<template>

  <!-- 抠像FPS显示已移除 -->

  <div :class="channel.homeClassName()"
       style="overflow: hidden; background-color:#ffeedd; position: absolute;background-size:100% 100%;background-repeat:no-repeat;"
       :style="{backgroundImage:`url(${channel.bgImg('qqs')})`,
         left:surface.left+'px', top:surface.top+'px', width:surface.width+'px', height:surface.height+'px',
         justifyContent:'center', alignItems:'center', display:'flex'}">

    <!-- 水印 -->
    <!-- div v-if="watermark" class="watermark"></div-->
    <Watermark v-if="watermark" :text="watermark"/>

    <!-- 预置的一些音频播放器 -->
    <div ref="hiddenContainer" id="hiddenContainer" style="position:fixed;left:0px;top:0px;width:1px;height:1px;overflow: hidden;">
      <audio v-for="idx in nStaticAudioPlayers" :id="'staticAudioPlayer-'+(idx-1)" v-bind:key="'sap'+idx"></audio>
    </div>

    <!-- 导播页面：普通版 v3(强国之路界面设计；英语界面设计02) -->
    <div v-if="!triggeredByUser && !bShowAuthorizationPage" style="width:100%; height:100%; position: absolute">
      <div v-if="surface.bLand" style="width:100%; height:100%; display:flex; justify-content:center; align-Items:center;">
        <div v-if="lesson&&(bDownloadingResources||bPreloadingResources)" style="display:flex; flex-direction:column; align-items:center;margin-top: -100px;">
          <div :style="channel.resourceLoadingStyle(surface.bLand)">{{ $t(bDownloadingResources ? 'loading.downloading_resources' : 'loading.loading_resources') }}({{nResourcesDone}}/{{nResourcesTotal}})</div>
          <div :style="{...channel.resourceLoadingStyle(surface.bLand), fontSize:'clamp(10px, 2vw, 14px)', marginTop:'30px', opacity:'0.8', whiteSpace:'nowrap'}">{{ $t('loading.tip_quiet_env') }}</div>
        </div>
        <img v-if="!(bDownloadingResources||bPreloadingResources)" :src="channel.navEnterLessonAutoImg()" style="width: 15%; margin: 8%; z-index: 2; cursor:pointer;" v-on:click="showAuthorizationPage(false)">
        <img v-if="!(bDownloadingResources||bPreloadingResources)" :src="channel.navEnterLessonStepImg()" style="width: 15%; margin: 8%; z-index: 2; cursor:pointer;" v-on:click="showAuthorizationPage(true)">
        <!-- img v-if="![208,209].includes(queries.lessonId)" :src="channel.navCopyRightImg()" style="width: 30%; top:92%;z-index: 2;position: absolute; " -->
        <!-- AI声明文字 -->
        <div style="position: absolute; left: 2%; bottom: 2%; z-index: 2; font-size: 0.8em; opacity: 0.7;color: #C3A281;">{{ $t('course.disclaimer') }}</div>
      </div>
      <div v-else style="width:100%; height:100%;">
        <div v-if="lesson&&(bDownloadingResources||bPreloadingResources)" style="display:flex; flex-direction:column; align-items:center; position:absolute; left:50%; top:50%; transform:translate(-50%, -50%);">
          <div :style="channel.resourceLoadingStyle(surface.bLand)">{{ $t(bDownloadingResources ? 'loading.downloading_resources' : 'loading.loading_resources') }}({{nResourcesDone}}/{{nResourcesTotal}})</div>
          <div :style="{...channel.resourceLoadingStyle(surface.bLand), fontSize:'clamp(10px, 3vw, 14px)', marginTop:'30px', opacity:'0.8', whiteSpace:'nowrap'}">{{ $t('loading.tip_quiet_env') }}</div>
        </div>
        <img src="@/assets/v2/nav_bg_port.jpg" style="width: 100%; height: 100%; z-index: 1; position: absolute">
        <div v-if="!(bDownloadingResources||bPreloadingResources)" style="z-index: 2; left: 25%; top: 25%; width: 50%; height: 50%; position: absolute; text-align: center;">
          <img src="@/assets/v2/nav_btn_play_auto.png" style="width: 80%; margin: 5%; cursor:pointer;" v-on:click="showAuthorizationPage(false)">
          <img src="@/assets/v2/nav_btn_play_manu.png" style="width: 50%; margin: 5%; cursor:pointer;" v-on:click="showAuthorizationPage(true)">
        </div>
        <!-- img v-if="![208,209].includes(queries.lessonId)" src="@/assets/v2/nav_tech_support.png" style="width: 40%; left: 30%; top:95%;z-index: 2;position: absolute;" -->
        <!-- AI声明文字 -->
        <div style="position: absolute; left: 2%; bottom: 2%; z-index: 2; font-size: 0.8em; opacity: 0.7;color: #C3A281;">{{ $t('course.disclaimer') }}</div>
      </div>
      <div v-if="hasNativeApi() && !(bDownloadingResources||bPreloadingResources)"
           style="position: absolute; left: 40%; bottom: 10%; width: 20%; height: 10%;
                  display: flex; justify-content: center; align-items: center">
        <div style="position: absolute; left: 0%; top: 0%; width: 100%; height: 60%;
                  border-color: #121212; background-color: #2c3e50; border-radius: 5px; border-width: 1px; border-style: solid;
                  box-shadow: #df1212; color: #df1212; cursor: pointer;
                  display: flex; justify-content: center; align-items: center" v-on:click="onClickLessonRecording()">
          开始录制课程
        </div>
        <div style="position: absolute; left: 0%; top: 80%; width: 100%; height: 35%;
                  border-color: #121212; border-radius: 5px; border-width: 1px; border-style: solid;
                  box-shadow: #df1212; color: #df1212; cursor: pointer;
                  display: flex; justify-content: center; align-items: center" v-on:click="backToRecordMainWindow()">
          返回主页面
        </div>
      </div>
    </div>

    <!-- 权限授权页面 -->
    <div v-if="bShowAuthorizationPage" 
         style="width:100%; height:100%; position: absolute; z-index: 10; background-size:100% 100%; background-repeat:no-repeat;"
         :style="{backgroundImage:`url(${channel.bgImg('qqs')})`}">
      <div style="width:100%; height:100%; display:flex; flex-direction:column; justify-content:center; align-items:center; padding: 20px; box-sizing: border-box;">
        <!-- 标题 -->
        <div style="margin-bottom: 2vh; text-align: center;">
          <div style="font-size: clamp(20px, 4vw, 28px); font-weight: bold; color: #734719; margin-bottom: 1vh;">{{ $t('authorization.tip_title') }}</div>
          <div style="font-size: clamp(12px, 2.5vw, 16px); color: #8B6914; opacity: 0.8;">{{ $t('authorization.tip_body') }}</div>
          <div v-if="isIPhone || isAndroid" style="font-size: clamp(12px, 2.5vw, 16px); color: #8B6914; opacity: 0.8; margin-top: 5px;">{{ $t('authorization.tip_landscape') }}</div>
        </div>
        
        <!-- 权限项容器 -->
        <!-- 暂时注释掉权限授权功能
        <div style="display: flex; flex-direction: column; gap: 1.5vh; margin-bottom: 2vh; width: min(90vw, 400px); max-width: 90vw;">
          麦克风权限
          <div style="background-color: rgba(236, 226, 217, 0.9); padding: min(3vw, 20px); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; border: 2px solid transparent;"
               :style="{ borderColor: permissionStates.microphone === 'granted' ? '#4CAF50' : permissionStates.microphone === 'denied' ? '#F44336' : 'transparent' }">
            <div style="display: flex; align-items: center; gap: min(2vw, 15px);">
              <div style="width: clamp(30px, 6vw, 40px); height: clamp(30px, 6vw, 40px); border-radius: 50%; background-color: #C3A281; display: flex; align-items: center; justify-content: center; color: white; font-size: clamp(14px, 3vw, 18px);">🎤</div>
              <div>
                <div style="color: #734719; font-size: clamp(14px, 2.8vw, 16px); font-weight: 500;">麦克风权限</div>
                <div style="color: #8B6914; font-size: clamp(11px, 2.2vw, 14px); margin-top: 2px;">用于语音回答问题</div>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <div v-if="permissionStates.microphone === 'granted'" style="color: #4CAF50; font-size: clamp(11px, 2.2vw, 14px);">✓ 已授权</div>
              <div v-else-if="permissionStates.microphone === 'denied'" style="color: #F44336; font-size: clamp(11px, 2.2vw, 14px);">✗ 拒绝</div>
              <button v-if="permissionStates.microphone !== 'granted'" 
                      @click="requestMicrophonePermission" 
                      style="background-color: #C3A281; color: white; border: none; padding: clamp(6px, 1.5vw, 8px) clamp(10px, 2.5vw, 16px); border-radius: 6px; cursor: pointer; font-size: clamp(11px, 2.2vw, 14px);">
                {{ permissionStates.microphone === 'denied' ? '重新授权' : '授权' }}
              </button>
            </div>
          </div>
          
          摄像头权限
          <div style="background-color: rgba(236, 226, 217, 0.9); padding: min(3vw, 20px); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; border: 2px solid transparent;"
               :style="{ borderColor: permissionStates.camera === 'granted' ? '#4CAF50' : permissionStates.camera === 'denied' ? '#F44336' : 'transparent' }">
            <div style="display: flex; align-items: center; gap: min(2vw, 15px);">
              <div style="width: clamp(30px, 6vw, 40px); height: clamp(30px, 6vw, 40px); border-radius: 50%; background-color: #C3A281; display: flex; align-items: center; justify-content: center; color: white; font-size: clamp(14px, 3vw, 18px);">📹</div>
              <div>
                <div style="color: #734719; font-size: clamp(14px, 2.8vw, 16px); font-weight: 500;">摄像头权限</div>
                <div style="color: #8B6914; font-size: clamp(11px, 2.2vw, 14px); margin-top: 2px;">用于课程学习效果监测</div>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <div v-if="permissionStates.camera === 'granted'" style="color: #4CAF50; font-size: clamp(11px, 2.2vw, 14px);">✓ 已授权</div>
              <div v-else-if="permissionStates.camera === 'denied'" style="color: #F44336; font-size: clamp(11px, 2.2vw, 14px);">✗ 拒绝</div>
              <button v-if="permissionStates.camera !== 'granted'" 
                      @click="requestCameraPermission" 
                      style="background-color: #C3A281; color: white; border: none; padding: clamp(6px, 1.5vw, 8px) clamp(10px, 2.5vw, 16px); border-radius: 6px; cursor: pointer; font-size: clamp(11px, 2.2vw, 14px);">
                {{ permissionStates.camera === 'denied' ? '重新授权' : '授权' }}
              </button>
            </div>
          </div>
        </div>
        -->
        
        <!-- 开始学习按钮 -->
        <button @click="startLearning" 
                style="border: none; padding: clamp(12px, 3vw, 16px) clamp(32px, 8vw, 48px); border-radius: 8px; font-size: clamp(14px, 3vw, 18px); font-weight: 500; transition: all 0.3s; background-color: #C3A281; color: white; cursor: pointer;">
          {{ $t('common.start_learning') }}
        </button>
        
        <!-- 提示文字 -->
        <!-- 暂时注释掉权限提示
        <div style="margin-top: 1.5vh; text-align: center; color: #8B6914; font-size: clamp(11px, 2.2vw, 14px); opacity: 0.8;">
          需要授权所有权限后才能开始学习
        </div>
        -->
      </div>
    </div>

    <!-- 学生主动提问页面 V2(为国家开放大学领导做demo设计；英语界面设计02) -->
    <user_asking v-if="userAsking.bShowView && channel.getCode() !== 'chinese'" :asking-data="userAsking" :channel="channel" :main-obj="this"/>

    <!-- 中文提问弹窗组件 -->
    <ChineseAskingDialog v-if="userAsking.bShowView && channel.getCode() === 'chinese'" :asking-data="userAsking" :channel="channel" :main-obj="this"/>

    <!-- 中文老师提问弹窗组件 -->
    <TeacherAskingDialog v-if="teacherAsking.bShowView && channel.getCode() === 'chinese'" :teacher-asking-data="teacherAsking" :channel="channel" :main-obj="this" :is-streaming="isStreaming" @close="handleTeacherAskingClose"/>

    <!-- 被动测试页面-随堂测试 v3(强国之路界面设计) -->
    <div v-if="bShowUserAnsweringView && userAnsweringSource.length>0"
         class="userAnswer userAnswerAll">
      <img :src="channel.bgImg()" style="position:absolute;left:0%;top:0%;width:100%;height:100%">
      <div style="position:absolute;left:7%;width:86%;top:7%;height:86%;">
        <img :src="channel.userAnsContainerImg()" style="position: absolute;left: 0%;top:0%;width: 100%;height:100%;">
        <img :src="channel.userAnsContainerLogo()" class="userAnswerLogo" style="">
        <div style="position:absolute;color:#424242;width: 100%;text-align: center; top:14%; font-weight: 1000;">
          {{userAnsweringSourceIdx>=0?userAnsweringSource[userAnsweringSourceIdx].question:''}}
        </div>
        <div class="userAnsOptionContainer">
          <div id="answerOptionA" v-on:click="onUserClickAnsweringOption(1)" style="position:absolute;left:5%;top: 0%;width:90%;height:25%;cursor:pointer;background-size:100% 100%;background-repeat:no-repeat;" :style="{backgroundImage: `url(${channel.userAnsOptionItemBgImg()})`}"><div style="display:flex;justify-content:center;align-items:center;height:100%;position:absolute;top:0%;width:96%;left:2%;">{{userAnsweringSourceIdx>=0?userAnsweringSource[userAnsweringSourceIdx].optionA:''}}</div></div>
          <div id="answerOptionB" v-on:click="onUserClickAnsweringOption(2)" style="position:absolute;left:5%;top:25%;width:90%;height:25%;cursor:pointer;background-size:100% 100%;background-repeat:no-repeat;" :style="{backgroundImage: `url(${channel.userAnsOptionItemBgImg()})`}"><div style="display:flex;justify-content:center;align-items:center;height:100%;position:absolute;top:0%;width:96%;left:2%;">{{userAnsweringSourceIdx>=0?userAnsweringSource[userAnsweringSourceIdx].optionB:''}}</div></div>
          <div id="answerOptionC" v-on:click="onUserClickAnsweringOption(3)" style="position:absolute;left:5%;top:50%;width:90%;height:25%;cursor:pointer;background-size:100% 100%;background-repeat:no-repeat;" :style="{backgroundImage: `url(${channel.userAnsOptionItemBgImg()})`}"><div style="display:flex;justify-content:center;align-items:center;height:100%;position:absolute;top:0%;width:96%;left:2%;">{{userAnsweringSourceIdx>=0?userAnsweringSource[userAnsweringSourceIdx].optionC:''}}</div></div>
          <div id="answerOptionD" v-on:click="onUserClickAnsweringOption(4)" style="position:absolute;left:5%;top:75%;width:90%;height:25%;cursor:pointer;background-size:100% 100%;background-repeat:no-repeat;" :style="{backgroundImage: `url(${channel.userAnsOptionItemBgImg()})`}"><div style="display:flex;justify-content:center;align-items:center;height:100%;position:absolute;top:0%;width:96%;left:2%;">{{userAnsweringSourceIdx>=0?userAnsweringSource[userAnsweringSourceIdx].optionD:''}}</div></div>
        </div>
        <div class="userAnsButtonsContainerStyle" :style="channel.userAnsButtonsContainerStyle(surface.bLand)">
          <div v-if="userAnsweringSourceIdx>=0&&userAnsweringSourceIdx<userAnsweringSource.length-1"
               style="position:absolute;left:0%;width:40%;cursor: pointer;text-align:right;" v-on:click="onUserClickAnsweringNext()">下一题</div>
          <div style="position:absolute;left:60%;width:40%;cursor: pointer;text-align:left;" v-on:click="onUserClickAnsweringSkip()">跳过</div>
        </div>
      </div>
      <div v-if="bShowUserAnsweringStatView" style="position:absolute;left:0%;top:0%;width:100%;height:100%;display:flex;z-index:999;">
        <img src="@/assets/test2/stat.png" style="position:absolute;left:0%;top:0%;width:100%;height:100%">
        <div style="position:absolute;left:49.2%;top:48%;width:3%;text-align:center;">{{userAnsweringCorrects}}</div>
        <div class="answering-stat-ok-button"
             :style="channel.userAnsStatButtonStyle()"
             style="position:absolute;left:45%;width:10%;bottom:26%;height:7%;background-size:100% 100%;background-repeat:no-repeat;cursor:pointer;"
             v-on:click="onUserClickAnsweringClose()">
        </div>
      </div>
    </div>

    <!-- 老师主动提问页面，学生开放式回答，或者跟AI伴读抢答: V3=隐藏老师话术(强国之路界面设计)  -->
    <div v-if="teacherAsking.bShowView"
         ref="teacherAskingDragView"
         :style="channel.teacherAskTextStyleColor()"
         style="z-index:999;position:absolute;left:0%;top:0%;width:100%;height:100%;font-size:1.6vw;cursor:move"
         draggable="true"
         @mousedown="teacherAskingDragStart"
         @mousemove="teacherAskingDragMove"
         @mouseup="teacherAskingDragEnd"
         @dragstart="teacherAskingDragStart"
         @dragmove="teacherAskingDragMove"
         @dragend="teacherAskingDragEnd"
         @touchstart="teacherAskingDragStart"
         @touchmove="teacherAskingDragMove"
         @touchend="teacherAskingDragEnd"
    >

      <img my-name="AI同学形象" v-if="teacherAsking.currentAction.isPree"
           :src="teacherAsking.aiMateImgUrl"
           id="idTeacherAskingAiMate"
           :style="{position:'absolute', left:'12%', bottom:'15%', height:'28%', ...teacherAsking.drag.aiMateStyle}"
      />

      <!-- 数字人老师视频 - 双缓冲结构 -->
      <div v-if="teacherAsking.bShowTeacherVideo"
           id="idTeacherVideoContainer"
           style="position:absolute; left:0%; top:0%; height:100%; width:100%;">
        <video id="idTeacherVideoA"
               autoplay
               loop
               muted
               playsinline
               webkit-playsinline
               x5-playsinline
               x5-video-player-type="h5"
               :controls="false"
               style="position:absolute; top:0; left:0; width:100%; height:100%; opacity:1;"
        ></video>
        <video id="idTeacherVideoB"
               autoplay
               loop
               muted
               playsinline
               webkit-playsinline
               x5-playsinline
               x5-video-player-type="h5"
               :controls="false"
               style="position:absolute; top:0; left:0; width:100%; height:100%; opacity:0;"
        ></video>
      </div>

      <div my-name="学生输入" v-if="!teacherAsking.bShowAiAnswer && channel.getCode() !== 'chinese'"
           id="idTeacherAskingUserInput"
           style="position:absolute;width:60%;height:20%;background-size:100% 100%;background-repeat:no-repeat;"
           :style="{backgroundImage:`url(${channel.teacherAskInputBoxBgImg()})`,
            left:teacherAsking.currentAction.isPree?'25%':'20%', bottom:'15%',
            ...teacherAsking.drag.userInputStyle}"
      >

        <div my-name="学生回答框" style="position:absolute;width:94%;height:50%;left:3%;top:20%;overflow:hidden">
          <textarea class="my-textarea" id="teacherQaAnswerBox" rows="3"
                    :style="channel.teacherAskTextStyleColor()"
                    style="position:absolute;width:98%;height:92%;left:1%;top:3%;font-size:1.6vw;"
                    v-model="teacherAsking.currentAction.userAnswerText"></textarea>
          <div class="my-textarea" id="taDisplayAudioText" v-if="teacherAsking.bShowAudioText"
               :style="channel.teacherAskTextStyleColor()"
               style="position:absolute;width:98%;height:98%;left:1%;top:1%;font-size:1.6vw;overflow-y: scroll;"
          >
            <MarkMathRenderer :content="teacherAsking.displayAudioText"/>
          </div>
        </div>

        <div my-name="语音输入、选图按钮和发送按钮" style="position:absolute;width:90%;height:20%;left:5%;top:76%;">
          <template v-if="!teacherAsking.bAutoRecording">
            <img style="position: absolute; left:0%; width:16%; top:15%; cursor: pointer;"
                 :src="teacherAsking.bAutoVoice?channel.teacherAskAutoVoiceImgChecked():channel.teacherAskAutoVoiceImgUnchecked()"
                 v-on:click="teacherAsking.bAutoVoice=!teacherAsking.bAutoVoice">
            <button style="position: absolute; left:18%; top:12%; width:14%;" v-if="!bAudioRecording" class="ans-btn2" :style="{backgroundImage:`url(${channel.userAskBtnVoiceInputBgImg()})`}" v-on:click="onUserClickAudioInputForTeacherAsking()"></button>
            <button style="position: absolute; left:18%; top:12%; width:14%;" v-else class="ans-btn2" :style="{backgroundImage:`url(${channel.userAskBtnVoiceInputEndBgImg()})`}" v-on:click="onUserClickAudioInputForTeacherAsking()">
              <div style="position:absolute;right:0%;top:2%;width:40%;height:98%;background-color:#2c3e5088;border-radius:100px;color:red;font-weight:bolder;display:flex;justify-content:center;align-items: center; ">
                {{Math.floor(audioRecorderSeconds)}}
              </div>
            </button>
          </template>
          <button my-name="选择附图" style="position: absolute; top:12%; width:14%;" class="ans-btn2"
                  :style="{backgroundImage:`url(${channel.userAskBtnChoosePhotoBgImg(1)})`, left: teacherAsking.bAutoRecording?'0%':'35%'}"
                  v-on:click="teacherAsking.bShowImageChooser=true"></button>
          <image-chooser v-if="teacherAsking.bShowImageChooser" @close="teacherAsking.bShowImageChooser=false" @chosen="onTeackerAskingImageChosen"/>
          <template v-if="teacherAsking.photoBase64Data">
            <button my-name="查看附图" style="position: absolute; top:12%; width:8%;" class="ans-btn2"
                    :style="{backgroundImage:`url(${channel.userAskBtnChoosePhotoBgImg(2)})`, left: teacherAsking.bAutoRecording?'15%':'50%'}"
                    v-on:click="showImgUrl=teacherAsking.photoUrl"></button>
            <button my-name="移除附图" style="position: absolute; top:12%; width:8%;" class="ans-btn2"
                    :style="{backgroundImage:`url(${channel.userAskBtnChoosePhotoBgImg(3)})`, left: teacherAsking.bAutoRecording?'24%':'59%'}"
                    v-on:click="onUserClickClearPhotoForTeacherAsking"></button>
          </template>
          <button my-name="确认输入" id="idTeacherAskingBtnSend" style="position: absolute; right:0%; top:12%; width:14%;" class="ans-btn2"
                  :style="{backgroundImage:`url(${channel.userAskBtnVoiceSendBgImg(true)})`}"
                  v-on:click="onUserClickSendAnswerForTeacherAsking()"></button>
        </div>

        <div my-name="倒计时" v-if="teacherAsking.countDownText" style="position:absolute;right:6%;top:1%;width:10%;height:13%;">
          <img :src="channel.teacherAskCountDownClockGifImg()" style="position:absolute;left:0%;top:0%;height:100%;">
          <span style="position:absolute;height:100%;right:0%;font-size:small">{{teacherAsking.countDownText}}</span>
        </div>

        <div my-name="老师提问板书" v-if="teacherAsking.bShowBoard && channel.getCode() !== 'chinese'"
             style="position: absolute; left:0%;top:-200%;width:100%;height:200%;background-size: 100% 100%;
                background-repeat: no-repeat; "
             :style="{backgroundImage:`url(${require('@/assets/teacher_ask_blackboard.png')})`}">
          <div class="my-content-div teacherAskingBoard" id="taDisplayBoardText"
               style="position: relative; left:3%; top:10%; width:96%; height:80%;overflow-y: scroll;">
            <MarkMathRenderer :content="teacherAsking.displayBoardText"/>
          </div>
        </div>
        <button my-name="显示和隐藏板书按钮" v-if="channel.getCode() !== 'chinese'"
                style="position: absolute; left:42%;top:0%;width:16%;height:20%;background-size: 100% 100%;background-repeat: no-repeat;"
                :style="{backgroundImage:teacherAsking.bShowBoard?`url(${require('@/assets/teacher_ask_hide_blackboard.png')})`:`url(${require('@/assets/teacher_ask_show_blackboard.png')})`}"
                v-on:click="teacherAsking.bShowBoard=!teacherAsking.bShowBoard"
        />
      </div>

      <div my-name="AI同学抢答框" v-if="teacherAsking.bShowAiAnswer"
           id="idTeacherAskingAiAnswer"
           style="position:absolute;width:60%;height:20%;background-size:100% 100%;background-repeat:no-repeat;overflow:hidden;z-index:777;"
           :style="{backgroundImage:`url(${channel.teacherAskAiMateInputBoxBgImg()})`, left:'25%', bottom:'15%', ...teacherAsking.drag.aiAnswerStyle}">
        <div style="position:absolute;width:94%;height:60%;left:3%;top:20%;overflow:hidden">
          <textarea class="my-textarea" rows="3"
                    :style="channel.teacherAskTextStyleColor()"
                    style="position:absolute;width:98%;height:90%;left:1%;top:3%;font-size:1.6vw;"
                    v-model="teacherAsking.aiAnswerText"></textarea>
        </div>
      </div>
    </div>

    <!-- 口语(语音)判分页面 -->
    <div v-if="oralScoring.bShowView"
         style="z-index:999;position:absolute;left:0%;top:0%;width:100%;height:100%">
      <img :src="channel.bgImg()" style="position:absolute;left:0%;top:0%;width:100%;height:100%">
      <img my-name="AI同学形象" v-if="oralScoring.currentAction.isPree && !oralScoring.bShowDetails"
           :src="oralScoring.aiMateImgUrl"
           style="position:absolute;left:12%;bottom:15%;height:28%;z-index:1"/>
      <div style="position:absolute;left:7%;width:86%;top:7%;height:86%;">
        <img :src="channel.oralScoringContainerImg()" style="position: absolute;left:0%;top:0%;width:100%;height:100%;">
        <div style="font-weight:bolder;font-size:x-large;position:absolute;left:10%;top:7%;width:80%;height:25%;background-size:100% 100%;background-repeat:no-repeat;display:flex;align-items:center;justify-content:center;color:#eeeeee"
             :style="{backgroundImage:`url(${channel.oralScoringQuesTextBgImg()})`}"
        >{{oralScoring.currentAction.identifyText}}</div>
        <div v-if="!oralScoring.bShowDetails" style="position:absolute;left:47.5%;top:32%">{{oralScoring.countDownText}}</div>
        <img id="idOralScoringMicImg"
             v-if="!oralScoring.bShowDetails"
             :src="oralScoring.micStat==oralScoringConst.MIC_STAT_BEFORE ? channel.oralScoringMicBeforeImg() :
                  oralScoring.micStat==oralScoringConst.MIC_STAT_RUNNING ? channel.oralScoringMicRunningImg() :
                  channel.oralScoringMicAfterImg()"
             v-on:click="oralScoring.micStat==oralScoringConst.MIC_STAT_AFTER?'':onUserClickAudioInputForOralScoring()"
             style="position:absolute;left:37%;bottom:18%;width:26%;"
             :style="{cursor:oralScoring.micStat==oralScoringConst.MIC_STAT_AFTER?'':'pointer'}">
        <div v-if="!oralScoring.bShowDetails" style="position:absolute;bottom:10%;width:100%;height:8%;text-align:center;font-size:large;font-weight:bolder">{{oralScoring.audioInputNotice}}</div>
      </div>
      <div v-if="oralScoring.bShowResult && !oralScoring.bShowDetails" style="position:absolute;left:0%;top:0%;width:100%;height:100%">
        <img src="@/assets/英语界面设计02/系统界面/口语判分/评分底图.png" style="position:absolute;left:0%;top:0%;width:100%;height:100%">
        <img v-for="i in oralScoring.overallStars"
             src="@/assets/英语界面设计02/系统界面/口语判分/五星.png"
             :key="i"
             style="position:absolute; top:59%; width:8%"
             :style="{left:(i*9.12+27.5)+'%'}">
        <div style="cursor: pointer;position:absolute;left: 40%;top:83%; width:20%;height:10%;" v-on:click="oralScoring.bShowDetails=true"></div>
      </div>
      <div v-if="oralScoring.bShowDetails"
           class="my-summary-div"
           style="position:absolute;left:25%;top:40%;width:50%;height:43%;overflow-y:scroll;">
        <table v-for="(sent,sIdx) in oralScoring.resultData.sentences" :key="'sent'+sIdx" style="margin-left:10px;margin-right:10px;">
          <tr><td colspan="2">{{sent.content}}</td></tr>
          <tr v-for="(word,wIdx) in sent.words" :key="'sent'+sIdx+'word'+wIdx">
            <td>{{word.content}}</td>
            <td v-if="oralScoring.resultData.lan==='en'">{{Math.floor(word.total_score*10)}}</td>
            <td v-if="oralScoring.resultData.lan==='cn'">{{word.dp_message_exp}}</td>
          </tr>
          <tr>
            <td>total score</td>
            <td v-if="oralScoring.resultData.lan==='en'">{{Math.floor(sent.total_score*10)}}</td>
            <td v-if="oralScoring.resultData.lan==='cn'">{{Math.floor(sent.total_score)}}</td>
          </tr>
        </table>
      </div>
      <img src="@/assets/英语界面设计02/系统界面/口语判分/exit.png" style="position:absolute;left:78%;top:75%;width:10%;cursor:pointer;"
           v-on:click="onUserClickExitOralScoring()">
    </div>

    <!-- 播放页面 -->
    <div class="scene" id="sceneContainer" v-if="bPlayingScript"
         style="position: absolute; width: 100%; height: 100%; background-size: cover"
         :style="{backgroundImage: currentScene.background ? 'url('+currentScene.background.url+')' : '', }">
      <!-- :style="channel.userCameraViewStyle()" -->
      <video v-if="bCheckboxCamera" ref="userCameraView" autoplay
             playsinline
             webkit-playsinline
             x5-playsinline
             x5-video-player-type="h5"
             :controls="false"
             style="position:absolute; cursor: move; background-color: black;"
             :style="cameraViewStyle"
             draggable="true"
             @mousedown="cameraDragStart"
             @mousemove="cameraDragMove"
             @mouseup="cameraDragEnd"
             @dragstart="cameraDragStart"
             @dragmove="cameraDragMove"
             @dragend="cameraDragEnd"
             @touchstart="cameraDragStart"
             @touchmove="cameraDragMove"
             @touchend="cameraDragEnd"
      ></video>
      <!-- 摄像头占位图 -->
      <div v-if="!bCheckboxCamera"
           class="camera-placeholder"
           style="position:absolute; display: flex; align-items: center; justify-content: center; background-color: #f0f0f0; border: 1px solid #ccc;"
           :style="cameraPlaceholderStyle">
        <img src="@/assets/全球说/camera_block.png" style="max-height: 63%;margin-top: -10px; object-fit: contain;" alt="摄像头占位图">
      </div>
      <canvas v-if="bCheckboxCamera" ref="userCameraCanvas" style="position: absolute; left:-500%; top:5%; width:10%;visibility: hidden"></canvas>
      <!-- button v-if="bCheckboxCamera" style="position: absolute; left:0%; top:0%; width:100px; height:50px; z-index: 9999" v-on:click="checkStudentStatus()">check</button -->
    </div>

    <!-- 设置弹窗 -->
    <div v-if="bShowOptionDialog" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; justify-content: center; align-items: center;">
      <div style="position: relative; width: 40%; aspect-ratio: 4/3; max-width: 400px; border-radius: 10px; background-size: 100% 100%; background-repeat: no-repeat; padding: 20px; display: flex; flex-direction: column; justify-content: space-between;" :style="{backgroundImage: `url(${require('@/assets/全球说/ques-bg.png')})`}">
        <!-- 标题 -->
        <div class="title-text"
             style="position: absolute; top: 20px; left: 50%; transform: translateX(-50%); font-size: 24px; color: #734719; background-size: contain; background-repeat: no-repeat; background-position: 4px bottom; z-index: 10; font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80%;"
             :style="{ backgroundImage: 'url(' + require('@/assets/全球说/zhuangshi.png') + ')' }">
          {{ $t('settings.title') }}
        </div>
        
        <!-- 设置项容器 -->
        <div style="flex: 1; display: flex; flex-direction: column; justify-content: center; gap: 15px; margin-top: 30px;">
          <!-- 录音设置项 -->
          <div style="background-color: #ece2d9; padding: 7px; border-radius: 8px; display: flex; justify-content: space-between; align-items: center;">
            <span style="color: #734719; font-size: 14px; flex: 1; min-width: 0; word-break: break-word; white-space: normal;">{{ $t('settings.auto_record_teacher_qa') }}</span>
            <div @click="toggleMicrophone" style="width: 60px; height: 30px; border-radius: 15px; cursor: pointer; position: relative; transition: all 0.3s; flex-shrink: 0;" :style="{backgroundColor: bCheckboxMicrophone ? '#c3a281' : '#dfcbb6'}">
              <div style="width: 26px; height: 26px; border-radius: 50%; background-color: white; position: absolute; top: 2px; transition: all 0.3s;" :style="{left: bCheckboxMicrophone ? '32px' : '2px'}"></div>
            </div>
          </div>
          <!-- 摄像头设置项 -->
          <div style="background-color: #ece2d9; padding: 7px; border-radius: 8px; display: flex; justify-content: space-between; align-items: center;">
            <span style="color: #734719; font-size: 14px; flex: 1; min-width: 0; word-break: break-word; white-space: normal;">{{ $t('settings.enable_camera') }}</span>
            <div @click="toggleCamera" style="width: 60px; height: 30px; border-radius: 15px; cursor: pointer; position: relative; transition: all 0.3s; flex-shrink: 0;" :style="{backgroundColor: bCheckboxCamera ? '#c3a281' : '#dfcbb6'}">
              <div style="width: 26px; height: 26px; border-radius: 50%; background-color: white; position: absolute; top: 2px; transition: all 0.3s;" :style="{left: bCheckboxCamera ? '32px' : '2px'}"></div>
            </div>
          </div>
          
        </div>
        <!-- 按钮容器 -->
         <div style="display: flex; justify-content: space-between; margin-top: 20px;">
           <img :src="require('@/assets/全球说/cancel.png')" @click="cancelOptionDialog" style="cursor: pointer; height: 40px;">
           <img :src="require('@/assets/全球说/save.png')" @click="saveOptionDialog" style="cursor: pointer; height: 40px;">
         </div>
      </div>
    </div>

    <!-- 内容摘要 V5: (强国之路界面设计) -->
    <div v-if="!bRecord&&bHaveSummary&&bPlayingScript&&channel.getCode()!=='chinese'" id="summaryContainer"
         :style="channel.summaryContainerStyle()"
         style="position: absolute; width:100%; height:100%;font-size:small;">
      <img :src="channel.summarySwitchButtonImg()" v-on:click="bShowSummary=!bShowSummary"
           style="position: absolute; right:0%;top:2%;z-index:8888;cursor:pointer;"
           :style="{width:(surface.bLand?'10%':'20%')}">
      <div v-if="bShowSummary" id="summaryContents"
           style="position:absolute;right:0%;z-index:7777; overflow: hidden;"
           :style="surface.bLand?{top:'8%', width:'45%', height:'90%'}:{top:'8%', width:'70%', height:'90%'}">
        <img :src="channel.summaryTextContainerBgImg()" style="position: absolute; left: 0%; top: 0%; width: 100%; height:100%;">
        <div style="position: absolute;left:6.5%;top:4.5%;width:87%;height:11%;display:flex;">
          <div v-for="(tab, idx) in channel.summaryTabs()" v-bind:key="idx"
               v-on:click="summary.currentTabIdx = idx"
               style="display:flex;flex-direction:column;align-items:center;padding:5px;width:25%;cursor:pointer;">
            <img style="height:100%;" :src="tab.icon0">
          </div>
        </div>
        <img style="position:absolute;left:6.5%;width:90%;top:15.5%;" myname="分隔线"
             :src="channel.summaryTabs()[summary.currentTabIdx].icon1">
        <div v-if="summary.currentTabIdx==0" class="my-summary-div"
             style="position: absolute;left:6.5%;top:17%;width:90%;height:78%;overflow-y: auto;max-height:100000%;">
          <div v-for="(section, idx) in summary.sections" v-bind:key="idx" style="margin: 10px 20px;">
            <h3>{{section.name}}</h3>
            <pre style="white-space: pre-wrap; word-wrap: break-word">{{section.summary}}</pre>
          </div>
        </div>
        <div v-else-if="[1,2,3].includes(summary.currentTabIdx)" class="my-summary-div"
             style="position: absolute;left:6.5%;top:17%;width:90%;height:78%;overflow-y: auto;max-height:100000%;">
          <div v-for="(question, idx) in summary.questions[summary.currentTabIdx-1]" v-bind:key="idx"
               style="margin: 10px 20px;display:flex;">
            <div style="width: 20%;font-weight: bolder">{{question.sectionName}}</div>
            <div style="width: 80%;">{{question.name}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 解除静音 -->
    <div v-if="mutedMediaElements.length>0"
         style="position: absolute; left:2px; top:2px; background-color: #df1212dd;z-index: 99999; cursor:pointer"
         v-on:click="onClickUserEnableSound()">
      <span>有部分音视频为静音，点击打开音量</span>
    </div>

    <!-- 你在认真听课吗，点我一下。为了交互一下获取播放权限 -->
    <div v-if="!this.bRecord&&bNeedInteractionWithUser"
         style="position:absolute;left:20%;top:20%;width:60%;height:30%;
         justify-content:center;display:flex;align-items:center;
         background-color:#ffeedd55;color:red;font-size:xx-large;font-weight:bolder;
         z-index: 9999;"
         v-on:click="onUserClickForInteraction()">
      你在认真听课吗，点我一下
    </div>

    <!-- 错误信息 -->
    <div v-if="bNetworkError"
         id="networkErrorView"
         style="position:fixed;left:25%;width:50%;top:45%;height:10%;color:#df1212;font-size:2.5vh;z-index:99999;
           background-color:#eeeeee;
           display:flex;justify-content:center; align-items:center;">
      <span>{{globalErrorMessage || $t('system.network_error')}}</span>
    </div>

    <!-- 场景切换目录列表弹窗 -->
    <div v-if="bShowListDialog" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; justify-content: center; align-items: center;">
      <div style="position: relative; width: 40%; aspect-ratio: 4/3; max-width: 400px; border-radius: 10px; background-size: 100% 100%; background-repeat: no-repeat; padding: 20px; display: flex; flex-direction: column; justify-content: space-between;" :style="{backgroundImage: `url(${require('@/assets/全球说/ques-bg.png')})`}">
        <!-- 标题 -->
        <div class="title-text">{{ $t('course.outline.title') }}</div>
        
        <!-- 关闭按钮 -->
        <img :src="require('@/assets/全球说/close.png')" style="position:absolute;top:-10px;right:-10px;width:32px;height:32px;cursor:pointer;" @click="bShowListDialog = false">

        <!-- 主要内容容器 -->
        <div style="flex: 1; display: flex; flex-direction: column; justify-content: flex-start; gap: 10px; margin-top: 50px; overflow-y: auto;">
          <!-- 场景切换目录列表 -->
          <div v-for="(scene, index) in sceneList" :key="index"
               style="background-color: #ece2d9; padding: 7px 15px; border-radius: 8px; cursor: pointer; font-size: 14px; display: flex; align-items: center; color: #734719;"
               @click="switchToScene(index)">
            <span style="width:8px;height:8px;background-color:#734719;border-radius:50%;margin-right:10px;"></span>
            {{scene.title || '未命名场景'}}
          </div>
        </div>
      </div>
    </div>

    <!-- 手写画板：高于老师提问侧拉/遮罩 (9999)，收起时用 DrawingBoard 内 pointer-events 避免挡侧拉 tab -->
    <div v-if="teacherAsking.bShowHandwritingBoard" style="position: fixed; z-index: 10100;">
      <DrawingBoard 
        :width="getAdaptedHandwritingBoardSize('width')"
        :height="getAdaptedHandwritingBoardSize('height')"
        :left="getAdaptedHandwritingBoardSize('left')"
        :top="getAdaptedHandwritingBoardSize('top')"
        :z-index="10100"
        :initial-background-image="teacherAsking.handwritingBoardConfig?.image || ''"
        :visible="true"
        @confirm-drawing="onHandwritingBoardConfirm"
        @visibility-changed="onHandwritingBoardVisibilityChanged"
        @image-updated="onHandwritingBoardImageUpdated"
      />
    </div>

    <!-- 画板组件 -->
    <div v-if="bShowDrawingBoard" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.8); z-index: 9999; display: flex; justify-content: center; align-items: center;">
      <div style="position: relative; width: 90%; height: 90%; background-color: white; border-radius: 10px; padding: 20px;">
        <!-- 关闭按钮 -->
        <button @click="bShowDrawingBoard = false" style="position: absolute; top: 10px; right: 10px; background: #ff4444; color: white; border: none; border-radius: 5px; padding: 5px 10px; cursor: pointer; z-index: 10;">
          关闭画板
        </button>
        
        <!-- 画板组件 -->
        <DrawingBoard style="width: 100%; height: 100%;" />
      </div>
    </div>

    <!-- 弹出图片  -->
    <div v-if="showImgUrl" style="z-index: 999; position: absolute; left:0%; top:0%; width:100%; height:100%; background-color: #121212; display: flex; justify-content: center; cursor:zoom-out;" v-on:click="showImgUrl=''">
      <img :src="showImgUrl" style="position:relative; top:0.1%;height:99.8%;max-width:99.8%"/>
    </div>

  </div>
</template>

<style lang="scss">
.title-text {
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  font-size: 24px;
  color: #734719;
  background-image: url('@/assets/全球说/zhuangshi.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 4px bottom;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.watermark-container {
  position: relative;
  height: 100%;
}

.watermark {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  font-size: 50px;
  color: rgba(200, 200, 200, 0.5); /* 调整颜色和透明度以保证内容可见 */
  z-index: 999999999; /* 确保水印在内容之下 */
  pointer-events: none; /* 关键属性，防止水印层阻挡鼠标事件 */
  background-image: url(@/assets/watermark.jpeg);
  opacity: 0.1;
  background-size: 15%;
}

.my-textarea {
  border-style:none;
  background-color:#00000000;
  outline:none;
  resize:none;
}
.my-textarea::-webkit-scrollbar{
  width:5px;
}
/* 添加轨道样式 */
#teacherQaAskingBox::-webkit-scrollbar-track {
  background-color: #e4e4e3;
  border-radius: 3px;
}
#teacherQaAnswerBox::-webkit-scrollbar-track {
  background-color: #ffffff;
  border-radius: 3px;
}
/* 添加滑块样式 */
.my-textarea::-webkit-scrollbar-thumb {
  background-color: #8c8c8c;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  border-radius: 3px;
}

/* 添加角度样式 */
.my-textarea::-webkit-scrollbar-corner {
  background-color: #f5f5f5;
}




//////
.my-summary-div::-webkit-scrollbar{
  width:3px;
}

/* 添加滑块样式 */
.my-summary-div::-webkit-scrollbar-thumb {
  background-color: #388ac1;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  border-radius: 3px;
}

/* 添加角度样式 */
.my-summary-div::-webkit-scrollbar-corner {
  background-color: #f5f5f5;
}
////




@keyframes fadein {
  0% {opacity: 0.4;}
  100% {opacity: 1;}
}
@keyframes fadeout {
  0% {opacity: 1;}
  100% {opacity: 0.4;}
}
@keyframes fadeoutin {
  50% {opacity: 0.4;}
  100% {opacity: 1;}
}
.fadein-box {
  animation: fadein 500ms linear;
}
.fadeout-box {
  animation: fadeout 80ms linear;
}
.fadeoutin-box {
  animation: fadeoutin 600ms linear;
}

.answering-stat-ok-button {
  background-image: url(@/assets/test2/ok0.png);
}
.answering-stat-ok-button:hover {
  background-image: url(@/assets/test2/ok1.png);
}

.ask2-btn {
//  margin:auto;
  width:15%;
  height:90%;
  font-size:1.6vw;
  border: none;
  background-color: transparent;
  background-size:100% 100%;
  background-repeat: no-repeat;
}
.ask2-btn-send             {background-image: url(@/assets/ask2/btn-send0.png);}
.ask2-btn-send:hover       {background-image: url(@/assets/ask2/btn-send1.png);}
.ask2-btn-end              {background-image: url(@/assets/ask2/btn-end0.png);}
.ask2-btn-end:hover        {background-image: url(@/assets/ask2/btn-end1.png);}
.ask2-btn-vinput           {background-image: url(@/assets/ask2/btn-vinput0.png);}
.ask2-btn-vinput:hover     {background-image: url(@/assets/ask2/btn-vinput1.png);}
.ask2-btn-vinput-end       {background-image: url(@/assets/ask2/btn-vinput-end0.png);}
.ask2-btn-vinput-end:hover {background-image: url(@/assets/ask2/btn-vinput-end1.png);}


.ans-btn {
  margin:auto;
  width:20%;
  height:90%;
  font-size:1.6vw;
  border: none;
  cursor: pointer;
  background-color: transparent;
  background-size:100% 100%;
  background-repeat: no-repeat;
}
.ans-btn-send             {background-image: url(@/assets/teacher-asking/确认输入.png);}
.ans-btn-send:hover       {background-image: url(@/assets/teacher-asking/确认输入-点击.png);}
.ans-btn-vinput           {background-image: url(@/assets/teacher-asking/语音输入等待.gif);}
.ans-btn-vinput:hover     {background-image: url(@/assets/teacher-asking/语音输入-点击.png);}
.ans-btn-vinput-end       {background-image: url(@/assets/teacher-asking/结束录音.gif);}
.ans-btn-vinput-end:hover {background-image: url(@/assets/teacher-asking/结束录音-点击.png);}
.ans-btn-send-wait-response {background-image: url(@/assets/teacher-asking/等待回复.gif);}

.ans-btn2 {
  margin:auto;
  width:15%;
  height:90%;
  font-size:1.6vw;
  border: none;
  cursor: pointer;
  background-color: transparent;
  background-size:100% 100%;
  background-repeat: no-repeat;
}
.ans-btn2-send               {background-image: url(@/assets/强国之路界面设计/提问页面/确认输入.png);}
.ans-btn2-send:hover         {background-image: url(@/assets/强国之路界面设计/提问页面/确认输入.png);}
.ans-btn2-vinput             {background-image: url(@/assets/强国之路界面设计/提问页面/正在输入动图.gif);}
.ans-btn2-vinput:hover       {background-image: url(@/assets/强国之路界面设计/提问页面/语音输入.png);}
.ans-btn2-vinput-end         {background-image: url(@/assets/强国之路界面设计/提问页面/结束录音.png);}
.ans-btn2-vinput-end:hover   {background-image: url(@/assets/强国之路界面设计/提问页面/结束录音.png);}
.ans-btn2-send-wait-response {background-image: url(@/assets/teacher-asking/等待回复.gif);} //{background-image: url(@/assets/强国之路界面设计/提问页面/等待回复.gif);}

.my-content-div::-webkit-scrollbar{
  width:3px;
}

/* 添加滑块样式 */
.my-content-div::-webkit-scrollbar-thumb {
  background-color: rgb(251,250,231);
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, .3);
  border-radius: 2px;
}

/* 添加角度样式 */
.my-content-div::-webkit-scrollbar-corner {
  background-color: #f5f5f5;
}

</style>

<script>
// @ is an alias to /src
import '@/util/channel.css';
import {convertCamelToKebab, sleep} from '@/util/util.js';
import {
  invokeLessonPlayerWebApi,
  invokeLessonPlayerWebFormApi,
  invokeLessonPlayerStreamWebApi,
  createQaDialogue
} from '@/util/readapi.js'
import {nextTick} from "vue";
import {Channel} from '@/util/channel';
import '@/util/HZRecorder';
import MarkMathRenderer from "@/components/MarkMathRenderer.vue";
import {marked} from "marked";

import user_asking from "@/views/user_asking/userAsking2.vue";
import ChineseAskingDialog from "@/components/ChineseAskingDialog.vue";
import TeacherAskingDialog from "@/components/TeacherAskingDialog.vue";
import html2canvas from "html2canvas";

import Watermark from "@/components/Watermark.vue";
import ImageChooser from "@/components/ImageChooser.vue";
import DrawingBoard from "@/components/DrawingBoard.vue";

import IOSAudioHelper from '@/util/IOSAudioHelper';

export default {
  name: 'HomeView',

  components: {
    Watermark,
    MarkMathRenderer,
    user_asking,
    ChineseAskingDialog,
    TeacherAskingDialog,
    ImageChooser,
    DrawingBoard
  },
  

  data() {
    return {
      channel: new Channel(),
      isIPhone: window.navigator.userAgent.indexOf('iPhone') > 0,
      isAndroid: window.navigator.userAgent.indexOf('Android') > 0,
      isWindows: window.navigator.userAgent.indexOf('Windows') > 0,
      isWeiXing: window.navigator.userAgent.indexOf('MicroMessenger') > 0,

//      bEnablePreloadResources: window.document.location.search.indexOf('preload=false') < 0, //普通视频是否需要抠图
//      bDownloadingResources: this.bEnablePreloadResources, //是否正在下载资源
//      bPreloadingResources: this.bEnablePreloadResources, //是否正在预加载资源

      bAutoPlay: window.document.location.search.indexOf('auto=true') > 0,
      bVideoHD: window.document.location.search.indexOf('hd=true') > 0,
      bRecord: window.document.location.search.indexOf('record=true') > 0,
      dstRecordMp4FileName: '',
      // bStatKeyingFPS和keyingFps变量已移除，不再需要抠像FPS统计

      watermark: '',

      bCheckboxMicrophone: true,
      bCheckboxCamera: true,
      cameraStream: null,
      
      // Authorization page state management
      bShowAuthorizationPage: false, // 控制权限授权页显示
      permissionStates: {
        microphone: 'pending', // 'pending', 'granted', 'denied'
        camera: 'pending'      // 'pending', 'granted', 'denied'
      },
      bStartButtonEnabled: false, // 开始学习按钮是否可用
      
      bShowOptionDialog: false, // 控制设置弹窗显示
      bShowListDialog: false, // 控制场景切换目录列表弹窗显示
      bShowDrawingBoard: false, // 控制画板显示
      sceneList: [], // 场景列表数据
      cameraDrag: {
        isDragging: false,
        diffX: 0,
        diffY: 0,
        style: {
//          right:'3.3%', top:'13%', height:'19%', width:'19%',
          right:'3.3%', top:'57%', height:'20%', width:'19.4%',
//          left: '76.44%', top: '28.4%', width: '12.43%', height: '16.57%',
          backgroundColor:'#E3D0BF', padding:'1px', borderRadius:'5px'
        }
      },

      nStaticAudioPlayers: 10,
      staticAudioPlayers: [],

      bDownloadingResources: true, //是否正在下载资源
      bPreloadingResources: true, //是否正在预加载资源

      bNeedInteractionWithUser: false,
      needInteractionPlayer: null,

      nResourcesTotal:0, //待下载资源总数
      nResourcesDone:0, //已下载资源数
      // bVideoKeying变量已移除，不再需要抠图功能
      // bEnableWasm变量已移除，不再需要wasm抠图功能
      // bRotated: false, //是否已转屏 - 已废弃，使用原生旋转
      bMute: false, //是否静音播放
      bStepByStep: false, //是否分步播放
      bEnterNextStep: true, //分步播放时，要进入下一场景，还是要跳过
      delayMultiplier: 1000, //Action delay的单位（毫秒）
      triggeredByUser: false, //用户是否点击过播放按钮
      bNetworkError: false,
      globalErrorMessage: '',
      queries: {
        userId: 0,
        pid: '',
        lessonId: 0,
        token: ''
      },
      surface: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bLand: true,
      },
      lesson: null,
      liveWindow: null, // 数字人显示窗口配置
      cameraPosition: null, // 摄像头位置配置
      cameraMonitoring: null, // 摄像头人像监控配置
      url2blobMap: {},
      mediasForRequestGesture:[],
      bPlayingScript: false,
      isStreaming: false, // 标记是否正在进行推流，防止推流过程中切换到待机状态
       streamAbortController: null, // 用于中断流请求的控制器
       streamRunningFlag: null, // 用于控制流是否继续运行的标志函数
      currentScene: null,
      currentSceneId: -1,
      currentGroupId: -1,
      exitElementsInCurrentScene: [], //[...elementInfo...]
      exitElementsInGroups      : {}, //{groupId : [...elementInfo...], }
      exitElementsOnTimespan    : [], //[...elementInfo...]
      backgroundAudio : null, //整个剧本只允许有一个背景音频在播放
      mutedMediaElements: [], //因需要用户gesture而静音播放的audio或video
      mediaCache: {}, //{elementId:element, ...}
      textCache : {}, //{elementId:fontSizeRatio, ...}
      blackboardCache: {}, //{elementId:{}, ...}
      playingMedias: {}, //{elementId:AudioOrVideo, ...}
      wasmInstance: null, //wasm实例
      wasmBufferBase: 0,
      wasmPixelOffset: 0,

      showImgUrl: '',

      pendingNextAskScreenshot: '',

      bNeedAudioRecorder: false,
      audioRecorder: null,
      audioRecorderTimer: null,
      audioRecorderSeconds: '',

      // 音量阈值控制配置
      audioVolumeThreshold: 0.022387, // 音量阈值 (对应 dBFS: -33)，低于此值的音频将被过滤
      audioVolumeDetectionEnabled: true, // 是否启用音量检测过滤
      audioVolumeSmoothingFactor: 0.8, // 音量平滑因子，用于减少音量波动（范围0-1）

      bShowUserAnsweringView: false,//是否需要显示用户被动回答窗口：系统主动测试，用户做选择题
      userAnsweringViewWidth:0,    //用户被动回答窗口宽
      userAnsweringViewHeight:0,   //用户被动回答窗口高
      userAnsweringSourceIdx: -1,
      userAnsweringSourceLastClickedIdx: -1,
      userAnsweringSource: [],
      userAnsweringOptionSizes: {
        a: '1.5vw', //:'2vh',
        b: '1.5vw', //:'2vh',
        c: '1.5vw', //:'2vh',
        d: '1.5vw', //:'2vh',
      },
      currentUserAnsweringAction: null, //当前场景下的[用户被动回答的action]
      bShowUserAnsweringStatView: false, //是否需要显示用户被动问答后的统计窗口
      userAnsweringCorrects: 0,

      bAudioRecording : false, //是否正在语音输入

      userAsking: {
        userQuestionFlag: false, //记录当前场景下用户是否想主动提问
        currentAction   : null,  //记录当前的用户主动提问的Action(actionType='ques')
        bShowView       : false, //是否需要显示用户主动提问窗口
        qaAutoVoice     : true,  //语音输入是否自动提问(不经过文本框=>发送)
        qaText          : '', //学生提的问题
        qaAnswer        : '', //教师返回的口语化文本，附带音频地址
        markdown        : '', //教师返回的板书文本，markdown格式
        qaVideo         : null, //用户主动提问时的数字人视频播放器
        qaIdleVideo     : null, //用户主动提问时的数字人待机视频播放器
        qaUsingVideoOrCartoon: false, //提问使用[true=视频数字人]还是[false=卡通数字人]
        bPlaying: true,
        lastAnswerPlayer: null,
        nMaxWords: 100, //最大输入的字（单词）数
        nWords: 0, //当前已输入的字（单词）数
        photoBase64Data: '', //用来显示选择的图片
      },

      teacherAsking: { //老师主动提问，学生开放式回答，或者跟AI伴读抢答
        bShowView    : false, //是否需要显示教师提问窗口：教师主动提问，学生开放式回答，也可能有AI同学抢答
        bShowBoard   : true, //是否需要显示板书
        bShowAudioText: false,//是否需要显示字幕
        displayBoardText: '',
        displayAudioText: '',
        bShowThinking: false, //是否需要显示教师正在思考学生的回答
        currentAction: null,
        bAutoRecording: true, //是否一打开就开始录音
        bAutoVoice   : true,  //语音输入是否自动确认(不经过文本框=>发送)
        bUserClickSendingButton: false, //学生是否在倒计时结束之前点击了确认按钮(仅bAutoRecording为true时起作用)
        bHaveAnswer  : false, //是否已经有人回答了问题：用户回答，或者AI抢答
        bShowAiAnswer: false, //是否显示AI抢答
        aiAnswerText : '',    //AI抢答时的显示文本
        countDownText: '',    //学生回答超时的倒计时文本
        bCountingDown: false, //是否需要倒计时
        aiMateImgUrl : '',
        bShowAnswer  : false,   //是否显示正确答案或者返回的点评内容
        answerText   : '',      //显示正确答案或者返回的点评内容
        bHandling    : false,   //当前是否正在处理学生或Ai同学的答案
        bExitDialogue: false,   //是否已经收到exitDialogue信号，用于控制学生输入框显示
        bShowImageChooser: false,
        photoUrl: '',
        photoBase64Data: '',
        bShowTeacherVideo: false, //是否显示数字人老师视频
        teacherVideoUrl: '',      //当前显示的数字人老师视频URL
        bTeacherSpeaking: false,  //数字人老师是否正在说话
        dialogueId: null,         //多轮对话ID，由create-qa-dialogue接口返回
        dialogueHistory: [],      //对话历史记录，用于追加新的对话内容
        countDownTimer: null,     //倒计时定时器
        // 手写画板相关属性
        bShowHandwritingBoard: false, //是否显示手写画板
        handwritingBoardConfig: null, //手写画板配置信息
        handwritingImage: '',         //手写画板绘制的图片
        isFirstRound: true,           //是否是第一轮问答
        drag: {
          isDragging: false,
          prevX: 0,
          prevY: 0,
          aiMateStyle:{},
          userInputStyle: {},
          aiAnswerStyle: {}
        }
      },

      // 场景切换时的下一场景视频信息
      nextSceneVideoInfo: null,

      oralScoringConst: {
        MIC_STAT_BEFORE : 0,
        MIC_STAT_RUNNING: 1,
        MIC_STAT_AFTER  : 2,
      },
      oralScoring: { //语音判分，前端流程跟“老师主动提问”相似
        bShowView    : false, //是否需要显示语音判分窗口
        bShowThinking: false, //是否需要显示教师正在思考学生的回答
        currentAction: null,

        bAutoVoice   : true,  //语音输入是否自动确认(不经过文本框=>发送)
        bHaveAnswer  : false, //是否已经有人回答了问题：用户回答，或者AI抢答
        bShowAiAnswer: false, //是否显示AI抢答
        aiAnswerText : '',    //AI抢答时的显示文本
        countDownText: '',    //学生回答超时的倒计时文本
        bCountingDown: false, //是否需要倒计时
        aiMateImgUrl : '',
        bShowAnswer  : false, //是否显示正确答案或者返回的点评内容
        answerText   : '',    //显示正确答案或者返回的点评内容
        bHandling    : false, //当前是否正在处理学生或Ai同学的答案

        micStat: 0, //this.oralScoringConst.MIC_STAT_BEFORE,
        audioInputNotice: '点击麦克风开始录音',

        bShowResult: false, //是否显示评分结果
        overallStars: 0,    //总评分星级 1~3
        bShowDetails: false,//是否显示评分的详细结果
        resultData: null,
        countDownTimer: null,     //倒计时定时器

        bPlaying: true,
        lastPlayer: null
      },

      bScriptEnded: false, //整个脚本是否播放完毕

      bHaveSummary: false, //课程是否含有内容提要
      bShowSummary: false, //是否显示内容提要
      summaryImageUrl: '',
      summary: {
        tabsBak: [
          {id: 'zhaiyao', label: '摘要', icon0: require('@/assets/summary/zhaiyao0.png'), icon1: require('@/assets/summary/zhaiyao1.png') },
          {id: 'gainian', label: '概念', icon0: require('@/assets/summary/gainian0.png'), icon1: require('@/assets/summary/gainian1.png') },
          {id: 'wenti'  , label: '问题', icon0: require('@/assets/summary/wenti0.png')  , icon1: require('@/assets/summary/wenti1.png')   },
          {id: 'kuozhan', label: '扩展', icon0: require('@/assets/summary/kuozhan0.png'), icon1: require('@/assets/summary/kuozhan1.png') },
        ],
        tabsBakV4: [
          {id: 'zhaiyao', label: '摘要', icon0: require('@/assets/summary-v4/zhaiyao0.png'), icon1: require('@/assets/summary-v4/zhaiyao1.png') },
          {id: 'gainian', label: '概念', icon0: require('@/assets/summary-v4/gainian0.png'), icon1: require('@/assets/summary-v4/gainian1.png') },
          {id: 'wenti'  , label: '问题', icon0: require('@/assets/summary-v4/wenti0.png')  , icon1: require('@/assets/summary-v4/wenti1.png')   },
          {id: 'kuozhan', label: '扩展', icon0: require('@/assets/summary-v4/kuozhan0.png'), icon1: require('@/assets/summary-v4/kuozhan1.png') },
        ],
//      tabs: this.channel.summaryTabs(),
        currentTabIdx: 0,
        sections: [],  // [ {title:'', content:''}, {}, {} ]
        questions: [], // [ [nouns], [basics], [extends] ]
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateSurfaceSize);
  },

  async mounted() {
    window.addEventListener('resize', this.calculateSurfaceSize);
    console.log('home view mounted()');
    if (this.isQqsContext()) this.applyQqsBranding();
    try { sessionStorage.clear(); console.log('🧹 已清理当前域名下的sessionStorage'); } catch (e) { console.warn('清理sessionStorage失败:', e); }
    try {
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        try {
          const w = iframe.contentWindow;
          if (w) w.postMessage({ type: 'CLEAR_STORAGE' }, '*');
        } catch (err) { console.warn('向已有iframe发送清理消息失败:', err); }
      });
    } catch (e) { console.warn('扫描iframe失败:', e); }
    const params = new URLSearchParams(window.location.search)
    const langParam = params.get('lang')
    const supported = ['zh','en','ar','es','it','ru','fr','ja','ko']
    const localeToUse = supported.includes(langParam) ? langParam : 'en'
    if (this.$i18n) {
      this.$i18n.locale = localeToUse
      document.documentElement.setAttribute('dir', localeToUse === 'ar' ? 'rtl' : 'ltr')
    }

    //从url获取参数：userId  pid  lessonId
    let search = window.document.location.search;
    console.log('mounted: search: ', search);
    let arr = search.split(/\?|&/g);
    console.log('mounted: arr: ', arr);
    let userId;
    for (let i in arr) {
      let s = arr[i];
      let pos = s.indexOf("=");
      if (pos > 0) {
        let k = s.substring(0, pos);
        let v = s.substring(pos + 1);
        if (k === 'userId') userId = parseInt(v);
        if (k == 'user_id') this.queries.userId = parseInt(v);
        if (k == 'pid') this.queries.pid = v;
        if (k == 'lessonId') this.queries.lessonId = parseInt(v);
        if (k == 'token') this.queries.token = v;
        if (k == 'watermark' && v && v.length > 0) {
          this.watermark = decodeURIComponent(v);
        }
      }
    }

    //特殊处理，兼容原有url格式，
    //  如 https://readapi.bluebirdabc.com/lessonplayer/index.html?userId=1111&pid=&lessonId=85
    //改为 https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=aif8j9q38t4q78y4&lessonId=85&user_id=32&token=aksdjfkajsdfjlsd
    if(!this.queries.pid && userId === 1111) {
      this.queries.pid = 'aif8j9q38t4q78y4';
      this.queries.userId = null;
      window.location.href = this.makeClearHref();
    }

    console.log('queries', this.queries);

    //save parameters and access-token
    this.handleParamsAndToken();

//    this.bHaveSummary = [94, 104, 106, 118, 119,120,121,122].includes(this.queries.lessonId);

    //监听页面大小变动，重新计算画面位置和大小
    window.onresize = () => {
      return (() => {
        this.calculateSurfaceSize();
      })();
    };

    //
    for(let sapIdx=0; sapIdx<this.nStaticAudioPlayers; sapIdx++) {
      let sapId = 'staticAudioPlayer-'+sapIdx;
      let sap = document.getElementById(sapId);
      this.staticAudioPlayers.push(sap);
    }

    //获取剧本
    await this.getLessonScript();
    if(!this.lesson) {
      return;
    }
    await this.getLessonSummarySections();
    await this.getLessonSummaryQuestions();

    this.bHaveSummary = this.checkHaveSummaryOrNot();
//    if(this.bHaveSummary) {
//      this.summaryImageUrl = '//static.bluebirdabc.com/lesson/summary/'+this.queries.lessonId+".png";
//    }

    //计算画面位置和大小
    this.calculateSurfaceSize();

    // 原生旋转模式：不再强制旋转body
    // 保持 resize 事件监听以更新布局


    //加载wasm
    if(this.bEnableWasm) {
      await (async () => {
        const keying_wasm_url = 'https://static.bluebirdabc.com/js/keying8.wasm';
        if(WebAssembly) {
          if(WebAssembly.instantiateStreaming) {
            const fetchPromise = fetch(keying_wasm_url);
            let instance = await WebAssembly.instantiateStreaming(fetchPromise);
            this.wasmInstance = instance.instance;
          } else {
            await this.loadWebAssembly(keying_wasm_url);
          }
        } else console.log("wasm not be supported")
        console.log('this.wasmInstance', this.wasmInstance);
        if(this.wasmInstance) {
          console.log('exports', this.wasmInstance.exports);
          this.wasmBufferBase  = this.wasmInstance.exports.memory.buffer;    // wasm模块的整个内存
          this.wasmPixelOffset = this.wasmInstance.exports.getMemoryOffset();// c代码中开辟的缓存的起始位置(= C_Pixel_Buffer = buffer+offset)
          let initParam = {beginH: 90, endH: 270, beginL: 0.2, beginS: 0.3 }
          this.wasmInstance.exports.initFlags(initParam.beginH, initParam.endH, initParam.beginL, initParam.beginS);
        }
      })();
    } else console.log('wasm disabled');

    //下载资源
    await this.downloadingResources();
    this.bDownloadingResources = false;
    console.log('downloadingResources finished');

    await this.preloadMediasOfLocalBlob();
    this.bPreloadingResources = false;
    console.log('preloadMedias finished');

    this.bNeedAudioRecorder = this.checkIfNeedAudioRecorder();

    if(this.bAutoPlay) {
      this.showAuthorizationPage(false);
    }
    
    // chinese渠道资源加载完成后自动进入播放
    if(this.channel.getCode() === 'chinese') {
      this.showAuthorizationPage(false);
    }
  },

  computed: {
    // 计算摄像头的样式，优先使用 cameraPosition，否则使用默认的 cameraDrag.style
    cameraViewStyle() {
      let baseStyle = {};
      
      let currentCameraPosition = this.getCurrentSceneCameraPosition();
      if (currentCameraPosition && this.lesson && this.lesson.resolution) {
        // 如果有 cameraPosition 配置，使用它来计算样式
        let cp = currentCameraPosition;
        let cpLeft = cp.left || cp.x || (cp.style && cp.style.left) || 0;
        let cpTop = cp.top || cp.y || (cp.style && cp.style.top) || 0;
        let cpWidth = cp.width || (cp.style && cp.style.width) || 100;
        let cpHeight = cp.height || (cp.style && cp.style.height) || 100;
        let cpZIndex = (cp.style && cp.style.zIndex) || 888; // 从配置中读取 zIndex，默认为 888

        // 转换为百分比坐标
        let leftPercent = (cpLeft / this.lesson.resolution.width) * 100;
        let topPercent = (cpTop / this.lesson.resolution.height) * 100;
        let widthPercent = (cpWidth / this.lesson.resolution.width) * 100;
        let heightPercent = (cpHeight / this.lesson.resolution.height) * 100;

        baseStyle = {
          ...this.cameraDrag.style,
          left: leftPercent + '%',
          top: topPercent + '%',
          width: widthPercent + '%',
          height: heightPercent + '%',
          right: 'auto', // 清除 right 属性，因为我们使用 left
          backgroundColor: 'black', // 为摄像头video设置黑色背景
          zIndex: cpZIndex // 使用配置中的 zIndex
        };
      } else {
        // 如果没有 cameraPosition 配置，使用默认的 cameraDrag.style
        baseStyle = {
          ...this.cameraDrag.style,
          backgroundColor: 'black', // 为摄像头video设置黑色背景
          zIndex: this.cameraDrag.style.zIndex || 888 // 使用默认的 zIndex
        };
      }

      // 如果页面已旋转，调整容器尺寸比例以适应旋转后的布局
      // if (this.bRotated) {
      //   // 获取原始的宽高比例（数值形式）
      //   const originalWidth = parseFloat(baseStyle.width) || 0;
      //   const originalHeight = parseFloat(baseStyle.height) || 0;
      //   const originalTop = parseFloat(baseStyle.top) || 0;
      //   const originalLeft = parseFloat(baseStyle.left) || 0;
        
      //   // 调整宽高比例：宽度变窄，高度变高，形成竖向布局
      //   // 计算新的宽高，保持面积大致相同但改变比例
      //   const newWidth = originalWidth * 0.75; // 宽度减少25%
      //   const newHeight = originalHeight * 1.25; // 高度增加25%
        
      //   // 微调位置以保持居中效果
      //   const leftAdjust = (originalWidth - newWidth) / 2;
      //   const topAdjust = (originalHeight - newHeight) / 2;
        
      //   baseStyle.width = newWidth + '%';
      //   baseStyle.height = newHeight + '%';
      //   baseStyle.left = (originalLeft + leftAdjust) + '%';
      //   baseStyle.top = (originalTop + topAdjust) + '%';
        
      //   // 同时旋转video元素，让人像头部朝向与页头保持一致
      //   const currentTransform = baseStyle.transform || '';
      //   baseStyle.transform = currentTransform + (currentTransform ? ' ' : '') + 'rotate(90deg)';
      //   baseStyle.transformOrigin = 'center center';
      // }

      return baseStyle;
    },
    
    // 摄像头占位图样式，保持原有背景色
    cameraPlaceholderStyle() {
      let baseStyle = {};
      
      let currentCameraPosition = this.getCurrentSceneCameraPosition();
      if (currentCameraPosition && this.lesson && this.lesson.resolution) {
        // 如果有 cameraPosition 配置，使用它来计算样式
        let cp = currentCameraPosition;
        let cpLeft = cp.left || cp.x || (cp.style && cp.style.left) || 0;
        let cpTop = cp.top || cp.y || (cp.style && cp.style.top) || 0;
        let cpWidth = cp.width || (cp.style && cp.style.width) || 100;
        let cpHeight = cp.height || (cp.style && cp.style.height) || 100;
        let cpZIndex = (cp.style && cp.style.zIndex) || 888; // 从配置中读取 zIndex，默认为 888

        // 转换为百分比坐标
        let leftPercent = (cpLeft / this.lesson.resolution.width) * 100;
        let topPercent = (cpTop / this.lesson.resolution.height) * 100;
        let widthPercent = (cpWidth / this.lesson.resolution.width) * 100;
        let heightPercent = (cpHeight / this.lesson.resolution.height) * 100;

        baseStyle = {
          ...this.cameraDrag.style,
          left: leftPercent + '%',
          top: topPercent + '%',
          width: widthPercent + '%',
          height: heightPercent + '%',
          right: 'auto', // 清除 right 属性，因为我们使用 left
          zIndex: cpZIndex // 使用配置中的 zIndex
        };
      } else {
        // 如果没有 cameraPosition 配置，使用默认的 cameraDrag.style
        baseStyle = {
          ...this.cameraDrag.style,
          zIndex: this.cameraDrag.style.zIndex || 888 // 使用默认的 zIndex
        };
      }

      // 如果页面已旋转，调整占位图容器尺寸比例以适应旋转后的布局
      // if (this.bRotated) {
      //   // 获取原始的宽高比例（数值形式）
      //   const originalWidth = parseFloat(baseStyle.width) || 0;
      //   const originalHeight = parseFloat(baseStyle.height) || 0;
      //   const originalTop = parseFloat(baseStyle.top) || 0;
      //   const originalLeft = parseFloat(baseStyle.left) || 0;
        
      //   // 调整宽高比例：宽度变窄，高度变高，形成竖向布局
      //   const newWidth = originalWidth * 0.75; // 宽度减少25%
      //   const newHeight = originalHeight * 1.25; // 高度增加25%
        
      //   // 微调位置以保持居中效果
      //   const leftAdjust = (originalWidth - newWidth) / 2;
      //   const topAdjust = (originalHeight - newHeight) / 2;
        
      //   baseStyle.width = newWidth + '%';
      //   baseStyle.height = newHeight + '%';
      //   baseStyle.left = (originalLeft + leftAdjust) + '%';
      //   baseStyle.top = (originalTop + topAdjust) + '%';
        
      //   // 同时旋转占位图，保持与video一致的视觉效果
      //   const currentTransform = baseStyle.transform || '';
      //   baseStyle.transform = currentTransform + (currentTransform ? ' ' : '') + 'rotate(90deg)';
      //   baseStyle.transformOrigin = 'center center';
      // }

      return baseStyle;
    }
  },

  methods: {

    applyQqsBranding: function() {
      document.title = '国际中文智能体';
      let favicon = document.querySelector("link[rel*='icon']");
      if (!favicon) { favicon = document.createElement('link'); favicon.rel = 'icon'; document.head.appendChild(favicon); }
      favicon.type = 'image/svg+xml';
      favicon.href = require('@/assets/logo.svg');
    },

    isQqsContext: function() {
      return window.location.pathname.includes('lessonplayer-qqs') ||
             window.location.hostname.includes('lessonplayer-qqs');
    },

    // 获取适配后的手写板尺寸
    getAdaptedHandwritingBoardSize(property) {
      const config = this.teacherAsking.handwritingBoardConfig;
      if (!config || !this.lesson) {
        // 默认值
        const defaults = { width: 800, height: 600, left: 100, top: 100 };
        return defaults[property] || 0;
      }

      const originalValue = config[property];
      if (originalValue === undefined || originalValue === null) {
        // 默认值
        const defaults = { width: 800, height: 600, left: 100, top: 100 };
        return defaults[property] || 0;
      }

      // 参考buildActionHtml方法的计算逻辑
      if (property === 'left') {
        // 按课程分辨率宽度计算百分比，然后转换为实际像素，并加上背景区域的偏移
        const percentage = (originalValue / this.lesson.resolution.width) * 100;
        return this.surface.left + (percentage / 100) * this.surface.width;
      } else if (property === 'top') {
        // 按课程分辨率高度计算百分比，然后转换为实际像素，并加上背景区域的偏移
        const percentage = (originalValue / this.lesson.resolution.height) * 100;
        return this.surface.top + (percentage / 100) * this.surface.height;
      } else if (property === 'width') {
        // 宽度只需要按比例缩放，不需要偏移
        const percentage = (originalValue / this.lesson.resolution.width) * 100;
        return (percentage / 100) * this.surface.width;
      } else if (property === 'height') {
        // 高度只需要按比例缩放，不需要偏移
        const percentage = (originalValue / this.lesson.resolution.height) * 100;
        return (percentage / 100) * this.surface.height;
      }

      return originalValue;
    },

    // 显示画板
    showDrawingBoard() {
      this.bShowDrawingBoard = true;
    },

    // 隐藏画板
    hideDrawingBoard() {
      this.bShowDrawingBoard = false;
    },

    // ========= 权限授权相关方法 =========
    
    // 请求麦克风权限
    async requestMicrophonePermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.permissionStates.microphone = 'granted';
        // 先停止媒体轨道（释放麦克风硬件），再恢复扬声器输出
        // 顺序不能颠倒：iOS 只在所有麦克风轨道停止后才会响应 audioSession 切换
        stream.getTracks().forEach(track => track.stop());
        // 稍作延迟，等待 iOS 完全释放音频会话后再切回扬声器
        setTimeout(() => {
          IOSAudioHelper.restoreAudioOutput();
        }, 300);
        this.updateStartButtonState();
      } catch (error) {
        this.permissionStates.microphone = 'denied';
        this.updateStartButtonState();
      }
    },

    // 请求摄像头权限
    async requestCameraPermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: { 
            width: { ideal: 320 }, 
            height: { ideal: 240 } 
          } 
        });
        this.permissionStates.camera = 'granted';
        // 停止媒体流，只是为了测试权限
        stream.getTracks().forEach(track => track.stop());
        this.updateStartButtonState();
      } catch (error) {
        this.permissionStates.camera = 'denied';
        this.updateStartButtonState();
      }
    },

    // 更新开始学习按钮状态
    updateStartButtonState() {
      this.bStartButtonEnabled = 
        this.permissionStates.microphone === 'granted' && 
        this.permissionStates.camera === 'granted';
      
      // 同步更新原有的checkbox状态
      if (this.permissionStates.microphone === 'granted') {
        this.bCheckboxMicrophone = true;
      }
      if (this.permissionStates.camera === 'granted') {
        this.bCheckboxCamera = true;
      }
    },

    // 显示授权页面
    showAuthorizationPage(stepByStep) {
      // 保存用户选择的学习模式
      this.bStepByStep = stepByStep;
      // 显示授权页面
      this.bShowAuthorizationPage = true;
    },

    // 开始学习
    startLearning() {
      // 暂时注释掉权限检查
      // if (!this.bStartButtonEnabled) {
      //   return;
      // }
      
      this.bShowAuthorizationPage = false;
      // 触发原有的开始学习逻辑，使用用户之前选择的模式
      this.onClickUserTrigger(this.bStepByStep);
    },

    // 手写画板确认绘制
    onHandwritingBoardConfirm(imageData) {
      this.teacherAsking.handwritingImage = imageData;
      // 使用手写合成图作为答案，清除临时截图附件，避免重复消息
      this.teacherAsking.photoBase64Data = '';
      this.teacherAsking.photoUrl = '';
      this.teacherAsking.bShowHandwritingBoard = false;
      
      // 提交手写图片作为答案，传入空字符串作为文本，图片数据在userAnsImgBase64WithMime中
      if (imageData) {
        let ta = this.teacherAsking;
        if (this.bAudioRecording) {
          this.startOrStopAudioRecording(null, (file) => {
            try {
              const url = URL.createObjectURL(file);
              ta.lastUserAnswerIsAudio = true;
              this.addToDialogueHistory('user', JSON.stringify({ audioUrl: url, fileName: file.name, size: file.size }), 'audio');
            } catch(e) {void 0}
            this.voiceToText(file, ta.currentAction, (text) => {
              this.sendAnswerForTeacherAskingInner(text);
            });
          }, null);
        } else {
          this.sendAnswerForTeacherAskingInner('');
        }
      }
    },

    // 手写画板显示/隐藏状态变化
    onHandwritingBoardVisibilityChanged(isVisible) {
      console.log('手写画板显示状态变化:', isVisible);
    },

    // 手写画板图片更新
    onHandwritingBoardImageUpdated(imageData) {
      this.teacherAsking.handwritingImage = imageData;
    },

    // 确认手写画板内容（用于时间到了时自动确认）
    confirmHandwritingBoard() {
      const ta = this.teacherAsking;
      if (ta.bShowHandwritingBoard && ta.handwritingImage) {
        console.log('🎨 确认手写画板内容，图片数据:', ta.handwritingImage);
        // 直接调用确认逻辑，不需要等待事件
        this.onHandwritingBoardConfirm(ta.handwritingImage);
      } else if (ta.bShowHandwritingBoard) {
        // 如果画板显示但没有图片数据，创建空白画板
        console.log('🎨 画板显示但无内容，创建空白画板');
        const canvas = document.createElement('canvas');
        canvas.width = ta.handwritingBoardConfig?.width || 800;
        canvas.height = ta.handwritingBoardConfig?.height || 600;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        const emptyImageData = canvas.toDataURL('image/png');
        this.onHandwritingBoardConfirm(emptyImageData);
      }
    },

    handleTeacherAskingClose() {
      try {
        console.log('🚪 handleTeacherAskingClose: 开始中断推流和音频播放');

        // 0. 若正在录音，立即停止麦克风并恢复 iOS 扬声器输出
        // 用户点 X 关闭弹窗时，录音可能仍在进行中，必须在此处手动清理，
        // 否则麦克风 stream 一直占用硬件，iOS 不会切回扬声器
        if (this.bAudioRecording && this.audioRecorder) {
          console.log('🎙️ handleTeacherAskingClose: 检测到录音中，强制停止并恢复扬声器');
          try {
            this.audioRecorder.stop();
            this.audioRecorder.stopStream(); // 先停麦克风轨道
            IOSAudioHelper.restoreAudioOutput(); // 再切回扬声器
            this.audioRecorder.end();
            this.audioRecorder = null;
          } catch(e) {
            console.warn('handleTeacherAskingClose: 停止录音出错', e);
          }
          this.bAudioRecording = false;
          if (this.audioRecorderTimer) {
            clearInterval(this.audioRecorderTimer);
            this.audioRecorderTimer = null;
          }
        }
        
        // 1. 立即中断流请求
        this.abortCurrentStream();
        
        // 2. 立即设置中断标志，停止推流处理
        if (this.isStreaming) {
          console.log('🛑 检测到正在推流，设置中断标志');
          this.isStreaming = false;
        }
        
        // 3. 停止teacherAsking相关的状态和处理
        if (this.teacherAsking.bHandling) {
          console.log('🛑 停止teacherAsking处理状态');
          this.teacherAsking.bHandling = false;
        }
        
        // 4. 暂停和释放所有正在播放的音频
        this.stopAllActiveAudioPlayers();
        
        // 5. 清理teacherAsking相关状态
        this.teacherAsking.bShowView = false;
        this.teacherAsking.bShowThinking = false;
        this.teacherAsking.bShowAnswer = false;
        this.teacherAsking.bShowAudioText = false;
        // 侧拉/弹窗关闭时同步收起手写画板（画板 z-index 高于侧拉，否则会残留挡操作）
        this.teacherAsking.bShowHandwritingBoard = false;
        
        // 6. 恢复数字人待机状态
        this.showTeacherIdleVideo();
        
        // 7. 立即触发场景切换 - 同步调用promiseResolve
        let ta = this.teacherAsking;
        if (ta.promiseResolve) {
          console.log('🎯 handleTeacherAskingClose: 立即调用promiseResolve，同步触发场景切换');
          ta.promiseResolve();
          ta.promiseResolve = null; // 清除引用
        }
        
        // 8. 清理倒计时器
        if (ta.countDownTimer) {
          clearInterval(ta.countDownTimer);
          ta.countDownTimer = null;
          console.log('🛑 清理多轮对话倒计时器');
        }
        
        console.log('✅ handleTeacherAskingClose: 推流中断完成，场景切换已同步触发');
        
      } catch (error) {
        console.error('❌ handleTeacherAskingClose 执行出错:', error);
        // 即使出错也要确保基本的状态清理
        this.teacherAsking.bShowView = false;
        this.teacherAsking.bShowHandwritingBoard = false;
        this.isStreaming = false;
        this.abortCurrentStream(); // 确保流被中断
        
        // 确保场景切换能继续
        let ta = this.teacherAsking;
        if (ta.promiseResolve) {
          console.log('🎯 错误处理: 调用promiseResolve确保场景切换');
          ta.promiseResolve();
          ta.promiseResolve = null;
        }
      }
    },
    
    // 中断当前流请求
     abortCurrentStream() {
       try {
         console.log('🛑 开始中断当前流请求');
         
         // 设置运行标志为false，停止流处理循环
         if (this.streamRunningFlag !== null && this.streamRunningFlag !== false) {
           console.log('🛑 设置流运行标志为false');
           this.streamRunningFlag = false;
         }
         
         // 如果有活跃的AbortController，则中断请求
         if (this.streamAbortController) {
           console.log('🛑 中断流请求控制器');
           try {
             this.streamAbortController.abort();
           } catch (abortError) {
             console.warn('⚠️ 中断AbortController时出错:', abortError);
           }
           this.streamAbortController = null;
         }
         
         console.log('✅ 流请求中断完成');
         
       } catch (error) {
         console.error('❌ abortCurrentStream 执行出错:', error);
       }
     },
    
    // 停止所有活跃的音频播放器
    stopAllActiveAudioPlayers() {
      try {
        console.log('🔇 开始停止所有活跃音频播放器');
        
        // 停止静态音频播放器池中的所有播放器
        for (let i = 0; i < this.staticAudioPlayers.length; i++) {
          const player = this.staticAudioPlayers[i];
          if (player && player.isBusy) {
            try {
              player.pause();
              player.currentTime = 0;
              this.freeStaticAudioPlayer(player);
              console.log('🔇 停止静态音频播放器:', player.id || i);
            } catch (err) {
              console.warn('⚠️ 停止静态音频播放器时出错:', err);
            }
          }
        }
        
        // 停止teacherAsking相关的特定音频
        if (this.teacherAsking.currentAction) {
          const action = this.teacherAsking.currentAction;
          
          // 停止老师提问音频
          if (action.teacherQuestionAudio) {
            try {
              action.teacherQuestionAudio.pause();
              action.teacherQuestionAudio.currentTime = 0;
              console.log('🔇 停止老师提问音频');
            } catch (err) {
              console.warn('⚠️ 停止老师提问音频时出错:', err);
            }
          }
          
          // 停止AI同学回答音频
          if (action.aiMateAnswerAudio) {
            try {
              action.aiMateAnswerAudio.pause();
              action.aiMateAnswerAudio.currentTime = 0;
              console.log('🔇 停止AI同学回答音频');
            } catch (err) {
              console.warn('⚠️ 停止AI同学回答音频时出错:', err);
            }
          }
        }
        
        // 停止语音判分相关音频
        if (this.oralScoring.lastPlayer) {
          try {
            this.oralScoring.lastPlayer.pause();
            this.oralScoring.lastPlayer.currentTime = 0;
            console.log('🔇 停止语音判分音频');
          } catch (err) {
            console.warn('⚠️ 停止语音判分音频时出错:', err);
          }
        }
        
        // 停止用户提问相关音频
        if (this.userAsking.lastAnswerPlayer) {
          try {
            this.userAsking.lastAnswerPlayer.pause();
            this.userAsking.lastAnswerPlayer.currentTime = 0;
            console.log('🔇 停止用户提问回答音频');
          } catch (err) {
            console.warn('⚠️ 停止用户提问回答音频时出错:', err);
          }
        }
        
        console.log('✅ 所有活跃音频播放器已停止');
        
      } catch (error) {
        console.error('❌ stopAllActiveAudioPlayers 执行出错:', error);
      }
    },

    hasNativeApi: function() {
      if(window.nativeApi){
        return true;
      }
      return false;
    },

    handleParamsAndToken: function () {
      let bNeedHref = false;
      if(this.queries.userId) {
        let user_id = Number(this.queries.userId); //用户id
        localStorage.setItem('lesson.player.user_id', user_id);
        bNeedHref = true;
      } else {
        this.queries.userId = Number(localStorage.getItem('lesson.player.user_id'));
      }

      if(this.queries.pid) {
        localStorage.setItem('lesson.player.pid', this.queries.pid);
      } else {
        this.queries.pid = localStorage.getItem('lesson.player.pid');
      }

      if(this.queries.token) {
        localStorage.setItem('lesson.player.token', this.queries.token);
        bNeedHref = true;
      } else {
        this.queries.token = localStorage.getItem('lesson.player.token');
      }

      if(bNeedHref) {
        window.location.href = this.makeClearHref();
      }
    },

    onUserClickForInteraction: function () {
      this.bNeedInteractionWithUser = false;
      if(this.needInteractionPlayer) {
        this.needInteractionPlayer.play().catch(async function (err) {
          console.error('play after user-interaction error:', err, err.name, err.message);
        });
        this.needInteractionPlayer = null;
      }
    },
    showErrorMsg: async function (duration, msg, clickFunction) {
      this.bNetworkError = true;
      this.globalErrorMessage = msg;
      await nextTick();
      let e = document.getElementById('networkErrorView');
      if (e) {
        if (clickFunction) {
          e.style.cursor = 'pointer';
          e.onclick = () => {
            clickFunction();
          }
        } else {
          e.style.cursor = '';
          e.onclick = '';
        }
      }
      let thiz = this;
      setTimeout(() => {
        thiz.bNetworkError = false;
      }, duration);
    },

    loadWebAssembly: function (path, imports = {}) {
      return fetch(path) // 加载文件
          .then(response => response.arrayBuffer()) // 转成 ArrayBuffer
          .then(buffer => WebAssembly.compile(buffer))
          .then(module => {
//            imports.env = imports.env || {}
            // 开辟内存空间
//            imports.env.memoryBase = imports.env.memoryBase || 0
//            if (!imports.env.memory) {
//              imports.env.memory = new WebAssembly.Memory({ initial: 128 })
//            }
            // 创建变量映射表
//            imports.env.tableBase = imports.env.tableBase || 0
//            if (!imports.env.table) {
            // 在 MVP 版本中 element 只能是 "anyfunc"
//              imports.env.table = new WebAssembly.Table({ initial: 0, element: 'anyfunc' })
//            }
            // 创建 WebAssembly 实例
            this.wasmInstance = new WebAssembly.Instance(module, imports);
            return this.wasmInstance;
          })
    },

    backToRecordMainWindow: function() {
      if (this.hasNativeApi()) {
        window.nativeApi.resetMainWindow();
      }
    },
    onClickLessonRecording: async function () {
      if (this.hasNativeApi()) {
        let fileName = await window.nativeApi.chooseMp4File('lesson-record-'+this.queries.lessonId+".mp4");
        if(fileName) {
          this.dstRecordMp4FileName = fileName;
          this.bRecord = true;
          this.showAuthorizationPage(false);
        } else alert('你已取消录制');
      } else alert('你的浏览器不支持录制课程');
    },

    //用户发起交互，为了获取视频播放权限
    onClickUserTrigger: async function (stepByStep) {
      console.log('onClickUserTrigger');
      this.bStepByStep = stepByStep;
      this.triggeredByUser = true;

      //播放剧本
      if (this.lesson) {
        // 原生旋转模式：不再强制旋转body
        // if(this.lesson.resolution.width > this.lesson.resolution.height && window.innerWidth < window.innerHeight) {
        //   document.body.style.transformOrigin = 'top left';
        //   document.body.style.transform = 'rotate(90deg) translateY(-100%)';
        //   document.body.style.width  = '100vh';
        //   document.body.style.height = '100vw';
        //   this.bRotated = true;
        //   await nextTick();
        //   this.calculateSurfaceSize();
        // }

        //open camera
        console.log('bCheckboxCamera=',this.bCheckboxCamera);
        if(this.bCheckboxCamera && !this.bRecord) {
          const constraints = {
            video: {
              width: { ideal: 320 }, // 理想宽度
              height: { ideal: 240 }  // 理想高度
            }
          };
          navigator.mediaDevices.getUserMedia(constraints)
              .then(stream => {
                this.cameraStream = stream;
                // 检查DOM元素是否存在
                if (this.$refs.userCameraView) {
                  this.$refs.userCameraView.srcObject = stream;
                  console.log('摄像头已打开（mounted）');
                } else {
                  console.warn('摄像头视频元素不存在，等待DOM更新后重试（mounted）');
                  this.$nextTick(() => {
                    if (this.$refs.userCameraView) {
                      this.$refs.userCameraView.srcObject = stream;
                      console.log('摄像头已打开（mounted延迟设置）');
                    } else {
                      console.error('摄像头视频元素仍然不存在（mounted）');
                    }
                  });
                }
              })
              .catch(error => {
                console.error('摄像头打开错误：', error);
              });
        }

        //request video/audio permissions
        console.log("requestPlayerPermissions-1");
        this.requestPlayerPermissions();
        console.log("requestPlayerPermissions-2");

        //start screen recording
        if(this.bRecord && window.nativeApi) {
          document.body.style.cursor = 'none'; //录制时隐藏鼠标
          await window.nativeApi.startScreenRecordPromise(
              this.surface.ratio_left, this.surface.ratio_top, this.surface.ratio_width, this.surface.ratio_height,
              this.dstRecordMp4FileName);
        }

        //play script
        this.bPlayingScript = true;
        // 移除keyingFps相关代码
        await this.playLessonScript();
        // 移除keyingFps相关代码

        //stop screen recording
        if(this.bRecord && window.nativeApi) {
          await window.nativeApi.stopScreenRecord(this.surface.ratio_left, this.surface.ratio_top, this.surface.ratio_width, this.surface.ratio_height);
          await sleep(1000); //等一秒，免得录到下面的消息框
          document.body.style.cursor = ''; //录制后显示鼠标
          this.showErrorMsg(99999999, '录制完成，返回主页面', this.backToRecordMainWindow);
        }

      }
    },

    requestPlayerPermissions: function() {
      for(let idx in this.mediasForRequestGesture) {
        let m = this.mediasForRequestGesture[idx];
        if(this.isIPhone) {
//          m.muted = true;
        } else {
          m.play().catch(async function (err) {
            console.error('play requestPlayerPermission error:', err, err.name, err.message);
          });
          m.pause();
        }
      }
    },

    isMediaActionType(actionType) {
      return ['aside', 'robot', 'robot_video', 'video', 'keying_video', 'audio', 'robot_cartoon'].includes(actionType);
    },

    //计算画面位置和大小
    calculateSurfaceSize: function () {
      let x = 0;
      let y = 0;
      let width  = window.innerWidth;
      let height = window.innerHeight;
      
      // 原生旋转模式：不再需要逻辑交换宽高
      // if(this.bRotated) {
      //   width  = window.innerHeight;
      //   height = window.innerWidth;
      // }
      
      if(this.lesson) {
        //keep width/height ratio
        let imgRatio = this.lesson.resolution.width / this.lesson.resolution.height;
        let wndRatio = width / height;
        if(imgRatio > wndRatio){
          let h = width / imgRatio;
          y += (height - h) / 2;
          height = h;
        }
        else if(imgRatio < wndRatio){
          let w = height * imgRatio;
          x += (width - w) / 2;
          width = w;
        }
      }
      this.surface.left = x;
      this.surface.top = y;
      this.surface.width = width;
      this.surface.height = height;
      this.surface.bLand = width > height;

      this.surface.ratio_left = x / window.innerWidth;
      this.surface.ratio_top  = y / window.innerHeight;
      this.surface.ratio_width  = width / window.innerWidth;
      this.surface.ratio_height = height / window.innerHeight;

      //计算被动回答的ui尺寸
      {
        let imgW = 1188;//1133;
        let imgH = 824;//1700;
        let padding = 20;
        if (this.surface.bLand) {
          this.userAnsweringViewHeight = (this.surface.height - padding) + 'px';
          this.userAnsweringViewWidth = (imgW * this.surface.height / imgH - padding) + 'px';
        } else {
          this.userAnsweringViewWidth = (this.surface.width - padding) + 'px';
          this.userAnsweringViewHeight = (imgH * this.surface.width / imgW - padding) + 'px';
        }
      }

      //重新计算text元素的fontSize
      for(let elementId in this.textCache) {
        let e = document.getElementById(elementId);
        if(e) {
          e.style.fontSize = (this.textCache[elementId] * this.surface.width)+'px';
        }
      }
      // //重新计算blackboard的transform
      // for(let elementId in this.blackboardCache) {
      //   let e = document.getElementById(elementId);
      //   if(e) {
      //     let cache = this.blackboardCache[elementId];
      //     let ratio = this.surface.width/this.lesson.resolution.width;
      //     e.style.transform = "scale("+(ratio)+")";
      //     let ratio2 = this.lesson.resolution.width/this.surface.width;
      //     e.style.width  = (cache.baseWidth * ratio2) + "%";
      //     e.style.height = (cache.baseHeight * ratio2) + "%";
      //   }
      // }
    },


    invokeLessonPlayerWebApi: async function(apiName, param, cbSuccess, cbError) {
      let thiz = this;
      return invokeLessonPlayerWebApi(this.queries, apiName, param, this.toLogin, cbSuccess, (error)=>{
        thiz.showErrorMsg(1000, '小故障，请检查一下您的网络');
        if(cbError) cbError(error);
      });
    },
    toLogin: function () {
      let thiz = this;
      this.showErrorMsg(2000, '需要登录，即将跳转');
      setTimeout(()=>{
        let backUrl = encodeURIComponent(thiz.makeClearHref());
//      let loginUrl = 'https://read2.bluebirdabc.com/?pid='+thiz.queries.pid+"&redirect="+backUrl;
//      window.location.href = loginUrl;
        let loginUrl = 'https://read2.bluebirdabc.com/my-login/#/?pid='+thiz.queries.pid+"&redirect="+backUrl;
        window.open(loginUrl, '_self');
      }, 2000);
    },
    makeClearHref: function () {
      let url = window.location.href;
      let idx = url.indexOf('?');
      let base = idx<0 ? url:url.substring(0, idx);
      let search = url.substring(idx+1);
      let arr = search.split(/\?|&/g);
      let param = {};
      for (let i in arr) {
        let s = arr[i];
        let pos = s.indexOf("#");
        if(pos > 0) {
          s = s.substring(0, pos);
        }
        pos = s.indexOf("=");
        if (pos > 0) {
          let k = s.substring(0, pos);
          let v = s.substring(pos + 1);
          param[k] = v;
        }
      }

      param['pid'] = this.queries.pid;
      param['lessonId'] = this.queries.lessonId;

      search = '';
      for(let k in param) {
        if(k === 'userId')
          continue
        if(k === 'user_id')
          continue;
        if(k === 'token')
          continue;
        if(search.length > 0)
          search += '&';
        search += k+'='+param[k];
      }

      let newurl = base + '?' + search;
      return newurl;
    },

    getLessonScript: function () {
      let thiz = this;
      return this.invokeLessonPlayerWebApi('get-script2', {}, function(res) {
        console.log('GotPlayableScript', res);
        thiz.lesson = res.data.data;//JSON.parse(res.data.data);
        console.log('lesson', thiz.lesson);
         if(thiz.lesson && thiz.lesson.config && thiz.lesson.config.courseTemplate == 'qqs'){
            if(thiz.lesson.channel){
              thiz.lesson.channel.code = 'chinese';
            }else{
              thiz.lesson.channel = {
                code: 'chinese',
              }
            }
            thiz.applyQqsBranding();
          }
        if(thiz.lesson && thiz.lesson.channel)
          thiz.channel.setCode(thiz.lesson);
        console.log('lesson.channel.getCode=', thiz.channel.getCode());
        
        // 当channelcode为chinese时，设置HTML背景色为黑色
        if(thiz.channel.getCode() === 'chinese') {
          document.documentElement.style.backgroundColor = '#000000';
        }

        // 处理新增的liveWindow字段 (向后兼容，现在优先使用场景actions中的配置)
        if(thiz.lesson && thiz.lesson.liveWindow) {
          thiz.liveWindow = thiz.lesson.liveWindow;
        }

        // 处理新增的cameraPosition字段 (向后兼容，现在优先使用场景actions中的配置)
        if(thiz.lesson && thiz.lesson.cameraPosition) {
          console.log('cameraPosition config (global fallback):', thiz.lesson.cameraPosition);
          console.log('cameraPosition keys:', Object.keys(thiz.lesson.cameraPosition));
          thiz.cameraPosition = thiz.lesson.cameraPosition;
        }

        // 处理新增的cameraMonitoring字段
        thiz.cameraMonitoring = thiz.lesson.config.cameraMonitoring;
        console.log('cameraMonitoring config:', thiz.cameraMonitoring);
      });
    },
    getLessonSummarySections: function () {
      let thiz = this;
      return this.invokeLessonPlayerWebApi('get-summary-sections', {}, function(res){
        console.log('getLessonSummarySections', res);
        thiz.summary.sections = res.data.data;
        console.log('summary.sections', thiz.summary.sections);
      });
    },
    getLessonSummaryQuestions: function () {
      let thiz = this;
      return this.invokeLessonPlayerWebApi('get-summary-questions', {}, function(res){
        console.log('getLessonSummaryQuestions', res);
        let nounArr = [];
        let basicArr = [];
        let extendArr = [];
        for(let idx in res.data.data) {
          let q = res.data.data[idx];
          switch(q.questionType) {
            case 'noun'  : nounArr.push(q); break;
            case 'basic' : basicArr.push(q); break;
            case 'extend': extendArr.push(q); break;
          }
        }
        thiz.summary.questions.push(nounArr);
        thiz.summary.questions.push(basicArr);
        thiz.summary.questions.push(extendArr);
        console.log('summary.questions', thiz.summary.questions);

        for(let i in thiz.summary.questions) {
          let arr = thiz.summary.questions[i];
          let secName = '';
          for(let j in arr) {
            let q = arr[j];
            if(q.sectionName != secName) {
              secName = q.sectionName;
            } else {
              q.sectionName = '';
            }
          }
        }
      });
    },
    checkHaveSummaryOrNot: function() {
      if(this.summary.sections) {
        for(let i in this.summary.sections) {
          let sec = this.summary.sections[i];
          if(sec.summary) {
            return true;
          }
        }
      }
      if(this.summary.questions) {
        for(let i in this.summary.questions) {
          let arr = this.summary.questions[i];
          if(arr.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    checkIfNeedAudioRecorder: function () {
      for (let sceneIdx in this.lesson.scenes) {
        let scene = this.lesson.scenes[sceneIdx];
        for (let groupIdx in scene.groups) {
          let group = scene.groups[groupIdx];
          for (let actionIdx in group.actions) {
            let action = group.actions[actionIdx];
            switch (action.actionType) {
              case 'ques'       : //用户主动提问
              case 'quesTeacher': //老师主动提问，学生开放式回答，或者跟AI伴读抢答
              case 'quesAudio'  : //语音判分，前端流程跟“老师主动提问”相似
                    return true;
            }
          }
        }
      }
      return false;
    },

    //预先下载视频、音频、图片
    downloadingResources: function () {
      return new Promise((resolve) => {
        console.log('downloadingResources ...');
        let urls = {};
        this.url2blobMap = urls;
        for (let sceneIdx in this.lesson.scenes) {
          if(sceneIdx >= 1) {
            console.log('downloadingResources skip scene:', sceneIdx);
            continue;
          }
          let scene = this.lesson.scenes[sceneIdx];
          for (let groupIdx in scene.groups) {
            let group = scene.groups[groupIdx];
            for (let actionIdx in group.actions) {
              let action = group.actions[actionIdx];
              let url;
              switch (action.actionType) {
                case 'material':
                case 'image':
                  url = action.url;
                  if(url) urls[url] = 0;
                  break;
                case 'aside':
                case 'audio':
                  url = action.audioUrl || action.url;
                  if(url) urls[url] = 0;
                  break;
                case 'robot':       //孪生数字人
                case 'robot_video': //图片数字人，不执行抠图处理，但需要像robot那样提前loading
                case 'video':       //普通视频
                case 'keying_video'://待机数字人，实际上是需要抠图的视频
                  url = action.videoUrl || action.robotvideoUrl || action.url;
                  if(url) urls[url] = 0;
//                if (action.frame0ImgUrl) urls[action.frame0ImgUrl] = 0;
                  if (action.idleVideoUrl) urls[action.idleVideoUrl] = 0;
                  break;
                case 'robot_cartoon'://卡通数字人
                  if(action.speakImgUrl) urls[action.speakImgUrl] = 0;
                  if(action.idleImgUrl)  urls[action.idleImgUrl] = 0;
                  if(action.audioUrl)    urls[action.audioUrl] = 0;
                  break;
                case 'quesTeacher':
                  if(!this.isIPhone) {
                    if(action.teacherQuestionAudioUrl) urls[action.teacherQuestionAudioUrl] = 0;
                    if(action.aiMateAnswerAudioUrl   ) urls[action.aiMateAnswerAudioUrl   ] = 0;
                  }
                  if(action.teacherIdleVideoUrl) urls[action.teacherIdleVideoUrl] = 0;
                  if(action.teacherMuteVideoUrl) urls[action.teacherMuteVideoUrl] = 0;
                  break;
                case 'quesAudio':
                  if(action.teacherImgUrl        ) urls[action.teacherImgUrl        ] = 0;
                  if(action.teacherHuashuAudioUrl) urls[action.teacherHuashuAudioUrl] = 0;
                  if(action.aiMateStandImgUrl    ) urls[action.aiMateStandImgUrl    ] = 0;
                  if(action.aiMateSpeakImgUrl    ) urls[action.aiMateSpeakImgUrl    ] = 0;
                  if(action.aiMateIdleImgUrl     ) urls[action.aiMateIdleImgUrl     ] = 0;
                  if(action.scoreFailAudioUrl    ) urls[action.scoreFailAudioUrl    ] = 0;
                  if(action.aiMateAnswerAudioUrlA) urls[action.aiMateAnswerAudioUrlA] = 0;
                  if(action.aiMateAnswerAudioUrlB) urls[action.aiMateAnswerAudioUrlB] = 0;
                  if(action.encourageAudioUrl    ) urls[action.encourageAudioUrl    ] = 0;
                  if(action.tooDifficultAudioUrl ) urls[action.tooDifficultAudioUrl ] = 0;
                  if(action.readMoreAudioUrl     ) urls[action.readMoreAudioUrl     ] = 0;
                  if(action.identifyTextAudioUrl ) urls[action.identifyTextAudioUrl ] = 0;
                  break;
                default:
                  break;
              }
            }
          }
        }
        if(this.summaryImageUrl) { urls[this.summaryImageUrl] = 0; }

        //collect urls into an Array
        let resources = [];
        for(let url in urls) {
          resources.push(url);
        }

        //
        this.nResourcesTotal = resources.length;
        if(this.nResourcesTotal == 0) {
          resolve();
          return;
        }

        /*
        //下载方式：任性下载
        {
          let promises = [];
          for(let idx in resources) {
            let url = resources[idx];
            let init = {};//{headers:{Range: 'bytes=0-5242880'}};
            console.log('download:', idx, url);
            let promise = fetch(url, init)
                .then((response) => {
                  response.blob().then((blob)=>{
                    this.nResourcesDone++;
                    let localBlobUrl = window.webkitURL.createObjectURL(blob) || window.URL.createObjectURL(blob);
                    urls[url] = localBlobUrl;
                    console.log('download ok:', idx, url, blob, localBlobUrl);
                    if(this.nResourcesDone == this.nResourcesTotal) {
                      resolve();
                      return;
                    }
                  });
                })
                .catch((err) => {
                  this.nResourcesDone++;
                  console.log('download error:', idx, err);
                  if(this.nResourcesDone == this.nResourcesTotal) {
                    resolve();
                    return;
                  }
                });
            console.log('download push promise:', idx, url);
            promises.push(promise);
          }
          Promise.all(promises);
        } */

        //下载方式：分10个队列
        {
          const nQueues = 10;
          let queues = this.groupAsQueues(resources, nQueues);
          console.log('downloading', queues);

          for(let i=0; i<queues.length; i++) {
            let queue = queues[i];
            if(queue.length > 0) {
              this.downloadImageOrAudioOrVideo(urls, queue, 0, queue.length);
            }
          }

          let timer = setInterval(()=>{
            if(this.nResourcesDone == resources.length) {
              clearInterval(timer);
              resolve();
            }
          }, 333);
        }

      });
    },

    waitUserClickNextSceneButton: function () {
      return new Promise(resolve => {
        let thiz = this;
        let container = document.getElementById("sceneContainer");

        let div = document.createElement("div");
        div.style = `position:absolute; left:15%; top:30%; width:70%;text-align:center;z-index:6666;color:`+this.channel.nextSceneContainerStyleColor()+`;
        background-image:url(${this.channel.nextSceneContainerBgImg()});background-size:100% 100%;background-repeat: no-repeat;`;

        {
          let divTitle = document.createElement("div");
          divTitle.innerHTML = "<h2 style='margin:50px 20px 20px 20px;'>即将进入："+this.currentScene.name+"</h2>";
          div.appendChild(divTitle);
        }

        {
          let btn = document.createElement('img');
          btn.src = this.channel.nextSceneEnterButtonImg();
          btn.style = `width:120px;margin-top:20px;margin-bottom:20px;margin-right:40px;cursor:pointer;`;
          btn.onclick = function () {
            thiz.bEnterNextStep = true;
            container.removeChild(div);
            resolve();
          }
          div.appendChild(btn);
        }

        {
          let btn = document.createElement('img');
          btn.src = this.channel.nextSceneSkipButtonImg();
          btn.style = `width:120px;margin-top:20px;margin-bottom:20px;margin-left:40px;cursor:pointer;`;
          btn.onclick = function () {
            thiz.bEnterNextStep = false;
            container.removeChild(div);
            resolve();
          }
          div.appendChild(btn);
        }

        container.appendChild(div);
      });
    },

    getBlobSrc: function (url) {
      if(this.url2blobMap[url])
        return this.url2blobMap[url];
      return url;
    },
    prepareMediaForAction: function (resources, medias, action, srcField, tagName, targetField) {
      if(action[srcField]) {
        let e = document.createElement(tagName);
        e.src = this.getBlobSrc(action[srcField]);
        e.setAttribute('tag', targetField);
        action[targetField] = e;
        medias.push(e);
        resources.push(e);
        this.$refs.hiddenContainer.appendChild(e);
      }
    },

    //加载视频、音频、图片，canplay
    preloadMediasOfLocalBlob: async function () {
      console.log('preloadMediasOfLocalBlob ...');
      let thiz = this;
      return new Promise( (resolve) => {
        let medias = [];
        let images = [];
        let resources = [];
        for (let sceneIdx in this.lesson.scenes) {
          let scene = this.lesson.scenes[sceneIdx];
          for (let groupIdx in scene.groups) {
            let group = scene.groups[groupIdx];
            for (let actionIdx in group.actions) {
              let action = group.actions[actionIdx];
              let elementId = 'element' + action.actionId;
              let element;
              let elementInfo;
//            let frame0Element;
              let idleElement;
              let url;
              switch (action.actionType) {
                case 'material':
                case 'image':
                  elementInfo = this.newElementInfo(elementId, action.actionType, action.exitMode);
                  element = document.createElement('img');
                  element.src = this.getBlobSrc(action.url);
                  if (action.url) {
                    images.push(element);
                    resources.push(element);
                  }
                  break;
                case 'aside':
                case 'audio':
                  url = action.audioUrl || action.url;
                  elementInfo = this.newElementInfo(elementId, action.actionType, action.exitMode);
                  element = document.createElement('audio');
                  element.src = this.getBlobSrc(url);
//                element.preload = 'auto';
                  if (url) {
                    medias.push(element);
                    resources.push(element);
                  }
                  break;
                case 'robot_cartoon'://卡通数字人
                  console.log('卡通数字人, speakImgUrl=', action.speakImgUrl);
                  elementInfo = this.newElementInfo(elementId, action.actionType, action.exitMode);
                  element = document.createElement('img');
                  element.src = this.getBlobSrc(action.speakImgUrl);
                  elementInfo.speakImg = element;
                  elementInfo.idleImg = document.createElement('img');
                  elementInfo.audio = document.createElement('audio');
                  elementInfo.idleImg.src = this.getBlobSrc(action.idleImgUrl);
                  elementInfo.audio.src = this.getBlobSrc(action.audioUrl);
                  if (action.speakImgUrl) {
                    images.push(element);
                    resources.push(element);
                  }
                  if (action.idleImgUrl) {
                    images.push(elementInfo.idleImg);
                    resources.push(elementInfo.idleImg);
                  }
                  if (action.audioUrl) {
                    medias.push(elementInfo.audio);
                    resources.push(elementInfo.audio);
                  }
                  break;
                case 'robot':       //孪生数字人
                case 'robot_video': //图片数字人，不执行抠图处理，但需要像robot那样提前loading
                case 'video':       //普通视频
                case 'keying_video'://待机数字人，实际上是需要抠图的视频
                  url = action.videoUrl || action.robotvideoUrl || action.url;
                  elementInfo = this.newElementInfo(elementId, action.actionType, action.exitMode);
                  elementInfo.fadeIn  = action.fadeIn;
                  elementInfo.fadeOut = action.fadeOut;
                  element = document.createElement('video');
                  element.setAttribute('x5-playsinline', true);
                  element.setAttribute('playsinline', true);
                  element.setAttribute('webkit-playsinline', true);
                  element.setAttribute('x-webkit-airplay', true);
                  element.crossOrigin = ''; //允许canvas跨域getImageData
                  element.src = this.getBlobSrc(url);
//                element.preload = 'auto';
                  if (url) {
                    medias.push(element);
                    resources.push(element);
                  }
                  element.onloadedmetadata = function () {
                    elementInfo.videoWidth = element.videoWidth;
                    elementInfo.videoHeight = element.videoHeight;
                    elementInfo.videoDuration = element.duration;
                  }
                  if (action.frame0ImgUrl) {
//                  frame0Element = document.createElement('img');
//                  frame0Element.src = this.getBlobSrc(action.frame0ImgUrl);
//                  elementInfo.frame0Element = frame0Element;
                  }
                  if (action.actionType === 'robot' && action.wait && action.idleVideoUrl) {
                    idleElement = document.createElement('video');
                    idleElement.setAttribute('x5-playsinline', true);
                    idleElement.setAttribute('playsinline', true);
                    idleElement.setAttribute('webkit-playsinline', true);
                    idleElement.setAttribute('x-webkit-airplay', true);
                    idleElement.crossOrigin = ''; //允许canvas跨域getImageData
                    idleElement.src = this.getBlobSrc(action.idleVideoUrl);
                    idleElement.style.display = 'none';
                    idleElement.loop = true;
//                  idleElement.preload = 'auto';
                    elementInfo.idleElement = idleElement;
                    medias.push(idleElement);
                    resources.push(idleElement);

                    element.ontimeupdate = () => {
                      if(element.duration - element.currentTime <= 0.300) { //300ms
                        element.dispatchEvent(new Event('before-ended-300'));
                      }
                    }
                    element.addEventListener('before-ended-300', ()=>{
                      let timer = setInterval(()=>{
                        if(element.duration - element.currentTime <= 0.010) { //10ms
                          clearInterval(timer);
                          element.dispatchEvent(new Event('before-ended'));
                        }
                      }, 5);
                    }, {once: true})
                  }
                  break
                case 'quesTeacher':
                  this.prepareMediaForAction(resources, medias, action, 'teacherQuestionAudioUrl', 'audio', 'teacherQuestionAudio');
                  this.prepareMediaForAction(resources, medias, action, 'aiMateAnswerAudioUrl', 'audio', 'aiMateAnswerAudio');
                  this.prepareMediaForAction(resources, medias, action, 'teacherIdleVideoUrl', 'video', 'teacherIdleVideo');
                  this.prepareMediaForAction(resources, medias, action, 'teacherMuteVideoUrl', 'video', 'teacherMuteVideo');
                  break
                case 'quesAudio':
                  this.prepareMediaForAction(resources, images, action, 'teacherImgUrl', 'img', 'teacherImg');
                  this.prepareMediaForAction(resources, medias, action, 'teacherHuashuAudioUrl', 'audio', 'teacherHuashuAudio');
                  this.prepareMediaForAction(resources, images, action, 'aiMateStandImgUrl', 'img', 'aiMateStandImg');
                  this.prepareMediaForAction(resources, images, action, 'aiMateSpeakImgUrl', 'img', 'aiMateSpeakImg');
                  this.prepareMediaForAction(resources, images, action, 'aiMateIdleImgUrl', 'img', 'aiMateIdleImg');
                  this.prepareMediaForAction(resources, medias, action, 'scoreFailAudioUrl', 'audio', 'scoreFailAudio');
                  this.prepareMediaForAction(resources, medias, action, 'aiMateAnswerAudioUrlA', 'audio', 'aiMateAnswerAudioA');
                  this.prepareMediaForAction(resources, medias, action, 'aiMateAnswerAudioUrlB', 'audio', 'aiMateAnswerAudioB');
                  this.prepareMediaForAction(resources, medias, action, 'encourageAudioUrl', 'audio', 'encourageAudio');
                  this.prepareMediaForAction(resources, medias, action, 'tooDifficultAudioUrl', 'audio', 'tooDifficultAudio');
                  this.prepareMediaForAction(resources, medias, action, 'readMoreAudioUrl', 'audio', 'readMoreAudio');
                  this.prepareMediaForAction(resources, medias, action, 'identifyTextAudioUrl', 'audio', 'identifyTextAudio');
                  break;
                default:
                  break;
              }
              if (element) { //media(video/audio) element
                element.muted = this.bMute;
                element.style.display = 'none';
                element.elementInfo = elementInfo;
                this.mediaCache[elementId] = element;
              }
              if (idleElement) {
                idleElement.muted = this.bMute;
                idleElement.style.display = 'none';
                idleElement.elementInfo = elementInfo;
              }
            }
          }
        }

        this.mediasForRequestGesture = medias;

        //preload or not
        let preloadFlag = true;
        if (!preloadFlag) {
          resolve();
          return;
        }

        //
        this.nResourcesTotal = medias.length + images.length;
        this.nResourcesDone = 0;
        console.log('nResourcesTotal=',this.nResourcesTotal, '=',resources.length);
        if (this.nResourcesTotal == 0) {
          resolve();
          return;
        }

        /*
        //任性地加载
        {
          //preload videos and audios
          for (let idx in medias) {
            let m = medias[idx];
            console.log('load-media:', idx, m.src);
            if (this.isIPhone) {
              console.log('iphone-media-oncanplay:', idx, m.src);
              thiz.nResourcesDone++;
              if (thiz.nResourcesDone == thiz.nResourcesTotal) {
                console.log('waitCanPlays done');
                resolve();
              }
            }
            else {
              m.oncanplay = function () {
                console.log('media-oncanplay:', idx, m.src);
                thiz.nResourcesDone++;
                if (thiz.nResourcesDone == thiz.nResourcesTotal) {
                  console.log('waitCanPlays done');
                  resolve();
                }
                m.oncanplay = null;
              }
              m.load();
            }
          }

          //preload images
          for (let idx in images) {
            let img = images[idx];
            console.log('load-img:', idx, img.src);
            img.onload = function () {
              console.log('image-onload:', idx, img.src);
              thiz.nResourcesDone++;
              if (thiz.nResourcesDone == thiz.nResourcesTotal) {
                console.log('waitCanPlays done');
                resolve();
              }
              img.onload = null;
            }
          }
        } */

        /*
        //10个10个的、此起彼伏的加载
        {
          //preload images, videos and audios
          const loadOnce = 10;
          if (images.length > 0) {
            let n = Math.floor(images.length / loadOnce);
            let tail = images.length % loadOnce;
            let idx0 = 0;
            for (let i = 0; i < n; i++) {
              await thiz.loadImagesCanplay(images, idx0, idx0 + loadOnce);
              idx0 += loadOnce;
            }
            if (tail > 0) {
              await thiz.loadImagesCanplay(images, idx0, idx0 + tail);
            }
          }
          if (medias.length > 0) {
            let n = Math.floor(medias.length / loadOnce);
            let tail = medias.length % loadOnce;
            let idx0 = 0;
            for (let i = 0; i < n; i++) {
              await thiz.loadMediasCanplay(medias, idx0, idx0 + loadOnce);
              idx0 += loadOnce;
            }
            if (tail > 0) {
              await thiz.loadMediasCanplay(medias, idx0, idx0 + tail);
            }
          }
          resolve();
        }
        */

        /*
        //分为10个队列进行加载：分裂方式 [0,1,2,3,4,5,6,7,8,9]， [10,11,12,13,41,51,6,17,18,19]， [20,21,22,23,24,52,62,72,82,29]
        {
          let nQueues = 10;
          let nQueueSize = Math.floor(resources.length / nQueues);
          let tail = nQueueSize > 0 ? (resources.length % nQueueSize) : resources.length;
          let idx0 = 0;
          for (let i = 0; i < nQueues; i++) {
            let nAdj = nQueueSize;
            if(tail > 0) {
              nAdj++;
              tail--;
            }
            thiz.loadImageOrAudioOrVideo(resources, idx0, idx0+nAdj).then();
            idx0 += nAdj;
          }

          let timer = setInterval(()=>{
            if(thiz.nResourcesDone == resources.length) {
              clearInterval(timer);
              resolve();
            }
          }, 333);
        }*/

        //分为10个队列进行加载：分裂方式 [0,10,20,30,40]， [1,11,22,31,41]， [2,12,22,32,42]
        {
          const nQueues = 10;
          let queues = thiz.groupAsQueues(resources, nQueues);
          console.log('preloading', queues);

          for(let i=0; i<queues.length; i++) {
            let queue = queues[i];
            if(queue.length > 0) {
              thiz.preloadImageOrAudioOrVideo(queue, 0, queue.length);
            }
          }

          let timer = setInterval(()=>{
            if(thiz.nResourcesDone == resources.length) {
              clearInterval(timer);
              resolve();
            }
          }, 333);
        }

      });
    },

    groupAsQueues: function(arr, numOfQueues) {
      let queues = [];
      for(let i=0; i<numOfQueues; i++) {
        queues.push([]);
      }
      let qid = 0;
      for(let i=0; i<arr.length; i++) {
        queues[qid%numOfQueues].push(arr[i]);
        qid++;
      }
      return queues;
    },

    downloadImageOrAudioOrVideo: async function (urlsMap, urlArr, beginIdx, endIdx) {
      let thiz = this;
      for (let idx = beginIdx; idx < endIdx; idx++) {
        let url = urlArr[idx];
        let init = {};//{headers:{Range: 'bytes=0-5242880'}};
        console.log('download:', idx, url);
        let promise = fetch(url, init)
            .then((response) => {
              response.blob().then((blob)=>{
                let localBlobUrl = window.webkitURL.createObjectURL(blob) || window.URL.createObjectURL(blob);
                urlsMap[url] = localBlobUrl;
                thiz.nResourcesDone++;
                console.log('download ok:', idx, url, blob, localBlobUrl);
              });
            })
            .catch((err) => {
              thiz.nResourcesDone++;
              console.log('download error:', idx, err);
            });
        await promise;
      }
    },
    preloadImageOrAudioOrVideo: async function (resources, beginIdx, endIdx) {
      let thiz = this;
      for (let i = beginIdx; i < endIdx; i++) {
        let res = resources[i];
        let promise = new Promise(resolve => {
          if (res instanceof HTMLImageElement) {
            console.log('loading image: ', i, res.src);
            if (res.complete) {
              console.log('load-ok image: ', i, 'complete');
              thiz.nResourcesDone++;
              resolve();
            } else {
              res.onload = function () {
                console.log('load-ok image: ', i, 'loaded');
                res.onload = null;
                thiz.nResourcesDone++;
                resolve();
              }
            }
          } else if ((res instanceof HTMLAudioElement) || (res instanceof HTMLVideoElement)) {
            console.log('loading audio-video: ', i, res.src);
            if (thiz.isIPhone) {
              res.load();
              console.log('load-ok audio-video: ', i, 'iphone-skip');
              thiz.nResourcesDone++;
              resolve();
            } else {
              const timeoutId = setTimeout(() => {
                console.log('load-error audio-video: ', i, 'timedout', res);
                res.oncanplay = null;
                thiz.nResourcesDone++;
                resolve();
              }, 120000);//120秒超时值
              res.oncanplay = function () {
                console.log('load-ok audio-video: ', i, 'oncanplay');
                clearTimeout(timeoutId); // 清除超时
                res.oncanplay = null;
                thiz.nResourcesDone++;
                resolve();
              }
              res.load();
            }
          }
        });
        await promise;
      }
    },
    loadMediasCanplay: function (medias, beginIdx, endIdx) {
      let thiz = this;
      let waitCanplay = true;
      return new Promise(resolve => {
        let nTotal = endIdx - beginIdx;
        let nDone = 0;
        for (let idx = beginIdx; idx < endIdx; idx++) {
          let m = medias[idx];
          console.log('load-media:', idx, m.src, m, m instanceof Audio);
          m.load();
          if (!waitCanplay) {
            thiz.nResourcesDone++;
            nDone++;
            if (nDone == nTotal) {
              console.log('loadMediasCanplay done');
              resolve();
            }
          }
          else {
            if (this.isIPhone) {
              console.log('iphone-media-oncanplay:', idx, m.src);
              thiz.nResourcesDone++;
              nDone++;
              if (nDone == nTotal) {
                console.log('loadMediasCanplay done');
                resolve();
              }
            } else {
              m.oncanplay = function () {
                console.log('media-oncanplay:', idx, m.src);
                thiz.nResourcesDone++;
                nDone++;
                if (nDone == nTotal) {
                  console.log('loadMediasCanplay done');
                  resolve();
                }
                m.oncanplay = null;
              }
            }
          }
        }
      });
    },
    loadImagesCanplay: function (images, beginIdx, endIdx) {
      let thiz = this;
      return new Promise(resolve => {
        let nTotal = endIdx - beginIdx;
        let nDone = 0;
        for (let idx = beginIdx; idx < endIdx; idx++) {
          let img = images[idx];
          console.log('load-img:', idx, img.src, img.prototype);
          if (img.complete) {
            console.log('image-is-complete:', idx, img.src);
            thiz.nResourcesDone++;
            nDone++;
            if (nDone == nTotal) {
              console.log('loadImagesCanplay done');
              resolve();
            }
            continue;
          }
          img.onload = function () {
            console.log('image-onload:', idx, img.src);
            thiz.nResourcesDone++;
            nDone++;
            if (nDone == nTotal) {
              console.log('loadImagesCanplay done');
              resolve();
            }
            img.onload = null;
          }
        }
      });
    },

    //播放课程剧本：逐个场景
    playLessonScript: async function() {
      let tBeginTimestampMillis = Date.now();
      let sceneIdx = -1;
      for (sceneIdx in this.lesson.scenes) {
        this.currentSceneId = sceneIdx;

        // 检查是否需要停止播放
        if (this.bScriptEnded) {
          console.log('播放被中断，停止在场景:', sceneIdx);
          break;
        }

        // Scene切换提示
        console.log(`🎬 开始播放场景 ${parseInt(sceneIdx) + 1}/${this.lesson.scenes.length}\n场景ID: ${sceneIdx}`);

        this.clearCurrentScene();

        this.currentScene = this.lesson.scenes[sceneIdx];
        this.log('scene-'+sceneIdx, this.currentScene);
        await nextTick();

        if(sceneIdx > 0 && !this.bRecord) {
          this.checkStudentStatus().then(r => {
            console.log('checkStudentStatus.then():', r);
          });
        }

        if(this.bStepByStep) {
          await this.waitUserClickNextSceneButton();
          if(!this.bEnterNextStep) {
            continue;
          }
        }

        this.userAsking.userQuestionFlag = false;
        if(this.bAutoPlay && !this.bRecord) {
          this.userAsking.userQuestionFlag = true;
        }

        //play action-groups of current scene
        for (let groupIdx in this.currentScene.groups) {
          // 检查是否需要停止播放
          if (this.bScriptEnded) {
            console.log('播放被中断，停止在场景:', sceneIdx, '组:', groupIdx);
            return;
          }

          // Group切换提示
          console.log(`🎭 开始播放动作组 ${parseInt(groupIdx) + 1}/${this.currentScene.groups.length}\n场景: ${parseInt(sceneIdx) + 1}, 组ID: ${groupIdx}`);

          this.currentGroupId = groupIdx;
          await this.playActionGroup(this.currentScene.groups[groupIdx]);
        }

        //wait scene end
        let bRemove = sceneIdx < this.lesson.scenes.length-1;
        await this.waitSceneEnd(bRemove);

        //用户主动提问
        if(this.userAsking.userQuestionFlag && !this.bRecord) {
          await this.enterUserAskingQuestions();
        }

        //系统主动测试，用户做选择题
        if(this.currentUserAnsweringAction && !this.bRecord) {
          await this.enterUserAnsweringQuestions();
        }

        this.log('scene-'+sceneIdx+' end');
      }

      let elapsedInMillis = Date.now() - tBeginTimestampMillis;
      this.bScriptEnded = true;
      this.log('script end, notify back-end server');

      //通知后端学习完毕
      let notifyData = {
        progressNumerator  : parseInt(sceneIdx)+1,     //学习进度: 分子
        progressDenominator: this.lesson.scenes.length,//学习进度: 分母
        elapsedInMillis: elapsedInMillis               //学习所花的时长（毫秒）
      };
      this.invokeLessonPlayerWebApi('play-end', notifyData, function(res) {
        console.log('play-end-reply', res);
      });
    },

    log: function() {
      // console.log('[scene='+this.currentSceneId+', group='+this.currentGroupId+'] ['+tag+']', str);
    },

    newElementInfo: function(elementId, actionType, exitMode) {
      return {
        elementId: elementId,
        actionType: actionType,
        exitMode: exitMode,
        ended: true,      //eos eog span 结束点标志
        mediaEnded: false, //音视频播放结束标志
        removed: false     //是否已经从界面移除标志
      };
    },

    //切换场景时需要先清理
    clearCurrentScene: function() {
      this.exitElementsInCurrentScene = [];
      this.exitElementsInGroups       = {};
      this.exitElementsOnTimespan     = [];

      // 清理liveWindow边框
      this.clearLiveWindowFrame();

//      let sceneContainer = document.getElementById("sceneContainer");
//      if (sceneContainer) {
//        sceneContainer.innerHTML = "";
//      }

      {
        this.bShowUserAnsweringView = false;//是否需要显示用户被动回答窗口
        this.userAnsweringSourceIdx = -1;
        this.userAnsweringSourceLastClickedIdx = -1;
        this.userAnsweringSource = [];
        this.currentUserAnsweringAction = null; //当前场景下的[用户被动回答的action]
        this.bShowUserAnsweringStatView = false; //是否需要显示用户被动问答后的统计窗口
        this.userAnsweringCorrects = 0;
      }
    },

    //播放场景下的一个action组：具有相同sort的action分为一组
    playActionGroup: async function (group) {
      this.log('group', group);
      let actions = group.actions;
      let maxDelay = 0;
      let robots = [];
      for (let actionIdx in actions) {
        let action = actions[actionIdx];
        console.log('PLAY ACTION: id=', action.actionId, 'type=', action.actionType);
        
        // Action切换提示
        console.log(`🎯 开始执行动作 ${parseInt(actionIdx) + 1}/${actions.length}\n动作ID: ${action.actionId}\n动作类型: ${action.actionType}`);
        
        // 【关键防护】检查是否已存在任何shop元素
        if (action.actionType === 'shop') {
          // 检查DOM中是否已有shop元素（通过查找iframe元素）
          let sceneContainer = document.getElementById("sceneContainer");
          if (sceneContainer) {
            let existingIframes = sceneContainer.querySelectorAll('iframe[data-shop-created="true"]');
            if (existingIframes.length > 0) {
              console.log('🚫🚫🚫 检测到DOM中已存在shop iframe元素，数量:', existingIframes.length, '完全跳过当前shop action！');
              console.log('🚫 已存在的iframe src:', existingIframes[0].src);
              console.log('🚫 当前要创建的shopUrl:', action.shopUrl);
              continue; // 立即跳过，不做任何处理
            }
          }
        }
        
        if (action.actionType === 'qa') { //系统主动测试，学生做选择题
          this.currentUserAnsweringAction = action;
          continue;
        }
        if (action.actionType === 'quesTeacher') {//老师主动提问，学生开放式回答，或者跟AI伴读抢答
          console.log('⚠️ 遇到quesTeacher，跳过当前处理，等待组结束后再执行');
          // 不调用buildActionHtml，避免可能的副作用
          // this.buildActionHtml(action, {});
          continue;
        }
        if (action.actionType === 'quesAudio') {//语音判分，前端流程跟“老师主动提问”相似
          continue;
        }
        if (action.actionType === 'ques' && this.bRecord) {//用户主动提问
          continue;
        }
        if (action.actionType === 'liveWindow' || action.actionType === 'cameraPosition') {//窗口配置类型，不需要创建DOM元素
          continue;
        }

        maxDelay = maxDelay > action.delay ? maxDelay : action.delay;

        let elementId = 'element' + action.actionId;
        let elementInfo;
        let element = this.mediaCache[elementId];
        let bElementExisted = false; // 标记元素是否已存在
        if (element) {
          elementInfo = element.elementInfo;
          bElementExisted = true;
          console.log('⚠️ 元素已存在于mediaCache:', elementId, 'actionType:', action.actionType);
          
          // 如果是shop组件且已存在，直接跳过这个action的处理
          if (action.actionType === 'shop') {
            console.log('🚫 Shop组件已存在且已播放，完全跳过这个action的处理');
            continue; // 跳过后续所有处理
          }
        } else {
          elementInfo = this.newElementInfo(elementId, action.actionType, action.exitMode);
        }

        // 添加action引用，用于数字人裁剪计算
        elementInfo.action = action;
        {
          let hanziCfg = action.hanziConfig || {};
          if (action.actionType === 'hanziWriter' && hanziCfg.quizMode) {
            action.exitMode = 'eog';
            action.exitParam = (group.id != null) ? group.id : action.exitParam;
            elementInfo.ended = false;
          }
          if (action.actionType === 'shop') {
            let bUseCommonLogic = (action.exitMode !== 'eos' && action.exitParam != null && Number(action.exitParam) > 0);
            if (!bUseCommonLogic) {
              if (!action.exitMode || action.exitMode === 'eos') {
                action.exitMode = 'eog';
                action.exitParam = (group.id != null) ? group.id : action.exitParam;
                elementInfo.shopNeedKeepUntilSceneEnd = true;
              } else if (action.exitMode === 'eog') {
                action.exitParam = (group.id != null) ? group.id : action.exitParam;
              }
              elementInfo.ended = false;
            }
          }
        }

        if (!action.exitMode) {
          action.exitMode = 'eos';
        }

        if (action.actionType === 'audio' && action.usedToEnd) {
          action.exitMode = 'endOfScript';
        }

        switch (action.exitMode) {
          case 'eos': //end of scene 本场景结束
            this.exitElementsInCurrentScene.push(elementInfo);
            break;
          case 'eog': //end of group 某个组结束
            if (!this.exitElementsInGroups[action.exitParam])
              this.exitElementsInGroups[action.exitParam] = [];
            this.exitElementsInGroups[action.exitParam].push(elementInfo);
            // 如果是shop组件且需要保留到场景结束，也加入场景结束列表
            if (elementInfo.shopNeedKeepUntilSceneEnd) {
              this.exitElementsInCurrentScene.push(elementInfo);
              console.log('🎬 Shop组件已加入组结束列表（用于解除阻塞）和场景结束列表（用于最终移除）');
            }
            break;
          case 'span': //持续一定时长后结束
            elementInfo.ended = false;
            this.exitElementsOnTimespan.push(elementInfo);
            if (!this.exitElementsInGroups[group.id])
              this.exitElementsInGroups[group.id] = [];
            this.exitElementsInGroups[group.id].push(elementInfo);
            break;
        }

        let actionDomElement = this.buildActionHtml(action, elementInfo);
        if (actionDomElement) {
          // 如果是shop组件且已经存在，不要重复添加到DOM
          if (action.actionType === 'shop' && bElementExisted) {
            console.log('🚫 Shop组件已存在，跳过重复添加');
          } else {
            if (action.delay > 0) {
              setTimeout(async () => {
                await this.appendActionElement(action, elementInfo, actionDomElement);
              }, action.delay * this.delayMultiplier);
            } else {
              await this.appendActionElement(action, elementInfo, actionDomElement);
            }
          }
        } else {
          console.warn('actionDomElement is null, skipping appendActionElement for action:', action.actionId);
        }
        if (action.actionType === 'robot' //孪生数字人
            || action.actionType === 'robot_video' //图片数字人，不执行抠图处理，但需要像robot那样提前loading
            || action.actionType === 'robot_cartoon' //卡通数字人
            || action.actionType === 'keying_video' //待机数字人，实际上是需要抠图的视频
        ) {
          robots.push(elementInfo);
        }
        if (action.actionType === 'ques') { //用户主动提问
          this.userAsking.currentAction = action;
        }
      }

      this.log('this.exitElementsInCurrentScene', this.exitElementsInCurrentScene);
      this.log('this.exitElementsInGroups', this.exitElementsInGroups);
      this.log('this.exitElementsOnTimespan', this.exitElementsOnTimespan);

      if (maxDelay > 0) {
        this.log('group sleep ', maxDelay);
        await sleep(maxDelay * this.delayMultiplier);
      }

      this.log('robots.length = ' + robots.length);
      if (robots.length > 0) {
        this.log('waiting group robots ...', robots);
        await this.waitGroupRobotsEnd(robots);
        this.log('group robots end');
      }

      this.log('waiting group ...');
      await this.waitGroupEnd(group.id);
      this.log('group end');

      if(!this.bRecord) {
        for (let actionIdx in actions) {
          let action = actions[actionIdx];
          if (action.actionType === 'quesTeacher') {//老师主动提问，学生开放式回答，或者跟AI伴读抢答
            if(this.backgroundAudio) {
              this.backgroundAudio.pause();
            }
            this.clearTeacherAsking();
            await this.enterTeacherAsking(action);
            if(this.backgroundAudio) {
              this.backgroundAudio.play().catch(async function (err) {
                console.error('play backgroundAudio-resume1 error:', err, err.name, err.message);
              });
            }
          }
          else if(action.actionType === 'quesAudio') {//语音判分，前端流程跟“老师主动提问”相似
            if(this.backgroundAudio) {
              this.backgroundAudio.pause();
            }
            this.clearOralScoring();
            await this.enterOralScoring(action);
            if(this.backgroundAudio) {
              this.backgroundAudio.play().catch(async function (err) {
                console.error('play backgroundAudio-resume2 error:', err, err.name, err.message);
              });
            }
          }
        }
      }
    },

    appendActionElement: async function (action, elementInfo, actionDomElement) {
      let sceneContainer = document.getElementById("sceneContainer");
      if (!sceneContainer) {
        console.warn('sceneContainer不存在，等待DOM更新后重试');
        await this.$nextTick();
        sceneContainer = document.getElementById("sceneContainer");
        if (!sceneContainer) {
          console.error('sceneContainer仍然不存在，无法添加元素');
          return;
        }
      }
      if(actionDomElement.isAV && elementInfo.frame0Element) {
        sceneContainer.appendChild(elementInfo.frame0Element);
      }
      sceneContainer.appendChild(actionDomElement);
      if(action.actionType === 'hanziWriter') {
        await this.initHanziWriter(action, elementInfo);
      }

      let thiz = this;
      let bKeepBackgroundAudio = false;
      if(actionDomElement.isAV) {
        console.log('appendActionElement.isAV.id=', actionDomElement.id);
        // canvas1相关代码已移除，不再需要抠像处理
        if(elementInfo.idleElement) {
          sceneContainer.appendChild(elementInfo.idleElement);
        }

        if(action.actionType === 'audio' && action.usedToEnd && action.infinityLive) {
          if(this.backgroundAudio) {
            this.backgroundAudio.pause();
          }
          this.backgroundAudio = actionDomElement;
        }

        thiz.addPlayingMedia(actionDomElement.id, actionDomElement);
        actionDomElement.play().catch(async function (err) {
          console.error('play AV error:', err, err.name, err.message, action);
          thiz.removePlayingMedia(actionDomElement.id);
          if(err.name === 'NotAllowedError') {
            actionDomElement.muted = true;
            actionDomElement.play().catch(async function (err) {
              console.error('play AV-muted error:', err, err.name, err.message);
            });
            thiz.mutedMediaElements[elementInfo.elementId] = actionDomElement;
            console.log('play error: try muted');
          } else {
            elementInfo.mediaEnded = true;
          }
        });
        bKeepBackgroundAudio = true;
      }
      else if(action.actionType === 'robot_cartoon') {//卡通数字人
        console.log('appendActionElement.robotCartoon.id=', elementInfo.audio.id, actionDomElement.id);
        bKeepBackgroundAudio = true;
        this.addPlayingMedia(actionDomElement.id, elementInfo.audio);
        elementInfo.audio.play().catch(async function (err) {
          console.error('play robot_cartoon error:', err, err.name, err.message);
          thiz.removePlayingMedia(actionDomElement.id);
        });
        elementInfo.audio.onended = function () {
          thiz.removePlayingMedia(actionDomElement.id);
          actionDomElement.src = action.idleImgUrl;
          elementInfo.mediaEnded = true;
        }
      }

      if(bKeepBackgroundAudio && this.backgroundAudio) {
        console.log('this.backgroundAudio.play()');
        this.backgroundAudio.play().catch(async function (err) {
          console.error('play backgroundAudio error:', err, err.name, err.message);
        });
      }

      if(action.exitMode === 'span') {
        setTimeout(() => {
          elementInfo.ended = true;
          this.removeActionElement(elementInfo);
        }, action.exitParam*this.delayMultiplier);
      }
    },

    removeActionElement: async function (elementInfo) {
      let sceneContainer = document.getElementById("sceneContainer");
      let ele = document.getElementById(elementInfo.elementId);
      
      // 【关键日志】记录shop元素的移除
      if (elementInfo.actionType === 'shop') {
        console.log('🗑️🗑️🗑️ 准备移除Shop元素！', elementInfo.elementId);
        console.log('🗑️ shopNeedKeepUntilSceneEnd:', elementInfo.shopNeedKeepUntilSceneEnd);
        console.log('🗑️ 调用堆栈:', new Error().stack);
      }
      
      if (!sceneContainer) {
        console.warn('sceneContainer不存在，等待DOM更新后重试');
        await this.$nextTick();
        sceneContainer = document.getElementById("sceneContainer");
      }
      
      if (!ele) {
        console.warn('要移除的元素不存在:', elementInfo.elementId);
        await this.$nextTick();
        ele = document.getElementById(elementInfo.elementId);
      }
      
      if(sceneContainer && ele) {
        // 如果是shop元素，在移除前通知iframe清除sessionStorage
        if (elementInfo.actionType === 'shop' && elementInfo.iframeWindow) {
          try {
            elementInfo.iframeWindow.postMessage({ type: 'CLEAR_STORAGE' }, '*');
            console.log('📤 已向iframe发送清除存储的消息');
          } catch (e) {
            console.warn('发送清除存储消息失败:', e);
          }
        }
        
        sceneContainer.removeChild(ele);
        if (elementInfo.actionType === 'shop') {
          console.log('✅ Shop元素已从DOM中移除');
        }
        // canvas1相关代码已移除，不再需要抠像处理
        if(elementInfo.frame0Element) {
          sceneContainer.removeChild(elementInfo.frame0Element);
          elementInfo.frame0Element = null;
        }
        if(elementInfo.idleElement){
//          sceneContainer.removeChild(elementInfo.idleElement);
          elementInfo.idleElement.remove();
          elementInfo.idleElement.pause();
          elementInfo.idleElement = null;
        }
        if (elementInfo.shopHandshakeTimer) { clearInterval(elementInfo.shopHandshakeTimer); elementInfo.shopHandshakeTimer = null; }
        elementInfo.removed = true;
        this.log('remove', elementInfo.elementId);
        delete this.mediaCache[elementInfo.elementId];
        delete this.textCache[elementInfo.elementId];
        delete this.blackboardCache[elementInfo.elementId];
        delete this.mutedMediaElements[elementInfo.elementId];
        if(elementInfo.actionType === 'hanziWriter' && elementInfo.hanziReport) {
          this.notifyHanziQuizResult(elementInfo.hanziReport);
        }
        if (elementInfo.resizeObserver) {
          elementInfo.resizeObserver.disconnect();
          elementInfo.resizeObserver = null;
        }
      }
    },

    onClickUserEnableSound: function () {
      console.log('mutedMediaElements', this.mutedMediaElements);
      for(let eid in this.mutedMediaElements) {
        let e = this.mutedMediaElements[eid];
        if(e) e.muted = false;
      }
      this.mutedMediaElements = [];
    },

    //为action创建对应的html代码
    onUserClickQuestion: async function () {
      this.userAsking.userQuestionFlag = true;

      let btn = document.getElementById('qaTriggerButton');
      if(btn) btn.innerText = '本节结束后回答';

      let img = document.getElementById('qaTriggerImage');
      if(img) img.src = this.channel.userAskTriggerWaitingAnswerImg(this.queries.lessonId);

      let ding = document.createElement('audio');
      ding.src = require('@/assets/ding.mp3');
      ding.play().catch(async function (err) {
        console.error('play ding.mp3 error:', err, err.name, err.message);
      });

      if (this.bScriptEnded) {
        await this.enterUserAskingQuestions();
      }
    },
    ensureHanziWriterScript: function() {
      return new Promise(resolve => {
        if(window.HanziWriter) {
          resolve();
          return;
        }
        let id = 'hanzi-writer-cdn';
        let s = document.getElementById(id);
        if(s) {
          s.onload = function(){ resolve(); };
          return;
        }
        s = document.createElement('script');
        s.id = id;
        s.src = 'https://cdn.jsdelivr.net/npm/hanzi-writer@3.7/dist/hanzi-writer.min.js';
        s.onload = function(){ resolve(); };
        document.head.appendChild(s);
      });
    },
    initHanziWriter: async function(action, elementInfo) {
      await this.ensureHanziWriterScript();
      let root = document.getElementById(elementInfo.elementId);
      let leftPane = document.getElementById(elementInfo.elementId+'-hw');
      if(!root || !leftPane) return;
      let cfg = action.hanziConfig || {};
      let sizeW = (cfg.width != null) ? cfg.width : ((action.style && action.style.width) ? action.style.width : 220);
      let sizeH = (cfg.height != null) ? cfg.height : ((action.style && action.style.height) ? action.style.height : 220);
      let size = Math.max(50, Math.min(sizeW, sizeH));
      let inner = document.createElement('div');
      inner.id = elementInfo.elementId + '-hw-inner';
      inner.style = 'width:'+ (cfg.width || size) +'px; height:'+ (cfg.height || size) +'px;';
      leftPane.appendChild(inner);

      let writer = window.HanziWriter.create(inner.id, cfg.character || action.character || '', {
        width: cfg.width || size,
        height: cfg.height || size,
        padding: cfg.padding != null ? cfg.padding : 20,
        strokeColor: cfg.strokeColor || '#555',
        radicalColor: cfg.radicalColor || '#555',
        outlineColor: cfg.outlineColor || '#DDD',
        showOutline: cfg.showOutline != null ? cfg.showOutline : true,
        showCharacter: cfg.showCharacter != null ? cfg.showCharacter : true,
        highlightColor: cfg.highlightColor || '#AAF',
        highlightOnComplete: cfg.highlightOnComplete != null ? cfg.highlightOnComplete : true,
        strokeAnimationSpeed: cfg.strokeAnimationSpeed != null ? cfg.strokeAnimationSpeed : 1,
        delayBetweenStrokes: cfg.delayBetweenStrokes != null ? cfg.delayBetweenStrokes : 1000,
        delayBetweenLoops: cfg.delayBetweenLoops != null ? cfg.delayBetweenLoops : undefined
      });
      elementInfo.hanziWriter = writer;
      
      // Add ResizeObserver to handle container resizing
      if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            const { width, height } = entry.contentRect;
            if (width > 0 && height > 0) {
              const newSize = Math.min(width, height);
              // Only resize if the size has changed significantly (avoid jitter)
              if (Math.abs(newSize - (elementInfo.lastHanziSize || size)) > 1) {
                elementInfo.lastHanziSize = newSize;
                inner.style.width = newSize + 'px';
                inner.style.height = newSize + 'px';
                if (writer.updateDimensions) {
                  writer.updateDimensions({ width: newSize, height: newSize });
                }
              }
            }
          }
        });
        resizeObserver.observe(leftPane);
        elementInfo.resizeObserver = resizeObserver;
      }

      elementInfo.hanziReport = {correct:0, incorrect:0, miss:0, status:'进行中'};
      let updateReport = function() {
        let c = document.getElementById(elementInfo.elementId+'-r-correct');
        let m = document.getElementById(elementInfo.elementId+'-r-miss');
        let s = document.getElementById(elementInfo.elementId+'-r-status');
        if(c) c.innerText = '正确：'+elementInfo.hanziReport.correct;
        if(m) m.innerText = '失误：'+elementInfo.hanziReport.miss;
        let statusText = elementInfo.hanziReport.status;
        if(statusText === 'running') statusText = '进行中';
        if(statusText === 'completed') statusText = '已完成';
        if(s) s.innerText = '状态：'+statusText;
      };
      if(cfg.quizMode) {
        writer.quiz({
          showHintAfterMisses: cfg.showHintAfterMisses != null ? cfg.showHintAfterMisses : 3,
          leniency: cfg.leniency != null ? cfg.leniency : 1,
          quizStartStrokeNum: cfg.quizStartStrokeNum != null ? cfg.quizStartStrokeNum : 0,
          markStrokeCorrectAfterMisses: cfg.markStrokeCorrectAfterMisses != null ? cfg.markStrokeCorrectAfterMisses : 3,
          acceptBackwardsStrokes: cfg.acceptBackwardsStrokes != null ? cfg.acceptBackwardsStrokes : false,
          drawingColor: cfg.drawingColor || '#333',
          drawingWidth: cfg.drawingWidth != null ? cfg.drawingWidth : 4,
          highlightColor: (cfg.highlightColor || '#AAF'),
          highlightOnComplete: cfg.highlightOnComplete != null ? cfg.highlightOnComplete : true,
          strokeHighlightSpeed: cfg.strokeHighlightSpeed != null ? cfg.strokeHighlightSpeed : 2,
          onCorrectStroke: () => { elementInfo.hanziReport.correct++; updateReport(); },
          onIncorrectStroke: () => { elementInfo.hanziReport.incorrect++; updateReport(); },
          onMistake: () => { elementInfo.hanziReport.miss++; updateReport(); },
          onComplete: () => { elementInfo.hanziReport.status = '已完成'; updateReport(); let delay = (cfg.onCompleteExitDelay != null ? cfg.onCompleteExitDelay : 1500); setTimeout(() => { elementInfo.ended = true; this.removeActionElement(elementInfo); }, delay); }
        });
      } else {
        if(cfg.loopAnimation) {
          writer.loopCharacterAnimation();
        } else if(cfg.autoAnimate) {
          writer.animateCharacter();
        }
      }
    },
    notifyHanziQuizResult: function(report) {
      console.log('hanziQuizReport', report);
    },

  buildActionHtml: function(action, elementInfo) {
      //make style
      let actionStyle = "";
      let left, top, width, height;
      if(action.style) {
        actionStyle = "position:absolute;";
        for(let k in action.style) {
          let name = convertCamelToKebab(k);
          let value = action.style[k];
          if(k === 'left') {
            left = (value / this.lesson.resolution.width) * 100;
          }
          else if(k === 'top') {
            top = (value / this.lesson.resolution.height) * 100;
          }
          else if(k === 'width') {
            width = (value / this.lesson.resolution.width) * 100;
          }
          else if(k === 'height') {
            height = (value / this.lesson.resolution.height) * 100;
          }
          else if(k !== 'color') {
            actionStyle += name+":"+value+";";
          }
        }
        if(action.actionType === 'blackboard') {
          {
            let cache = {};
            cache['baseWidth'] = width;
            cache['baseHeight'] = height;
            this.blackboardCache[elementInfo.elementId] = cache;
          }
          // let ratio = this.surface.width/this.lesson.resolution.width;
          // actionStyle += "transform:scale("+(ratio)+");";
          // actionStyle += "transform-origin:left top;";
          // let ratio2 = this.lesson.resolution.width/this.surface.width;
          // width  *= ratio2;
          // height *= ratio2;
        }
        if(left  ) actionStyle += 'left:'  +left  +"%;";
        if(top   ) actionStyle += 'top:'   +top   +"%;";
        if(width ) actionStyle += 'width:' +width +"%;";
        if(height) actionStyle += 'height:'+height+"%;";
      }
      if (action.font) {
        for(let k in action.font) {
          let name = convertCamelToKebab(k);
          let value = action.font[k];
          if(k === 'fontSize') {
//            let n = parseFloat(value) / this.lesson.resolution.width * 100; //good
//            value = n+"vw";
            let n = parseFloat(value) / this.lesson.resolution.width;
            this.textCache[elementInfo.elementId] = n;
            n = n * this.surface.width;
            value = n+"px";
          }
          else if(k === 'lineHeight') {
            if(value.endsWith('px')) {
              let s = value.substring(0, value.length-2);
              let n = parseFloat(s) / this.lesson.resolution.width * 100; //good
              value = n+"vw";
            }
          }

          else if(k === 'bold') {
            name = 'font-weight';
          } else if(k === 'italic') {
            name = 'font-style';
          } else if(k === 'underline') {
            name = 'text-decoration';
          } else if(k === 'center') {
            name = 'text-align';
          }

          else if(k === 'text' && action.actionType === 'text') {
            action.text = value;
            continue;
          }
          actionStyle += name+":"+value+";";
        }
      }

      //make element
      let self = this;
      let href;
      let element;
      switch (action.actionType) {
        case 'blackboard':
          href = action.href;
          element = document.createElement('div');
//          element.innerHTML = action.html;
          element.innerHTML = marked(action.html);
          window.MathJax.typesetPromise([element])
          break;
        case 'shop':
        {
          let useSpecialShopLogic = (action.exitMode === 'eos') || !(action.exitParam != null && Number(action.exitParam) > 0);
          // 检查是否已经有shop元素存在
          let existingShopElement = document.getElementById(elementInfo.elementId);
          if (existingShopElement) {
            console.log('🚫 Shop元素已存在于DOM中，直接返回已存在的元素:', elementInfo.elementId);
            return existingShopElement;
          }
          
          let container = document.createElement('div');
          let iframe = document.createElement('iframe');
          iframe.src = action.shopUrl;
          iframe.setAttribute('allow', 'autoplay; microphone; camera; fullscreen; encrypted-media');
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.setAttribute('frameborder', '0');
          iframe.style = 'position:absolute;left:0;top:0;width:100%;height:100%';
          iframe.setAttribute('data-shop-created', 'true'); // 标记这个iframe已创建
          console.log('🎬 创建新的shop iframe元素:', action.shopUrl);

          if (elementInfo) {
            if (useSpecialShopLogic) {
              elementInfo.ended = false;
              elementInfo.shopAnimationFinished = false;
            }
            elementInfo.iframe = iframe;
            elementInfo.iframeWindow = null;
          }

          // 若未提供尺寸样式，默认充满舞台区域
          if (!action.style) {
            actionStyle += 'position:absolute;left:0;top:0;width:100%;height:100%;z-index:7777;pointer-events:auto;';
          } else {
            actionStyle += 'z-index:7777;pointer-events:auto;';
          }

          const onMessage = (ev) => {
            const sameSource = !!(elementInfo && elementInfo.iframeWindow && ev.source === elementInfo.iframeWindow);
            let sameOrigin = false;
            try { sameOrigin = new URL(action.shopUrl, window.location.href).origin === ev.origin; } catch(e) {}
            if (!sameSource && !sameOrigin) { return; }
            try {
              const data = ev && ev.data;
              if (data && data.type === 'ANIMATION_FINISHED') {
                console.log('✅ 收到 ANIMATION_FINISHED');
                if (data.screenshot) { 
                  self.pendingNextAskScreenshot = data.screenshot;
                  
                  // 【新增】用截图替换iframe，彻底移除iframe
                  console.log('🖼️ 开始用截图替换iframe');
                  try {
                    // 创建img元素
                    let placeholderImg = document.createElement('img');
                    placeholderImg.src = data.screenshot;
                    placeholderImg.style = 'position:absolute;left:0;top:0;width:100%;height:100%;object-fit:contain;';
                    placeholderImg.setAttribute('data-shop-placeholder', 'true');
                    
                    // 彻底移除iframe（使命已完成）
                    if (container.contains(iframe)) {
                      container.removeChild(iframe);
                      console.log('🗑️ iframe已从container中移除');
                    }
                    
                    // 将截图插入到container中
                    container.appendChild(placeholderImg);
                    
                    // 保存截图元素的引用，清除iframe引用
                    if (elementInfo) {
                      elementInfo.placeholderImg = placeholderImg;
                      elementInfo.iframe = null;
                    }
                    
                    console.log('✅ 截图已替换iframe，iframe已彻底移除');
                  } catch (err) {
                    console.error('❌ 替换iframe失败:', err);
                  }
                }
                if (elementInfo) {
                  elementInfo.shopAnimationFinished = true;
                  elementInfo.ended = true;
                }
                window.removeEventListener('message', onMessage);
                if (elementInfo) {
                  elementInfo.iframeWindow = null;
                }
                setTimeout(() => {}, 100);
              } else if (data && (data.type === 'REQUEST_PARENT_READY' || data.type === 'NEED_PARENT_READY')) {
                if (!elementInfo || elementInfo.shopAnimationFinished) {
                  return;
                }
                try {
                  if (elementInfo.iframeWindow) {
                    elementInfo.iframeWindow.postMessage({ type: 'PARENT_READY' }, '*');
                  }
                } catch (e) {}
              }
            } catch (e) {}
          };
          window.addEventListener('message', onMessage);

          let ua = navigator.userAgent || '';
          let isIOS = /(iPad|iPhone|iPod)/.test(ua) && !window.MSStream;
          let isMobile = /Mobile|Android/.test(ua) || isIOS;
          if (isMobile && useSpecialShopLogic) {
            let overlay = document.createElement('div');
            overlay.style = 'position:absolute;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.3);color:#fff;font-size:16px;cursor:pointer;z-index:1';
            overlay.innerText = '点击开启声音';
            overlay.onclick = function () {
              if (elementInfo && !elementInfo.shopAnimationFinished && elementInfo.iframeWindow) {
                try { 
                  elementInfo.iframeWindow.postMessage({ type: 'enable-sound' }, '*'); 
                } catch (e) { void e }
              }
              overlay.style.display = 'none';
            };
            container.appendChild(overlay);
          }

          // iframe加载完成后
          iframe.onload = function () {
            console.log('📦 iframe加载完成');
            // 保存contentWindow引用
            if (elementInfo) {
              try {
                elementInfo.iframeWindow = iframe.contentWindow;
              } catch (e) {
                console.error('无法获取iframe.contentWindow:', e);
              }
            }
            if (elementInfo && elementInfo.iframeWindow) {
              try {
                elementInfo.iframeWindow.postMessage({ type: 'CLEAR_STORAGE' }, '*');
                console.log('📤 发送清理存储消息');
              } catch (e) {
                console.error('发送清理存储失败:', e);
              }
            }
            // 发送初始握手消息
            if (useSpecialShopLogic && elementInfo && !elementInfo.shopAnimationFinished && elementInfo.iframeWindow) {
              try {
                elementInfo.iframeWindow.postMessage({ type: 'PARENT_READY' }, '*');
                console.log('📤 发送初始握手消息');
              } catch (e) {
                console.error('发送初始握手失败:', e);
              }
            }
          };

          // 完全移除定时器机制！
          // 只通过被动响应iframe的REQUEST_PARENT_READY来发送PARENT_READY
          // 这样可以避免主动发送消息导致的任何问题
          console.log('🎯 采用被动响应模式，不使用定时器');

          container.appendChild(iframe);
          element = container;
          break;
        }
        case 'material':
        case 'image':
          element = this.mediaCache[elementInfo.elementId];
          if (!element) {
            console.warn('mediaCache element not found for elementId:', elementInfo.elementId);
            return null;
          }
          href = action.href;
          break;
        case 'text':
          element = document.createElement('div');
          element.innerText = action.text;
          href = action.href;
          break;
        case 'aside':
        case 'audio':
          element = this.mediaCache[elementInfo.elementId];
          if (!element) {
            console.warn('mediaCache element not found for elementId:', elementInfo.elementId);
            return null;
          }
          console.log('audio action volume=',action.volume);
          if(action.volume) {
            console.log('audio action change volume');
            element.volume = action.volume/100;
          }
          console.log('audio element volume=',element.volume);
          element.style.display = '';
          element.onended = function () {
            if(action.usedToEnd && action.infinityLive) {
              element.play().catch(async function (err) {
                console.error('play backgroundAudio loop-again error:', err, err.name, err.message);
              });
            } else {
              self.removePlayingMedia(elementInfo.elementId);
              elementInfo.mediaEnded = true;
            }
          }
          element.isAV = true;
          break;
        case 'robot':        //孪生数字人
        case 'robot_video':  //图片数字人，不执行抠图处理，但需要像robot那样提前loading
        case 'video':        //普通视频
        case 'keying_video': //待机数字人，实际上是需要抠图的视频
            // 移除bKeying参数设置，不再需要抠图处理
          href = action.href;
          element = this.mediaCache[elementInfo.elementId];
          if (!element) {
            console.warn('mediaCache element not found for elementId:', elementInfo.elementId);
            return null;
          }
          if(action.volume != null) element.volume = action.volume/100;
          element.style.display = '';
          element.isAV = true;
          if(width >= 80) {
            element.controls = 'controls';
          }
          element.onended = function () {
            console.log('videotime: onended ', element.id);
            elementInfo.mediaEnded = true;
            self.removePlayingMedia(elementInfo.elementId);
//          self.playRobotIdleVideo(action, element, elementInfo);
          }
          element.addEventListener('before-ended', async ()=>{
            console.log('videotime: on-before-ended ', element.id);

            // 检查是否是当前场景的最后一个robot视频
            let lastRobotAction = this.getLastRobotActionInCurrentScene();
            if (lastRobotAction && action === lastRobotAction) {
              console.log('🎬 检测到当前场景最后一个robot视频即将结束');

              // 获取下一个场景的索引
              let currentSceneIndex = this.lesson.scenes.indexOf(this.currentScene);
              let nextSceneIndex = currentSceneIndex + 1;

              if (nextSceneIndex < this.lesson.scenes.length) {
                console.log('🎬 开始预加载下一场景的数字人视频, nextSceneIndex:', nextSceneIndex);
                // 预加载下一场景的第一个数字人视频
                await this.preloadNextSceneRobotVideo(nextSceneIndex);
              } else {
                console.log('🎬 已经是最后一个场景，无需预加载');
              }
            }

            this.playRobotIdleVideo(action, element, elementInfo);
          }, {once: true});
          break;
        case 'robot_cartoon': //卡通数字人
          element = this.mediaCache[elementInfo.elementId];
          if (!element) {
            console.warn('mediaCache element not found for elementId:', elementInfo.elementId);
            return null;
          }
          href = action.href;
          break;
        case 'hanziWriter':
          element = document.createElement('div');
          actionStyle += 'overflow:visible;';
          {
            let leftPane = document.createElement('div');
            leftPane.id = elementInfo.elementId + '-hw';
            leftPane.style = 'position:absolute;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;';
            element.appendChild(leftPane);
          }
          break;
        case 'ques': //用户主动提问
          element = document.createElement('div');
          actionStyle += 'cursor:pointer; display: flex; justify-content: center';
          element.innerHTML = `
            <img id="qaTriggerImage" src="${this.channel.userAskTriggerWantToAskImg(this.queries.lessonId)}"
             style="position: absolute; height:100%">
            <div style="position: absolute; width:63%;height:63%; border-radius: 9999px;overflow: hidden;">
                <img src="`+action.robotUrl+`" style="width: 100%; display: inline-block; overflow: auto;">
            </div>
            `;
          element.onclick = this.onUserClickQuestion;
          break;
        case 'animation': //动画组件
          element = document.createElement('div');
          actionStyle += 'display: flex;align-items: center;justify-content: center;';
          element.innerHTML = action.html;
          href = action.href;
          break;
        case 'quesTeacher': //老师主动提问，学生开放式回答，或者跟AI伴读抢答
          console.log('buildActionHtml of quesTeacher');
          if(action.teacherQuestionAudio) {
            console.log('appendChild(action.teacherQuestionAudio)');
            document.body.appendChild(action.teacherQuestionAudio);
          }
          if(action.aiMateAnswerAudio) {
            console.log('appendChild(action.aiMateAnswerAudio)');
            document.body.appendChild(action.aiMateAnswerAudio);
          }
          return;
        case 'liveWindow': //数字人显示窗口配置
          console.log('buildActionHtml of liveWindow, config:', action);
          // liveWindow配置不需要创建DOM元素，只是配置数据
          return null;
        case 'cameraPosition': //摄像头位置配置
          console.log('buildActionHtml of cameraPosition, config:', action);
          // cameraPosition配置不需要创建DOM元素，只是配置数据
          return null;
        default:
          console.warn('未知的actionType，无法创建element:', action.actionType);
          return null;
      }

      element.id = elementInfo.elementId;
      element.style = actionStyle;

      // 数字人按原本坐标显示，不再强制约束到窗口内

      // 对于数字人元素应用liveWindow裁剪 - 使用与老师提问相同的逻辑
      let currentLiveWindow = this.getCurrentSceneLiveWindow();
      if(currentLiveWindow && (action.actionType === 'robot' || action.actionType === 'robot_video' || action.actionType === 'keying_video' || action.actionType === 'robot_cartoon')) {
        console.log('Applying clip for digital human element:', action.actionType);

        // 计算裁剪信息
        let clippingInfo = this.calculateDigitalHumanClipping(action);
        if (clippingInfo && clippingInfo.hasOverlap) {
          // 先设置基本的位置和尺寸（保持原始样式）
          element.style = actionStyle;

          // 然后再应用CSS clip-path进行裁剪（与老师提问逻辑一致）
          let clipPath = `inset(${clippingInfo.clipPercent.top}% ${100 - clippingInfo.clipPercent.left - clippingInfo.clipPercent.width}% ${100 - clippingInfo.clipPercent.top - clippingInfo.clipPercent.height}% ${clippingInfo.clipPercent.left}%)`;
          element.style.clipPath = clipPath;
          element.style.webkitClipPath = clipPath;

          console.log('应用数字人容器裁剪 - 先调整尺寸位置再裁剪:', {
            clipPath: clipPath,
            clippingInfo: clippingInfo
          });
        } else {
          element.style = actionStyle;
          let minWidthPercent = (1 / this.lesson.resolution.width) * 100;
          let minHeightPercent = (1 / this.lesson.resolution.height) * 100;
          element.style.width = minWidthPercent + '%';
          element.style.height = minHeightPercent + '%';
          element.style.clipPath = 'none';
          element.style.webkitClipPath = 'none';
        }

        this.showLiveWindowFrame();
      } else {
        // 没有liveWindow或不是数字人类型，使用原始样式
        element.style = actionStyle;
      }

      // 设置淡入效果
      element.onplay = function () {
        if(action.fadeIn) {
          element.setAttribute('class', 'fadein-box');
        }
      }

      if(elementInfo.idleElement) {
        elementInfo.idleElement.style = actionStyle;
        elementInfo.idleElement.style.display = 'none';

        // 对于待机视频也要应用liveWindow裁剪 - 使用与老师提问相同的逻辑
          if(currentLiveWindow && (action.actionType === 'robot' || action.actionType === 'robot_video' || action.actionType === 'keying_video' || action.actionType === 'robot_cartoon')) {
            console.log('Applying clip for idle element:', action.actionType);

            // 计算裁剪信息并应用到idle元素
            let clippingInfo = this.calculateDigitalHumanClipping(action);
            if (clippingInfo && clippingInfo.hasOverlap) {
              // 先设置基本的位置和尺寸（保持原始样式）
              elementInfo.idleElement.style = actionStyle;
              elementInfo.idleElement.style.display = 'none';

              // 然后再应用CSS clip-path进行裁剪（与老师提问逻辑一致）
              let clipPath = `inset(${clippingInfo.clipPercent.top}% ${100 - clippingInfo.clipPercent.left - clippingInfo.clipPercent.width}% ${100 - clippingInfo.clipPercent.top - clippingInfo.clipPercent.height}% ${clippingInfo.clipPercent.left}%)`;
              elementInfo.idleElement.style.clipPath = clipPath;
              elementInfo.idleElement.style.webkitClipPath = clipPath;

              console.log('应用idle元素裁剪 - 先调整尺寸位置再裁剪:', {
                clipPath: clipPath,
                clippingInfo: clippingInfo
              });
            } else {
              elementInfo.idleElement.style = actionStyle;
              elementInfo.idleElement.style.display = 'none';
              let minWidthPercent = (1 / this.lesson.resolution.width) * 100;
              let minHeightPercent = (1 / this.lesson.resolution.height) * 100;
              elementInfo.idleElement.style.width = minWidthPercent + '%';
              elementInfo.idleElement.style.height = minHeightPercent + '%';
              elementInfo.idleElement.style.clipPath = 'none';
              elementInfo.idleElement.style.webkitClipPath = 'none';
            }

            this.showLiveWindowFrame();
          }
      }

      if(href) {
        element.style.cursor = 'pointer';
        element.onclick = ()=>{
          // 检查是否为特殊的方法调用href
          if(href === '--camera') {
            console.log('调用camera方法');
            this.camera();
            return;
          }
          if(href === '--list') {
            console.log('调用list方法');
            this.list();
            return;
          }
          if(href === '--option') {
            console.log('调用option方法');
            this.option();
            return;
          }
          if(href === '--question') {
            console.log('调用question方法');
            this.question();
            return;
          }
          if(href === '--back') {
            console.log('调用back方法');
            window.history.back();
            return;
          }

          // 原有的href跳转逻辑
          let url1 = window.location.href;
          let url2 = href;
          let idx1 = url1.indexOf('#');
          let idx2 = url2.indexOf('#');
          if(idx1>0) url1 = url1.substring(0, idx1);
          if(idx2>0) url2 = url2.substring(0, idx2);
          if(url1 == url2)
            window.location.reload()
          else
            window.location.href = href;
        }
      }

      return element;
    },

    playRobotIdleVideo: function (action, element, elementInfo) {
      if(elementInfo.idleElement && action.wait) { //播完 && 待机
        // 使用新的过渡效果替代简单的fadeoutin-box
        this.transitionBetweenVideos(element, elementInfo.idleElement, {
          crossfadeDuration: 0.2, // 交叉时长0.2秒
          brightnessStability: 0.3, // 亮度稳定强度0.3
          colorMatching: 0.55 // 色彩匹配强度0.55
        }).catch(err => {
          console.error('视频过渡失败，使用备用方案:', err);
          // 备用方案：使用原来的简单切换
          elementInfo.idleElement.setAttribute('class', 'fadeoutin-box');
          element.style.display = 'none';
          elementInfo.idleElement.style.display = '';
          elementInfo.idleElement.play().catch(async function (err) {
            console.error('play idleElement error:', err, err.name, err.message);
          });
        });
      }
    },

    // 视频无缝过渡方法 - 从demo.html移植
    transitionBetweenVideos: async function(currentVideo, nextVideo, options = {}) {
      const {
        crossfadeDuration = 0.2,
        brightnessStability = 0.3,
        colorMatching = 0.55
      } = options;

      console.log('开始视频过渡:', {
        from: currentVideo.src,
        to: nextVideo.src,
        crossfadeDuration,
        brightnessStability,
        colorMatching
      });

      try {
        // 1) 采样当前视频末尾帧的统计
        const currentStats = this.sampleVideoStats(currentVideo);

        // 2) 准备下一个视频并采样首帧统计
        nextVideo.currentTime = 0.01;
        await this.waitVideoSeek(nextVideo);
        const nextStats = this.sampleVideoStats(nextVideo);

        // 3) 计算并应用固定滤镜到下一个视频
        const filterStr = this.computeVideoFilter(currentStats, nextStats, brightnessStability, colorMatching);
        nextVideo.style.filter = filterStr;

        // 4) 开始播放下一个视频
        await nextVideo.play();

        // 5) 执行交叉淡入淡出动画
        await this.performCrossfadeAnimation(currentVideo, nextVideo, crossfadeDuration);

        // 6) 清理：暂停当前视频，重置样式
        currentVideo.pause();
        currentVideo.style.opacity = '1';
        nextVideo.style.opacity = '1';
        nextVideo.style.filter = 'none';

        console.log('视频过渡完成');

      } catch (error) {
        console.error('视频过渡过程中出错:', error);
        throw error;
      }
    },

    // 采样视频统计信息
    sampleVideoStats: function(video) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 64;
      canvas.height = 36;

      try {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        let totalR = 0, totalG = 0, totalB = 0;
        let totalH = 0, totalS = 0, totalL = 0;
        const pixelCount = canvas.width * canvas.height;

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i] / 255;
          const g = data[i + 1] / 255;
          const b = data[i + 2] / 255;

          totalR += r;
          totalG += g;
          totalB += b;

          // 转换为HSL
          const max = Math.max(r, g, b);
          const min = Math.min(r, g, b);
          const l = (max + min) / 2;

          let h = 0, s = 0;
          if (max !== min) {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
              case r: h = (g - b) / d + (g < b ? 6 : 0); break;
              case g: h = (b - r) / d + 2; break;
              case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
          }

          totalH += h;
          totalS += s;
          totalL += l;
        }

        return {
          avgR: totalR / pixelCount,
          avgG: totalG / pixelCount,
          avgB: totalB / pixelCount,
          avgH: totalH / pixelCount,
          avgS: totalS / pixelCount,
          avgL: totalL / pixelCount
        };
      } catch (error) {
        console.warn('采样视频统计失败:', error);
        return {
          avgR: 0.5, avgG: 0.5, avgB: 0.5,
          avgH: 0, avgS: 0, avgL: 0.5
        };
      }
    },

    // 计算视频滤镜
    computeVideoFilter: function(currentStats, nextStats, brightnessStability, colorMatching) {
      // 亮度调整
      const currentBrightness = (currentStats.avgR + currentStats.avgG + currentStats.avgB) / 3;
      const nextBrightness = (nextStats.avgR + nextStats.avgG + nextStats.avgB) / 3;
      const brightnessDiff = currentBrightness - nextBrightness;
      const brightnessAdjust = 1 + (brightnessDiff * brightnessStability);

      // 色相调整
      const hueDiff = (currentStats.avgH - nextStats.avgH) * 360;
      const hueAdjust = hueDiff * colorMatching;

      // 饱和度调整
      const saturationDiff = currentStats.avgS - nextStats.avgS;
      const saturationAdjust = 1 + (saturationDiff * colorMatching * 0.5);

      return `brightness(${brightnessAdjust.toFixed(3)}) hue-rotate(${hueAdjust.toFixed(1)}deg) saturate(${saturationAdjust.toFixed(3)})`;
    },

    // 等待视频seek完成
    waitVideoSeek: function(video) {
      return new Promise((resolve) => {
        const onSeeked = () => {
          video.removeEventListener('seeked', onSeeked);
          resolve();
        };
        video.addEventListener('seeked', onSeeked);
        // 设置超时防止卡死
        setTimeout(resolve, 100);
      });
    },

    // 执行交叉淡入淡出动画
    performCrossfadeAnimation: function(currentVideo, nextVideo, duration) {
      return new Promise((resolve) => {
        const startTime = performance.now();
        const durationMs = duration * 1000;

        // S曲线缓动函数
        const easeInOutCubic = (t) => {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / durationMs, 1);
          const easedProgress = easeInOutCubic(progress);

          // 设置透明度
          nextVideo.style.opacity = easedProgress.toString();
          currentVideo.style.opacity = (1 - easedProgress).toString();

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            resolve();
          }
        };

        // 初始化透明度
        nextVideo.style.opacity = '0';
        currentVideo.style.opacity = '1';
        nextVideo.style.display = '';

        requestAnimationFrame(animate);
      });
    },

    addPlayingMedia: function (id, av) {
      this.playingMedias[id] = av;
    },
    removePlayingMedia: function (id) {
      delete this.playingMedias[id];
    },
    pausePlayingMedias: function() {
      for(let k in this.playingMedias) {
        this.playingMedias[k].pause();
      }
    },
    resumePlayingMedias: function() {
      for(let k in this.playingMedias) {
        this.playingMedias[k].play();
      }
    },

    // timerCallback函数已移除，不再需要canvas抠像处理

    // computeFrameWasm函数已移除，不再需要canvas抠像处理

    waitGroupRobotsEnd: async function(robotElementInfos) {
      return new Promise(resolve => {
        this.log('begin group robots timer');
        this.log(robotElementInfos);
        let timer = setInterval(()=> {
          this.log(' group robots timer ...')
          if(!this.checkIfElementsEnded(robotElementInfos)) {
            return;
          }
          clearInterval(timer);
          resolve();
          this.log('end group robots timer');
        }, 100);
      });
    },

    // computeFramePureJS函数已移除，不再需要canvas抠像处理

    waitGroupEnd: async function (groupId) {
      return new Promise(resolve => {
        this.log('begin group timer');
        let timer = setInterval(()=> {
          for(let grpId in this.exitElementsInGroups) {
            if(grpId > groupId)
              continue;
            if(!this.checkIfElementsEnded(this.exitElementsInGroups[grpId])) {
              return;
            }
            // 移除组内元素，但跳过需要保留到场景结束的shop组件
            this.removeElements(this.exitElementsInGroups[grpId], true);
            this.exitElementsInGroups[grpId] = [];
          }
          clearInterval(timer);
          resolve();
          this.log('end group timer');
        }, 100);
      });
    },

    checkIfElementsEnded: function (elementInfos) {
      if(!elementInfos)
        return true;
      for (let idx in elementInfos) {
        let element = elementInfos[idx];
        if(element.removed)
          continue;
        if(this.isMediaActionType(element.actionType)) {
          if(!element.mediaEnded) {
            return false;
          }
        }
        else if(!element.ended) {
          return false;
        }
      }
      return true;
    },
    removeElements: function (elementInfos, skipShopKeepUntilSceneEnd = false) {
      if(!elementInfos)
        return;
      for (let idx in elementInfos) {
        let element = elementInfos[idx];
        if(element.removed)
          continue;
        // 如果是需要保留到场景结束的shop组件，且当前是组结束调用，则跳过移除
        if(skipShopKeepUntilSceneEnd && element.shopNeedKeepUntilSceneEnd) {
          console.log('🎬 Shop组件iframe已播放完成，解除阻塞但保留显示，等待场景结束');
          continue;
        }
        this.removeActionElement(element);
      }
    },
    waitSceneEnd: async function (bRemoveElements) {
      return new Promise(resolve => {
        this.log('begin scene timer');
        let timer = setInterval(()=>{

          if(!this.checkIfElementsEnded(this.exitElementsInCurrentScene))
            return;

          for(let k in this.exitElementsInGroups) {
            if(!this.checkIfElementsEnded(this.exitElementsInGroups[k]))
              return;
          }

          if(!this.checkIfElementsEnded(this.exitElementsOnTimespan))
            return;

          clearInterval(timer);

          if(bRemoveElements) {
            // 移除场景结束时的元素（包括shop组件，因为它应该在场景结束时移除）
            this.removeElements(this.exitElementsInCurrentScene);
            this.exitElementsInCurrentScene = [];

            // 移除组结束时的元素，但跳过需要保留到场景结束的shop组件
            for(let k in this.exitElementsInGroups) {
              this.removeElements(this.exitElementsInGroups[k], true); // 传递true，跳过shop
              this.exitElementsInGroups[k] = [];
            }

            this.removeElements(this.exitElementsOnTimespan);
            this.exitElementsOnTimespan = [];
          }

          this.log('end scene timer');

          // 执行场景切换时的数字人视频过渡
          if (this.nextSceneVideoInfo && this.nextSceneVideoInfo.preloaded) {
            console.log('🎬 场景结束，执行数字人视频过渡');
            this.performSceneTransition().then(() => {
              resolve();
            }).catch((error) => {
              console.error('❌ 场景切换视频过渡失败:', error);
              resolve(); // 即使过渡失败也要继续
            });
          } else {
            resolve();
          }
        }, 100);
      });
    },

    //系统主动测试，用户做选择题
    enterUserAnsweringQuestions: async function() {
      console.log("enterUserAnsweringQuestions");
      return new Promise(resolve => {
        this.bShowUserAnsweringView = true;
        let thiz = this;

        this.enterUserAnsweringQuestionsInner();

        let timer = setInterval(()=>{
          if(thiz.bShowUserAnsweringView === false) {
            clearInterval(timer);
            resolve();
            thiz.log("End User Answering");
          }
        }, 1000);
      });
    },
    enterUserAnsweringQuestionsInner: function () {
      let param = {
        section: this.currentUserAnsweringAction.sections
      };
      let thiz = this;
      this.invokeLessonPlayerWebApi('fetch-answering-questions', param, function(res) {
        console.log(res);
        let reply = JSON.parse(res.data.data);
        console.log('fetch-answering-questions.reply', reply);
        if(reply && reply.length > 0) {
          thiz.userAnsweringSource = reply;
          thiz.userAnsweringSourceIdx = 0;
          thiz.calculateUserAnsweringOptionFontSizes();
        } else {
          thiz.bShowUserAnsweringView = false;
          thiz.showErrorMsg(2000, '随堂测试缺少题目，有待完善');
        }
      }, function (err){
        console.log(err);
        thiz.bShowUserAnsweringView = false;
      });
    },

    //用户主动提问
    enterUserAskingQuestions: async function() {
      return new Promise(resolve => {
        let thiz = this;
        this.enterUserAskingQuestionsInPromise();
        let timer = setInterval(()=>{
          if(thiz.userAsking.bShowView == false) {
            clearInterval(timer);
            resolve();
            thiz.log("End User Asking");
          }
        }, 1000);
      });
    },

    enterUserAskingQuestionsInPromise: async function () {
      console.log('==enterUserAskingQuestionsInPromise==', this.userAsking.currentAction);
      this.userAsking.bShowView = true;
      this.userAsking.bPlaying = true;
      await nextTick();

      if (this.userAsking.currentAction.qaStartAudioUrl) {
        this.playUserAskingQuestionsCartoon(this.userAsking.currentAction.qaStartAudioUrl);
      }
      else if (this.userAsking.currentAction.qaStartVideoUrl) {
        this.stopUserAskingQuestionsVideo();
        this.playUserAskingQuestionsVideo(this.userAsking.currentAction.qaStartVideoUrl, this.userAsking.currentAction.qaStartIdleVideoUrl)
      }

      if (this.userAsking.currentAction.qaEndAudioUrl) {
//        this.playUserAskingQuestionsCartoon(this.userAsking.currentAction.qaEndAudioUrl);
      }
      else if (this.userAsking.currentAction.qaEndVideoUrl) {
//        this.playUserAskingQuestionsVideo(this.userAsking.currentAction.qaEndVideoUrl, this.userAsking.currentAction.qaEndIdleVideoUrl)
      }
    },

    startOrStopAudioRecording: async function (onRecordStarted, onRecordWavFile, onRecordDuration) {
      let thiz = this;
      if (!thiz.audioRecorder) {
        await new Promise(resolve => {
          let config = {
            sampleBits: 16, 
            sampleRate: 16000, 
            format: 'wav',
            // 音量阈值控制配置
            volumeThreshold: thiz.audioVolumeThreshold,
            volumeDetectionEnabled: thiz.audioVolumeDetectionEnabled,
            volumeSmoothingFactor: thiz.audioVolumeSmoothingFactor
          };
          window.HZRecorder.get((recorder) => {
            thiz.audioRecorder = recorder;
            resolve();
          }, config);
        });
      }

      if (thiz.bAudioRecording) {
        thiz.audioRecorder.stop();

        // 关键修复：先停止麦克风 stream tracks，释放硬件占用
        // iOS 只有在所有麦克风轨道完全停止后，才会响应 audioSession 类型的切换请求
        thiz.audioRecorder.stopStream();

        // 恢复 iOS 音频输出到扬声器（必须在 stopStream 之后调用才有效）
        IOSAudioHelper.restoreAudioOutput();
        
        if(thiz.audioRecorderTimer) {
          clearInterval(thiz.audioRecorderTimer);
          this.audioRecorderTimer = null;
        }
        let blob = thiz.audioRecorder.getWavBlob();

        // 关闭 AudioContext 并清空 recorder 引用，下次录音时重新创建新的干净的 stream
        thiz.audioRecorder.end();
        thiz.audioRecorder = null;

        let file = new window.File([blob], "record.wav");
        if(onRecordWavFile) {
          onRecordWavFile(file);
        }
      }
      else {
        thiz.audioRecorder.start();
        if(onRecordStarted) {
          onRecordStarted(Date.now());
        }
        if(onRecordDuration) {
          thiz.audioRecorderTimer = setInterval(()=>{
            onRecordDuration(Date.now());
          }, 1000);
        }
      }
      thiz.bAudioRecording = !thiz.bAudioRecording;
    },

    // 新的语音转文字方法，使用action.languageSpecify字段
    voiceToText: function(voiceFile, action, onTextResult) {
      // 从action.languageSpecify直接获取语言参数
      let lang = action?.languageSpecify || 'none';
      let langGroup = action?.languageGroup || 'none';

      this.log("Voice-To-Text", "actionId="+action?.actionId+", languageSpecify="+lang+", languageGroup="+langGroup);

      let fm = new FormData();
      fm.append('ref_lang', lang);
      fm.append('ref_lang_group', langGroup);
      fm.append('driven_audio', voiceFile);
      invokeLessonPlayerWebFormApi(this.queries, 'voice2text', fm, this.toLogin,
          (res)=>{
            if(res.data.code == 0) {
              let data = res.data.data;
              if(data&&data.whole_text) {
                console.log('VTT: ', {'文本': data.whole_text});
                onTextResult(data.whole_text);
              }
              else {
                console.log('VTT: 返回格式不对', data);
                onTextResult('');
              }
            }
            else {
              console.log('VTT: ', res.data.msg);
              onTextResult('');
            }
          },
          ()=>{
            this.showErrorMsg(1000, '小故障，请检查一下您的网络');
            onTextResult('');
          }
      );
    },

    // 保留原方法作为备用
    voiceToTextByOurFasterWhisperService: function(voiceFile, onTextResult) {
      let lang = this.lesson?.channel?.whisper_lang || 'none';

      //草稿 412 415 425 426 427 428 429 的时候：
      //    场景 7-11选择zh
      //    场景 12和13选择en
      let sceneNo = Number(this.currentSceneId) + 1;
      switch(this.queries.lessonId) {
        case 411: case 415: case 425: case 426: case 428: case 429:
          if(sceneNo >= 7 && sceneNo <= 11) {
            lang = "zh";
          } else if(sceneNo >= 12 && sceneNo <= 13) {
            lang = "en";
          }
          break;
        case 427:
          if(sceneNo >= 7 && sceneNo <= 12) {
            lang = "zh";
          } else if(sceneNo >= 13 && sceneNo <= 14) {
            lang = "en";
          }
          break;
        case 438:
          switch(sceneNo) {
            case 6:case 7:case 8:case 11:case 14:case 16:case 23:case 24: lang = "zh"; break;
            default: break;
          }
          break;
        case 439: case 440: case 441:
          switch(sceneNo) {
            case 3: case 4: case 5: case 6: case 8: lang = "zh"; break;
            default: break;
          }
          break;
        case 445: case 446: case 448:
          switch (sceneNo) {
            case 4: case 5: case 6: lang = "zh"; break;
            default: break;
          }
          break;
        default:
          break;
      }
      this.log("Faster-Whisper", "lessonId="+this.queries.lessonId+", sceneNo="+sceneNo+", lang="+lang);

      //
      let fm = new FormData();
      fm.append('ref_lang', lang);
      fm.append('driven_audio', voiceFile);
      invokeLessonPlayerWebFormApi(this.queries, 'voice2text', fm, this.toLogin,
          (res)=>{
            if(res.data.code == 0) {
              let data = res.data.data;
              if(data.language && data.whole_text) {
                console.log('语种：', data.language);
                console.log('FF: ', {'语种': data.language, '文本': data.whole_text});
                onTextResult(data.whole_text);
              }
              else {
                console.log('FF: 返回格式不对', data);
                onTextResult('');
              }
            }
            else {
              console.log('FF: ', res.data.msg);
              onTextResult('');
            }
          },
          ()=>{
            this.showErrorMsg(1000, '小故障，请检查一下您的网络');
            onTextResult('');
          }
      );
    },

    scrollToBottomEnd: async function (elementId) {
      let element = document.getElementById(elementId);
      if (element) {
        await nextTick();
        element.scrollTop = element.scrollHeight - element.clientHeight
        await nextTick();
      }
    },

    injectJSXGraphCode: async function (dynamicJavascript, onImageDataUrl) {
      let clearjs = `
        if(window.boardVars) {
          delete window.boardVars;
          window.boardVars = null;
        }
        if(window.board) {
          delete window.board;
          window.board = null;
        }
      `;

      if (this.userAsking.jsxGraphNode) {
        this.userAsking.jsxGraphNode.remove()
      }

      // 创建一个 <script> 标签
      this.userAsking.jsxGraphNode = document.createElement('script');

      // 将 JS 代码作为文本内容注入到 script 标签中
      this.userAsking.jsxGraphNode.textContent = clearjs + dynamicJavascript;

      // 将 script 标签添加到当前文档的 <body> 中
      document.body.appendChild(this.userAsking.jsxGraphNode);

      if(onImageDataUrl) {
        await nextTick();
        let div = document.getElementById('jxgbox');
        html2canvas(div).then(async function (canvas) {
          // 将 canvas 转换为图片的 data URL
          let imgData = canvas.toDataURL('image/png');
          onImageDataUrl(imgData);
        });
      }
    },

    stopUserAskingQuestionsVideo: function() {
      if(this.userAsking.qaVideo) {
        this.userAsking.qaVideo.pause();
        delete this.userAsking.qaVideo;
        this.userAsking.qaVideo = null;
      }
      if(this.userAsking.qaIdleVideo) {
        this.userAsking.qaIdleVideo.pause();
        delete this.userAsking.qaIdleVideo;
        this.userAsking.qaIdleVideo = null;
      }
    },
    playUserAskingQuestionsVideo: function(videoUrl, idleVideoUrl) {
      let video = document.createElement('video');
      if(idleVideoUrl == null) {
        this.userAsking.qaIdleVideo = video;
        this.userAsking.qaIdleVideo.loop = true;
      } else {
        this.userAsking.qaVideo = video;
      }

      // 移除canvas抠像处理，直接播放视频
      video.style.display = '';
      video.loop = false;
      video.src = videoUrl;
      video.preload = true;

      let self = this;
      video.onended = function() {
        if(idleVideoUrl) {
          self.playUserAskingQuestionsVideo(idleVideoUrl, null);
        }
      }

      this.userAsking.lastAnswerPlayer = video;
      video.play().catch(async function (err) {
        console.error('play user-asking-video error:', err, err.name, err.message);
      });
      return video;
    },

    stopMediaPlayer: function(player) {
      if(player) {
        player.pause();
        player.currentTime = 0;
        player.dispatchEvent(new Event('ended'));
      }
    },

    playUserAskingQuestionsCartoon: async function (audioUrl) {
      let player = this.getStaticAudioPlayer();
      player.src = audioUrl;
      this.userAsking.lastAnswerPlayer = player;
      await this.playerPlayAndWaitEnd(player, 'user-asking-cartoon-audio');
      this.freeStaticAudioPlayer(player);
    },

    getStaticAudioPlayer: function () {
      for(let ap of this.staticAudioPlayers) {
        if(!ap.isBusy) {
          ap.isBusy = true;
          ap.volume = 1.0;
          console.log('getStaticAudioPlayer', ap.id);
          return ap;
        }
      }
      console.log('getStaticAudioPlayer', 'dynamicPlayer-X');
      return new Audio();
    },
    freeStaticAudioPlayer: function (player) {
      player.isBusy = false;
      // 清理事件监听器，避免重复触发
      player.onended = null;
      player.onplay = null;
      player.onerror = null;
      // 重置播放器状态
      player.currentTime = 0;
      player.src = '';
    },

    onUserClickAnsweringNext: function () {
      this.userAnsweringSourceIdx++;
      this.calculateUserAnsweringOptionFontSizes();
    },
    calculateUserAnsweringOptionFontSizes() {
      const maxLen = '跨域、异构、可信、独立的数据采集系统，支持数据采集、存储、分析和展现'.length;
      const stepLen = maxLen / 2;
      console.log('maxLen=', maxLen);
      console.log('this.userAnsweringSource.length=', this.userAnsweringSource.length);
      let src = this.userAnsweringSource[this.userAnsweringSourceIdx];

      //a: '1.5vw', //:'2vh',

      this.userAnsweringOptionSizes.a = this.calculateOptionFontSize(src.optionA, maxLen, stepLen);
      this.userAnsweringOptionSizes.b = this.calculateOptionFontSize(src.optionB, maxLen, stepLen);
      this.userAnsweringOptionSizes.c = this.calculateOptionFontSize(src.optionC, maxLen, stepLen);
      this.userAnsweringOptionSizes.d = this.calculateOptionFontSize(src.optionD, maxLen, stepLen);
    },
    calculateOptionFontSize: function (text, maxLen, stepLen) {
      if(text.length <= maxLen) {
        return this.surface.bLand?'1.5vw':'2vh';
      }
      let fontSize = this.surface.bLand?1.5:2;
      let fontAdj = this.surface.bLand?0.25:0.45;
      let n = text.length / stepLen-2;
      for(let i=0; i<n; i++) {
        fontSize -= fontAdj;
      }
      return fontSize+(this.surface.bLand?'vw':'vh');
    },

    onUserClickAnsweringSkip: function () {
      this.bShowUserAnsweringStatView = true;
    },
    onUserClickAnsweringClose: function(){
      this.bShowUserAnsweringView = false;
    },
    onUserClickAnsweringOption: function(optionIdx1) {
      if(this.userAnsweringSourceLastClickedIdx === this.userAnsweringSourceIdx)
        return;
      this.userAnsweringSourceLastClickedIdx = this.userAnsweringSourceIdx;

      if(!this.answerGoodImg) {
        this.answerGoodImg = document.createElement('img');
        this.answerGoodImg.src = require('@/assets/test/good.png');
        this.answerGoodImg.style = `position:absolute;left:4%;top:30%;height:30%;`;
      }
      if(!this.answerFailImg) {
        this.answerFailImg = document.createElement('img');
        this.answerFailImg.src = require('@/assets/test/fail.png');
        this.answerFailImg.style = `position:absolute;right:4%;top:30%;height:30%;`;
      }
      this.answerGoodImg.remove();
      this.answerFailImg.remove();

      let userAnswerEleId = '';
      let userAnswerText = '';
      let question = this.userAnsweringSource[this.userAnsweringSourceIdx];
      switch(optionIdx1) {
        case 1:
          userAnswerEleId = 'answerOptionA'
          userAnswerText = question.optionA;
          break;
        case 2:
          userAnswerEleId = 'answerOptionB'
          userAnswerText = question.optionB;
          break;
        case 3:
          userAnswerEleId = 'answerOptionC'
          userAnswerText = question.optionC;
          break;
        case 4:
          userAnswerEleId = 'answerOptionD'
          userAnswerText = question.optionD;
          break;
      }
      let userAnswerEle = document.getElementById(userAnswerEleId);
      if(question.answer === userAnswerText) {
        this.userAnsweringCorrects++;
        userAnswerEle.appendChild(this.answerGoodImg);
        this.playSound(require('@/assets/test/good.mp3'));
      }
      else {
        userAnswerEle.appendChild(this.answerFailImg);
        let goodEleId;
        if(question.answer === question.optionA)
          goodEleId = 'answerOptionA';
        else if(question.answer === question.optionB)
          goodEleId = 'answerOptionB';
        else if(question.answer === question.optionC)
          goodEleId = 'answerOptionC';
        else if(question.answer === question.optionD)
          goodEleId = 'answerOptionD';
        if(goodEleId) {
          let goodEle = document.getElementById(goodEleId);
          goodEle.appendChild(this.answerGoodImg);
        }
        this.playSound(require('@/assets/test/fail.mp3'));
      }

      setTimeout(()=>{
        if(this.userAnsweringSourceIdx < this.userAnsweringSource.length-1) {
          this.answerGoodImg.remove();
          this.answerFailImg.remove();
          this.userAnsweringSourceIdx++;
          this.calculateUserAnsweringOptionFontSizes();
        }else{
          this.onUserClickAnsweringSkip();
        }
      }, 2000);
    },

    playSound: function (src, onSoundEnded) {
//      let player = document.createElement('audio');
      let player = this.getStaticAudioPlayer();
      if(onSoundEnded) {
        player.onended = onSoundEnded;
      }
      else {
        let thiz = this;
        player.onended = function () {
          thiz.freeStaticAudioPlayer(player);
        }
      }

      let thiz = this;
      player.src = src;
      this.$refs.hiddenContainer.appendChild(player);
      player.play().catch(async function (err) {
        console.error('playSound-Error:', err, src, err.name, err.message);
        thiz.stopMediaPlayer(player);
      });
      return player;
    },

    playerPlayAndWaitEnd: function (player, msg) {
      return new Promise(resolve => {
        player.onended = function() {
          resolve();
        };
        console.log('playerPlayAndWaitEnd:', msg, player.src);
        player.play().catch(function(err){
          console.error('playerPlayAndWaitEnd-Error:', msg, player.src, err, err.name, err.message);
          resolve();
        });
      });
    },

    secondsToText: function(sec) {
      let hours = Math.floor(sec / (60*60))
      let minutes = Math.floor((sec-hours*60*60) / 60);
      let seconds = sec % 60;
      let s = '';
      if(hours > 0) {
        if(hours < 10)
          s += '0';
        s += hours + ':';
      }
      if(minutes < 10)
        s += '0';
      s += minutes + ':';
      if(seconds < 10)
        s += '0';
      s += seconds;
      return s;
    },

    enterTeacherAsking: function (action) {
      this.teacherAsking.bAutoRecording = this.bCheckboxMicrophone;
      this.teacherAsking.bShowBoard     = true;
      this.teacherAsking.bShowAudioText = false;
      this.teacherAsking.displayBoardText = '';
      this.teacherAsking.displayAudioText = '';
      if (this.pendingNextAskScreenshot && action.quesScreenshotEnabled) {
        if (action.handwritingBoard && action.handwritingBoard.enabled) {
          action.handwritingBoard.image = this.pendingNextAskScreenshot;
        }
        action.quesUrl = this.pendingNextAskScreenshot;
        this.pendingNextAskScreenshot = '';
      }
      
      // 检查是否有handwritingBoard配置
      if (action.handwritingBoard && action.handwritingBoard.enabled) {
        this.teacherAsking.handwritingBoardConfig = action.handwritingBoard;
        this.teacherAsking.isFirstRound = true;
        this.teacherAsking.bShowHandwritingBoard = true;
      } else {
        this.teacherAsking.handwritingBoardConfig = null;
        this.teacherAsking.isFirstRound = true;
        this.teacherAsking.bShowHandwritingBoard = false;
      }
      
//      action.qaDelay = 10000000;
      if(this.teacherAsking.bAutoRecording) {
        return this.enterTeacherAsking_autoRecording(action);
      } else {
        return this.enterTeacherAsking_manuRecording(action);
      }
    },

    enterTeacherAsking_autoRecording: function (action) {
      return new Promise(resolve => {
        console.log('enterTeacherAsking', action);
        let thiz = this;
        let ta = thiz.teacherAsking;

        ta.currentAction = action;
        ta.promiseResolve = resolve; // 保存resolve函数引用，供多轮对话定时器使用
        ta.bShowView = true; //打开老师提问窗口

        // 在quesTeacher时显示liveWindow
        if (thiz.liveWindow) {
          thiz.showLiveWindowFrame();
        }

        ta.aiAnswerText = '老师我知道答案，让我来回答吧，我的答案是：\r\n'+ta.currentAction.aiAnswer;
        ta.aiMateImgUrl = ta.currentAction.aiMateStandImgUrl;

        ta.bCountingDown = true;

        let handleTeacherAskingAutoRecording = function() {
          console.log('开始录音');
          
          thiz.startOrStopAudioRecording(null, null, null);

          // 清除之前的定时器
          if (ta.countDownTimer) {
            clearInterval(ta.countDownTimer);
            ta.countDownTimer = null;
          }
          let seconds = 0;
          if(ta.bCountingDown) {
            ta.countDownText = thiz.secondsToText(ta.currentAction.qaDelay);
          }
          ta.countDownTimer = setInterval(() => {
            seconds++;
            if(ta.bCountingDown) {
              let remainingTime = ta.currentAction.qaDelay - seconds;
              if(remainingTime > 0) {
                ta.countDownText = thiz.secondsToText(remainingTime);
              } else {
                ta.countDownText = thiz.secondsToText(0);
              }
            }
            //三秒内没有回答，则发起学生状态监控
//          if(!ta.bHaveAnswer && seconds == 4 && !thiz.bAudioRecording) {
//            thiz.checkStudentStatus((badStatusAudioUrl) => {
//              if(!ta.bHaveAnswer && !thiz.bAudioRecording && badStatusAudioUrl) {
//                thiz.playSound(badStatusAudioUrl);
//              }
//            });
//          }
            //超过问答限时/秒，或者学生点击了发送按钮
            if(!ta.bHaveAnswer && (seconds > ta.currentAction.qaDelay || ta.bUserClickSendingButton)) {
              // 调用统一的时间到了处理方法
              thiz.handleTeacherAskingTimeUp();
            }
            if(!ta.bShowView) {
              clearInterval(ta.countDownTimer);
              ta.countDownTimer = null;
              thiz.log("End Teacher Asking");
              ta.promiseResolve = null; // 清除引用
              resolve();
            }
          }, 1000); //interval
        }; //EOF: function handleTeacherAsking(...)

        //process
        console.log('ta.currentAction.isRead = ',ta.currentAction.isRead);
        let isRead = (typeof ta.currentAction.isRead === 'undefined') || ta.currentAction.isRead;
        if(isRead) {
          console.log('play teacherQuestionAudio', ta.currentAction.teacherQuestionAudio.src);
          // 播放音频时显示数字人说话状态
          if (!thiz.teacherAsking.bTeacherSpeaking) {
            console.log('🎤 老师提问音频开始，开始动嘴');
            thiz.showTeacherSpeakingVideo();
          } else {
            console.log('🎤 老师提问音频开始，已在说话状态，跳过');
          }
          ta.currentAction.teacherQuestionAudio.onended = () => {
            // 音频播放结束时，如果不在推流过程中才显示数字人待机状态
            console.log('📢 老师提问音频结束，isStreaming:', thiz.isStreaming);
            if (!thiz.isStreaming) {
              console.log('✅ 不在推流中，调用 showTeacherIdleVideo');
              thiz.showTeacherIdleVideo();
            } else {
              console.log('❌ 正在推流中，跳过 showTeacherIdleVideo');
            }
            handleTeacherAskingAutoRecording();
          }; //player-onended
          ta.currentAction.teacherQuestionAudio.play().catch(err=>{console.error('play teacherQuestionAudio-error', err,err.message);});
        }
        else {
          // 没有音频时，如果不在推流过程中才显示待机状态
          console.log('🔇 没有老师提问音频，isStreaming:', thiz.isStreaming);
          if (!thiz.isStreaming) {
            console.log('✅ 不在推流中，调用 showTeacherIdleVideo');
            thiz.showTeacherIdleVideo();
          } else {
            console.log('❌ 正在推流中，跳过 showTeacherIdleVideo');
          }
          handleTeacherAskingAutoRecording();
        }
      });
    },

    enterTeacherAsking_manuRecording: function (action) {
      return new Promise(resolve => {
        console.log('enterTeacherAsking', action);
        let thiz = this;
        let ta = thiz.teacherAsking;

        ta.currentAction = action;
        ta.bShowView = true; //打开老师提问窗口

        // 在quesTeacher时显示liveWindow
        if (thiz.liveWindow) {
          thiz.showLiveWindowFrame();
        }

        ta.aiAnswerText = '老师我知道答案，让我来回答吧，我的答案是：\r\n'+ta.currentAction.aiAnswer;
        ta.aiMateImgUrl = ta.currentAction.aiMateStandImgUrl;

        ta.bCountingDown = true;

        let handleTeacherAskingManuRecording = function() {
          if (ta.handwritingBoardConfig && ta.handwritingBoardConfig.enabled) {
            thiz.startOrStopAudioRecording(null, null, null);
          }
          // 清除之前的定时器
          if (ta.countDownTimer) {
            console.log('🔥 手动录音清除之前的定时器');
            clearInterval(ta.countDownTimer);
            ta.countDownTimer = null;
          }
          let seconds = 0;
          console.log('🔥 手动录音倒计时初始化 - qaDelay:', ta.currentAction.qaDelay, 'bCountingDown:', ta.bCountingDown);
          if(ta.bCountingDown) {
            ta.countDownText = thiz.secondsToText(ta.currentAction.qaDelay);
            console.log('🔥 初始化countDownText:', ta.countDownText);
          }
          ta.countDownTimer = setInterval(() => {
            seconds++;
            console.log('🔥 定时器执行 - seconds:', seconds, 'bCountingDown:', ta.bCountingDown);
            if(ta.bCountingDown) {
              let remainingTime = ta.currentAction.qaDelay - seconds;
              console.log('🔥 计算remainingTime:', remainingTime, '= qaDelay:', ta.currentAction.qaDelay, '- seconds:', seconds);
              if(remainingTime > 0) {
                ta.countDownText = thiz.secondsToText(remainingTime);
                console.log('🔥 更新countDownText (>0):', ta.countDownText);
              } else {
                ta.countDownText = thiz.secondsToText(0);
                console.log('🔥 更新countDownText (<=0):', ta.countDownText);
              }
            }
            //三秒内没有回答，则发起学生状态监控
            if(!ta.bHaveAnswer && seconds == 4 && !thiz.bAudioRecording) {
              thiz.checkStudentStatus((badStatusAudioUrl) => {
                if(!ta.bHaveAnswer && !thiz.bAudioRecording && badStatusAudioUrl) {
                  thiz.playSound(badStatusAudioUrl);
                }
              });
            }
            //超过问答限时/秒
            if(!ta.bHaveAnswer && seconds > ta.currentAction.qaDelay) {
              ta.bCountingDown = false;
              console.log('作答时限到');
              //如果开启了AI抢答
              if(ta.currentAction.isPree) {
                console.log('AI同学抢答');
                ta.bShowAiAnswer = true; //显示AI抢答
                if(ta.currentAction.aiMateAnswerAudioUrl) {
                  ta.bHaveAnswer = true;
                  ta.aiMateImgUrl = ta.currentAction.aiMateSpeakImgUrl;
                  console.log('play aiMateAnswerAudio', ta.currentAction.aiMateAnswerAudio.src);
                  ta.currentAction.aiMateAnswerAudio.play().catch(err=>{console.error('play aiMateAnswerAudio-error', err,err.message);});
                  ta.currentAction.aiMateAnswerAudio.onended = () => {
                    ta.aiMateImgUrl = ta.currentAction.aiMateIdleImgUrl;
                    thiz.sendAnswerForTeacherAskingInner(ta.currentAction.aiAnswer);
                  };
                } else {
                  thiz.sendAnswerForTeacherAskingInner(ta.currentAction.aiAnswer);
                }
              }
              //如果没开启AI抢答，则直接提示正确答案
              else {
                console.log('学生未回答');
                thiz.sendAnswerForTeacherAskingInner('');
              }
            }
            if(!ta.bShowView) {
              clearInterval(ta.countDownTimer);
              ta.countDownTimer = null;
              thiz.log("End Teacher Asking");
              resolve();
            }
          }, 1000); //interval
        }; //EOF: function handleTeacherAsking(...)

        console.log('ta.currentAction.isRead = ',ta.currentAction.isRead);
        let isRead = (typeof ta.currentAction.isRead === 'undefined') || ta.currentAction.isRead;

        if(isRead) {
          console.log('play teacherQuestionAudio', ta.currentAction.teacherQuestionAudio.src);
          // 播放音频时显示数字人说话状态
          if (!thiz.teacherAsking.bTeacherSpeaking) {
            console.log('🎤 手动录音-老师提问音频开始，开始动嘴');
            thiz.showTeacherSpeakingVideo();
          } else {
            console.log('🎤 手动录音-老师提问音频开始，已在说话状态，跳过');
          }
          ta.currentAction.teacherQuestionAudio.onended = () => {
            // 音频播放结束时，如果不在推流过程中才显示数字人待机状态
            console.log('📢 手动录音-老师提问音频结束，isStreaming:', thiz.isStreaming);
            if (!thiz.isStreaming) {
              console.log('✅ 不在推流中，调用 showTeacherIdleVideo');
              thiz.showTeacherIdleVideo();
            } else {
              console.log('❌ 正在推流中，跳过 showTeacherIdleVideo');
            }
            handleTeacherAskingManuRecording();
          }; //player-onended
          ta.currentAction.teacherQuestionAudio.play().catch(err=>{console.error('play teacherQuestionAudio-error', err,err.message);});
        }
        else {
          // 没有音频时，如果不在推流过程中才显示待机状态
          console.log('🔇 手动录音-没有老师提问音频，isStreaming:', thiz.isStreaming);
          if (!thiz.isStreaming) {
            console.log('✅ 不在推流中，调用 showTeacherIdleVideo');
            thiz.showTeacherIdleVideo();
          } else {
            console.log('❌ 正在推流中，跳过 showTeacherIdleVideo');
          }
          handleTeacherAskingManuRecording();
        }
      });
    },

    

    //进入老师主动提问，学生开放式回答，或者跟AI伴读抢答
    clearTeacherAsking: function() {
      this.teacherAsking.bShowView = false; //是否需要显示教师提问窗口：教师主动提问，学生开放式回答，也可能有AI同学抢答
      this.teacherAsking.bShowThinking = false;   //是否需要显示教师正在思考学生的回答
      this.teacherAsking.currentAction = null;
      //this.teacherAsking.bAutoRecording = true; //是否一打开就开始录音
      //this.teacherAsking.bAutoVoice = true;     //语音输入是否自动确认(不经过文本框=>发送)
      this.teacherAsking.bUserClickSendingButton = false; //学生是否在倒计时结束前点击了提交按钮
      this.teacherAsking.bHaveAnswer = false;   //是否已经有人回答了问题：用户回答，或者AI抢答
      this.teacherAsking.bShowAiAnswer = false; //是否显示AI抢答
      this.teacherAsking.aiAnswerText = '';
      this.teacherAsking.countDownText = '';    //学生回答超时的倒计时文本
      this.teacherAsking.bCountingDown = false;
      this.teacherAsking.aiMateImgUrl = '';
      this.teacherAsking.bShowAnswer = false;   //是否显示正确答案或者返回的点评内容
      this.teacherAsking.answerText = '';        //显示正确答案或者返回的点评内容
      this.teacherAsking.bHandling = false;
      this.teacherAsking.bExitDialogue = false; //重置退出对话标志
      this.teacherAsking.bShowTeacherVideo = false; //清理数字人视频显示状态
      this.teacherAsking.teacherVideoUrl = '';
      this.teacherAsking.bTeacherSpeaking = false;
      this.teacherAsking.dialogueId = null;         //清理多轮对话ID
      this.teacherAsking.dialogueHistory = [];     //清理对话历史记录
      
      // 清理手写板相关数据
      this.teacherAsking.bShowHandwritingBoard = false;
      this.teacherAsking.handwritingBoardConfig = null;
      this.teacherAsking.handwritingImage = '';
      this.teacherAsking.isFirstRound = true;
      this.teacherAsking.photoBase64Data = '';
      
      // 重置录音状态
      this.bAudioRecording = false;

      // 清理liveWindow显示
      this.clearLiveWindowFrame();
    },

    // 获取lesson.scenes中最后一个robot类型action的style参数
    getLastRobotActionStyle: function() {
      let lastRobotAction = null;
      for (let sceneIdx in this.lesson.scenes) {
        let scene = this.lesson.scenes[sceneIdx];
        for (let groupIdx in scene.groups) {
          let group = scene.groups[groupIdx];
          for (let actionIdx in group.actions) {
            let action = group.actions[actionIdx];
            if (action.actionType === 'robot') {
              lastRobotAction = action;
            }
          }
        }
      }
      return lastRobotAction ? lastRobotAction.style : null;
    },

    // 获取当前老师提问前一个数字人的style参数
    getPreviousRobotActionStyle: function() {
      if (!this.lesson.scenes || !this.currentScene) {
        return null;
      }

      let previousRobotAction = null;
      let currentSceneIndex = this.lesson.scenes.indexOf(this.currentScene);
      
      // 遍历到当前场景为止，查找最后一个robot类型的action
      for (let sceneIdx = 0; sceneIdx <= currentSceneIndex; sceneIdx++) {
        let scene = this.lesson.scenes[sceneIdx];
        for (let groupIdx in scene.groups) {
          let group = scene.groups[groupIdx];
          
          // 如果是当前场景，只遍历到当前组之前的组
          if (sceneIdx === currentSceneIndex) {
            let currentGroupIndex = parseInt(this.currentGroupId);
            if (parseInt(groupIdx) >= currentGroupIndex) {
              break;
            }
          }
          
          for (let actionIdx in group.actions) {
            let action = group.actions[actionIdx];
            if (action.actionType === 'robot' || action.actionType === 'robot_video' || action.actionType === 'keying_video') {
              previousRobotAction = action;
            }
          }
        }
      }
      
      return previousRobotAction ? previousRobotAction.style : null;
    },

    // 获取指定场景的第一个robot类型action
    getFirstRobotActionInScene: function(sceneIndex) {
      if (!this.lesson.scenes || sceneIndex >= this.lesson.scenes.length) {
        return null;
      }

      let scene = this.lesson.scenes[sceneIndex];
      for (let groupIdx in scene.groups) {
        let group = scene.groups[groupIdx];
        for (let actionIdx in group.actions) {
          let action = group.actions[actionIdx];
          if (action.actionType === 'robot' || action.actionType === 'robot_video' || action.actionType === 'keying_video') {
            return action;
          }
        }
      }
      return null;
    },

    // 获取当前场景的最后一个robot类型action
    getLastRobotActionInCurrentScene: function() {
      if (!this.currentScene) {
        return null;
      }

      let lastRobotAction = null;
      for (let groupIdx in this.currentScene.groups) {
        let group = this.currentScene.groups[groupIdx];
        for (let actionIdx in group.actions) {
          let action = group.actions[actionIdx];
          if (action.actionType === 'robot' || action.actionType === 'robot_video' || action.actionType === 'keying_video') {
            lastRobotAction = action;
          }
        }
      }
      return lastRobotAction;
    },

    // 从当前场景的actions中获取liveWindow配置，如果没有则回退到全局配置
    getCurrentSceneLiveWindow: function() {
      if (!this.currentScene) {
        return this.liveWindow; // 回退到全局配置
      }

      for (let groupIdx in this.currentScene.groups) {
        let group = this.currentScene.groups[groupIdx];
        for (let actionIdx in group.actions) {
          let action = group.actions[actionIdx];
          if (action.actionType === 'liveWindow') {
            return action;
          }
        }
      }
      
      // 如果场景中没有找到，回退到全局配置
      if (this.liveWindow) {
      }
      return this.liveWindow;
    },

    // 从当前场景的actions中获取cameraPosition配置，如果没有则回退到全局配置
    getCurrentSceneCameraPosition: function() {
      if (!this.currentScene) {
        return this.cameraPosition; // 回退到全局配置
      }

      for (let groupIdx in this.currentScene.groups) {
        let group = this.currentScene.groups[groupIdx];
        for (let actionIdx in group.actions) {
          let action = group.actions[actionIdx];
          if (action.actionType === 'cameraPosition') {
            console.log('使用场景级cameraPosition配置:', action);
            return action;
          }
        }
      }
      
      // 如果场景中没有找到，回退到全局配置
      if (this.cameraPosition) {
        console.log('使用全局cameraPosition配置:', this.cameraPosition);
      }
      return this.cameraPosition;
    },

    // 预加载下一场景的第一个数字人视频
    preloadNextSceneRobotVideo: async function(nextSceneIndex) {
      console.log('🎬 预加载下一场景数字人视频, sceneIndex:', nextSceneIndex);

      let nextRobotAction = this.getFirstRobotActionInScene(nextSceneIndex);
      if (!nextRobotAction) {
        console.log('❌ 下一场景没有数字人视频');
        return;
      }

      let nextVideoUrl = nextRobotAction.videoUrl || nextRobotAction.robotvideoUrl || nextRobotAction.url;
      if (!nextVideoUrl) {
        console.log('❌ 下一场景数字人视频URL为空');
        return;
      }

      console.log('✅ 找到下一场景数字人视频:', nextVideoUrl);

      // 等待DOM更新，确保视频元素已经渲染
      await this.$nextTick();

      let videoA = document.getElementById('idTeacherVideoA');
      let videoB = document.getElementById('idTeacherVideoB');

      if (!videoA || !videoB) {
        console.warn('❌ 找不到双缓冲视频元素，无法预加载');
        return;
      }

      // 确定下一个视频元素（用于预加载）
      let nextVideo;
      let videoAOpacity = videoA.style.opacity || '1';

      if (videoAOpacity !== '0') {
        nextVideo = videoB;
      } else {
        nextVideo = videoA;
      }

      // 预加载下一个场景的视频到备用缓冲区
      try {
        console.log('🔄 开始预加载下一场景视频到备用缓冲区');
        nextVideo.src = nextVideoUrl;
        nextVideo.style.opacity = '0';

        // 等待视频加载但不播放
        await new Promise((resolve, reject) => {
          let timeout = setTimeout(() => reject(new Error('视频预加载超时')), 5000);
          nextVideo.oncanplay = () => {
            clearTimeout(timeout);
            console.log('✅ 下一场景视频预加载完成');
            resolve();
          };
          nextVideo.onerror = () => {
            clearTimeout(timeout);
            reject(new Error('视频预加载失败'));
          };
          nextVideo.load();
        });

        // 存储预加载的视频信息，用于场景切换时的过渡
        this.nextSceneVideoInfo = {
          videoUrl: nextVideoUrl,
          action: nextRobotAction,
          preloaded: true
        };

      } catch (error) {
        console.error('❌ 预加载下一场景视频失败:', error);
        this.nextSceneVideoInfo = null;
      }
    },

    // 执行场景切换时的数字人视频过渡
    performSceneTransition: async function() {
      console.log('🎬 执行场景切换数字人视频过渡');

      if (!this.nextSceneVideoInfo || !this.nextSceneVideoInfo.preloaded) {
        console.log('❌ 没有预加载的下一场景视频，跳过过渡');
        return;
      }

      try {
        await this.$nextTick();

        let videoA = document.getElementById('idTeacherVideoA');
        let videoB = document.getElementById('idTeacherVideoB');

        if (!videoA || !videoB) {
          console.warn('❌ 找不到双缓冲视频元素');
          return;
        }

        // 确定当前显示的视频和下一个视频
        let currentVideo, nextVideo;
        let videoAOpacity = videoA.style.opacity || '1';

        if (videoAOpacity !== '0') {
          currentVideo = videoA;
          nextVideo = videoB;
        } else {
          currentVideo = videoB;
          nextVideo = videoA;
        }

        // 开始播放下一个视频
        await nextVideo.play();

        // 使用transitionBetweenVideos进行平滑过渡
        await this.transitionBetweenVideos(currentVideo, nextVideo, {
          crossfadeDuration: 0.3, // 场景切换用稍长的过渡时间
          brightnessStability: 0.3,
          colorMatching: 0.55
        });

        // 过渡完成后，交换视频元素的角色
        currentVideo.style.opacity = '0';
        nextVideo.style.opacity = '1';
        currentVideo.pause();

        // 更新当前视频URL
        this.teacherAsking.teacherVideoUrl = this.nextSceneVideoInfo.videoUrl;

        console.log('✅ 场景切换数字人视频过渡完成');

        // 清理预加载信息
        this.nextSceneVideoInfo = null;

      } catch (error) {
        console.error('❌ 场景切换视频过渡失败:', error);
        this.nextSceneVideoInfo = null;
      }
    },

    // 老师视频平滑过渡方法
    transitionTeacherVideo: async function(newVideoUrl) {
      console.log('🎬 transitionTeacherVideo called with:', newVideoUrl);
      if (!newVideoUrl) {
        console.warn('transitionTeacherVideo: 新视频URL为空');
        return;
      }

      // 如果新旧视频URL相同，跳过过渡
      if (this.teacherAsking.teacherVideoUrl === newVideoUrl) {
        console.log('transitionTeacherVideo: 视频URL相同，跳过过渡');
        return;
      }

      try {

        // 等待DOM更新，确保视频元素已经渲染
        await this.$nextTick();

        // 应用正确的容器尺寸和位置
        this.applyTeacherVideoClipping();

        let videoA = document.getElementById('idTeacherVideoA');
        let videoB = document.getElementById('idTeacherVideoB');

        console.log('🔍 检查视频元素:', {
          videoA: videoA ? '存在' : '不存在',
          videoB: videoB ? '存在' : '不存在',
          bShowTeacherVideo: this.teacherAsking.bShowTeacherVideo
        });

        if (!videoA || !videoB) {
          console.warn('transitionTeacherVideo: 找不到双缓冲视频元素，使用简单切换');
          this.teacherAsking.teacherVideoUrl = newVideoUrl;
          return;
        }

        // 确定当前显示的视频和下一个视频
        let currentVideo, nextVideo;
        let videoAOpacity = videoA.style.opacity || '1';

        if (videoAOpacity !== '0') {
          currentVideo = videoA;
          nextVideo = videoB;
        } else {
          currentVideo = videoB;
          nextVideo = videoA;
        }

        // 如果当前视频没有src（第一次调用），直接设置给当前视频
        console.log('🔍 检查当前视频src:', currentVideo.src, '长度:', currentVideo.src ? currentVideo.src.length : 'undefined');
        if (!currentVideo.src || currentVideo.src.trim() === '') {
          console.log('🎬 第一次设置视频，直接设置给当前视频元素');
          currentVideo.src = newVideoUrl;
          this.teacherAsking.teacherVideoUrl = newVideoUrl;
          currentVideo.load();
          await currentVideo.play().catch(e => console.warn('视频播放失败:', e));
          console.log('transitionTeacherVideo: 第一次设置完成');
          return;
        }

        // 设置下一个视频的URL并准备播放
        nextVideo.src = newVideoUrl;
        nextVideo.style.opacity = '0';

        // 等待视频加载
        await new Promise((resolve, reject) => {
          let timeout = setTimeout(() => reject(new Error('视频加载超时')), 5000);
          nextVideo.oncanplay = () => {
            clearTimeout(timeout);
            resolve();
          };
          nextVideo.onerror = () => {
            clearTimeout(timeout);
            reject(new Error('视频加载失败'));
          };
          nextVideo.load();
        });

        // 开始播放下一个视频
        await nextVideo.play();

        // 使用transitionBetweenVideos进行平滑过渡
        await this.transitionBetweenVideos(currentVideo, nextVideo, {
          crossfadeDuration: 0.2,
          brightnessStability: 0.3,
          colorMatching: 0.55
        });

        // 过渡完成后，交换视频元素的角色
        currentVideo.style.opacity = '0';
        nextVideo.style.opacity = '1';
        currentVideo.pause();

        // 更新当前视频URL
        this.teacherAsking.teacherVideoUrl = newVideoUrl;

        console.log('transitionTeacherVideo: 过渡完成');

      } catch (error) {
        console.error('transitionTeacherVideo: 过渡失败，使用简单切换:', error);
        // 回退到简单切换
        this.teacherAsking.teacherVideoUrl = newVideoUrl;
        let currentLiveWindow = this.getCurrentSceneLiveWindow();
        if (currentLiveWindow) {
          this.$nextTick(() => {
            this.applyTeacherVideoClipping();
          });
        }
      }
    },

    // 显示数字人老师说话状态视频
    showTeacherSpeakingVideo: async function() {
      console.log('🎤 showTeacherSpeakingVideo called, isStreaming:', this.isStreaming);
      let ta = this.teacherAsking;
      console.log('🔍 检查 currentAction:', ta.currentAction);
      console.log('🔍 检查 teacherMuteVideoUrl:', ta.currentAction ? ta.currentAction.teacherMuteVideoUrl : 'currentAction为空');

      if (ta.currentAction && ta.currentAction.teacherMuteVideoUrl) {
        ta.bShowTeacherVideo = true;
        ta.bTeacherSpeaking = true;
        console.log('✅ 显示数字人老师说话视频:', ta.currentAction.teacherMuteVideoUrl);

        try {
          await this.transitionTeacherVideo(ta.currentAction.teacherMuteVideoUrl);
        } catch (error) {
          console.error('showTeacherSpeakingVideo: 过渡失败，使用简单切换:', error);
          ta.teacherVideoUrl = ta.currentAction.teacherMuteVideoUrl;
          let currentLiveWindow = this.getCurrentSceneLiveWindow();
          if (currentLiveWindow) {
            this.$nextTick(() => {
              this.applyTeacherVideoClipping();
            });
          }
        }
      } else {
        console.warn('❌ showTeacherSpeakingVideo: 无法显示说话视频，原因:');
        if (!ta.currentAction) {
          console.warn('   - currentAction为空');
        } else if (!ta.currentAction.teacherMuteVideoUrl) {
          console.warn('   - teacherMuteVideoUrl为空:', ta.currentAction.teacherMuteVideoUrl);
        }
      }
    },

    // 显示数字人老师待机状态视频
    showTeacherIdleVideo: async function() {
      console.log('🔍 showTeacherIdleVideo called, isStreaming:', this.isStreaming);
      console.trace('🔍 showTeacherIdleVideo call stack');
      let ta = this.teacherAsking;
      if (ta.currentAction && ta.currentAction.teacherIdleVideoUrl) {
        ta.bShowTeacherVideo = true;
        ta.bTeacherSpeaking = false;
        console.log('显示数字人老师待机视频:', ta.currentAction.teacherIdleVideoUrl);

        try {
          await this.transitionTeacherVideo(ta.currentAction.teacherIdleVideoUrl);
        } catch (error) {
          console.error('showTeacherIdleVideo: 过渡失败，使用简单切换:', error);
          ta.teacherVideoUrl = ta.currentAction.teacherIdleVideoUrl;
          let currentLiveWindow = this.getCurrentSceneLiveWindow();
          if (currentLiveWindow) {
            this.$nextTick(() => {
              this.applyTeacherVideoClipping();
            });
          }
        }
      }
    },

    // 为teacherAsking中的数字人视频应用liveWindow裁剪逻辑
    applyTeacherVideoClipping: function() {
      let teacherVideoContainer = document.getElementById('idTeacherVideoContainer');
      if (!teacherVideoContainer) {
        return;
      }

      // 获取当前老师提问前一个数字人的样式参数
      let robotStyle = this.getPreviousRobotActionStyle();
      if (!robotStyle) {
        console.log('未找到当前老师提问前一个数字人的样式参数，使用默认样式');
        return;
      }

      // 计算基本的位置和尺寸（基于当前老师提问前一个数字人的样式）
      let left = (robotStyle.left / this.lesson.resolution.width) * 100;
      let top = (robotStyle.top / this.lesson.resolution.height) * 100;
      let width = (robotStyle.width / this.lesson.resolution.width) * 100;
      let height = (robotStyle.height / this.lesson.resolution.height) * 100;

      // 如果没有liveWindow，直接使用当前老师提问前一个数字人的原始样式
      let currentLiveWindow = this.getCurrentSceneLiveWindow();
      if (!currentLiveWindow) {
        teacherVideoContainer.style.left = left + '%';
        teacherVideoContainer.style.top = top + '%';
        teacherVideoContainer.style.width = width + '%';
        teacherVideoContainer.style.height = height + '%';
        teacherVideoContainer.style.clipPath = 'none';
        teacherVideoContainer.style.webkitClipPath = 'none';
        return;
      }

      // 创建一个模拟的action对象用于计算裁剪
      let mockAction = {
        actionType: 'robot',
        style: robotStyle
      };

      // 计算裁剪信息
      let clippingInfo = this.calculateDigitalHumanClipping(mockAction);
      if (clippingInfo && clippingInfo.hasOverlap) {
        // 先设置基本的位置和尺寸
        teacherVideoContainer.style.left = left + '%';
        teacherVideoContainer.style.top = top + '%';
        teacherVideoContainer.style.width = width + '%';
        teacherVideoContainer.style.height = height + '%';

        // 然后再应用CSS clip-path进行裁剪
        let clipPath = `inset(${clippingInfo.clipPercent.top}% ${100 - clippingInfo.clipPercent.left - clippingInfo.clipPercent.width}% ${100 - clippingInfo.clipPercent.top - clippingInfo.clipPercent.height}% ${clippingInfo.clipPercent.left}%)`;
        teacherVideoContainer.style.clipPath = clipPath;
        teacherVideoContainer.style.webkitClipPath = clipPath;
        console.log('应用teacherVideo容器裁剪 - 先调整尺寸位置再裁剪:', {
          originalSize: {left, top, width, height},
          clippingInfo: clippingInfo
        });
      } else {
        teacherVideoContainer.style.left = left + '%';
        teacherVideoContainer.style.top = top + '%';
        let minWidthPercent = (1 / this.lesson.resolution.width) * 100;
        let minHeightPercent = (1 / this.lesson.resolution.height) * 100;
        teacherVideoContainer.style.width = minWidthPercent + '%';
        teacherVideoContainer.style.height = minHeightPercent + '%';
        teacherVideoContainer.style.clipPath = 'none';
        teacherVideoContainer.style.webkitClipPath = 'none';
      }
    },

    // 隐藏数字人老师视频
    hideTeacherVideo: function() {
      let ta = this.teacherAsking;
      ta.bShowTeacherVideo = false;
      ta.teacherVideoUrl = '';
      ta.bTeacherSpeaking = false;
      console.log('隐藏数字人老师视频');
    },

    onUserClickAudioInputForTeacherAsking: function () {
      let thiz = this;
      let ta = thiz.teacherAsking;
      let begin = 0;
      let onRecordStarted = function(beginTime) {
        begin = beginTime;
        thiz.audioRecorderSeconds = 60;
      };
      let onRecordWavFile = function(file) {
        try {
          const url = URL.createObjectURL(file);
          ta.lastUserAnswerIsAudio = true;
          thiz.addToDialogueHistory('user', JSON.stringify({ audioUrl: url, fileName: file.name, size: file.size }), 'audio');
        } catch(e) {void 0}
        thiz.voiceToText(file, ta.currentAction, (text) => {
          if(ta.bAutoVoice) {
            thiz.sendAnswerForTeacherAskingInner(text);
          } else {
            ta.currentAction.userAnswerText = text;
          }
        });
      };
      let onRecordDuration = function(durationTimeMillis) {
        let seconds = (durationTimeMillis - begin) / 1000;
        thiz.audioRecorderSeconds = 60 - seconds;
        if(thiz.audioRecorderSeconds <= 0) {
          thiz.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
        }
      };
      
      // 停止当前所有正在播放的音频
      try {
        const audioElements = document.getElementsByTagName('audio');
        for (let i = 0; i < audioElements.length; i++) {
            if (!audioElements[i].paused) {
                audioElements[i].pause();
            }
        }
        
        // 移除 Helper 的 prepare，避免干扰
        // IOSAudioHelper.prepareForRecording();
      } catch(e) { console.warn(e); }

      this.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
    },

    onTeackerAskingImageChosen: function (imageUrl, file) {
      let thiz = this;
      thiz.teacherAsking.photoUrl = imageUrl;
      let reader = new FileReader();
      reader.onload = function (event) {
        thiz.teacherAsking.photoBase64Data = event.target.result;
        thiz.teacherAsking.bShowImageChooser = false;
      }
      reader.readAsDataURL(file);
    },

    // 处理时间到了或点击发送的逻辑（从时间到了的逻辑中提取）
    handleTeacherAskingTimeUp: function() {
      let ta = this.teacherAsking;
      let thiz = this;
      ta.bCountingDown = false;
      ta.bHaveAnswer = true;
      
      // 如果手写画板正在显示，自动确认画板内容
      if (ta.bShowHandwritingBoard) {
        console.log('🎨 时间到了，自动确认手写画板内容');
        // 触发画板确认，这会自动调用 onHandwritingBoardConfirm
        this.confirmHandwritingBoard();
        return; // 确认画板后会自动提交答案，所以直接返回
      }
      
      // 先保存手动输入的文字，避免被语音识别结果覆盖
      let manualInputText = ta.currentAction.userAnswerText;
      //开始语音识别
      thiz.startOrStopAudioRecording(null, (wavFile)=>{
        try {
          const url = URL.createObjectURL(wavFile);
          ta.lastUserAnswerIsAudio = true;
          thiz.addToDialogueHistory('user', JSON.stringify({ audioUrl: url, fileName: wavFile.name, size: wavFile.size }), 'audio');
        } catch(e) {void 0}
        thiz.voiceToText(wavFile, ta.currentAction, (text) => {
          let finalText = text;
          if(manualInputText && manualInputText.length>0) {
            finalText += '\n';
            finalText += manualInputText;
          }
          if(finalText && finalText.length > 0) {
            thiz.sendAnswerForTeacherAskingInner(finalText);
          }
          //如果开启了AI抢答
          else if(ta.currentAction.isPree) {
            console.log('AI同学抢答');
            ta.bShowAiAnswer = true; //显示AI抢答
            if(ta.currentAction.aiMateAnswerAudioUrl) {
              ta.aiMateImgUrl = ta.currentAction.aiMateSpeakImgUrl;
              console.log('play aiMateAnswerAudio', ta.currentAction.aiMateAnswerAudio.src);
              ta.currentAction.aiMateAnswerAudio.play().catch(err=>{console.error('play aiMateAnswerAudio-error', err,err.message);});
              ta.currentAction.aiMateAnswerAudio.onended = () => {
                ta.aiMateImgUrl = ta.currentAction.aiMateIdleImgUrl;
                thiz.sendAnswerForTeacherAskingInner(ta.currentAction.aiAnswer);
              };
            } else {
              thiz.sendAnswerForTeacherAskingInner(ta.currentAction.aiAnswer);
            }
          }
          //如果没开启AI抢答，则直接提示正确答案
          else {
            console.log('学生未回答');
            thiz.sendAnswerForTeacherAskingInner('');
          }
        });
      }, null);
    },

    onUserClickSendAnswerForTeacherAsking: function () {
      this.handleTeacherAskingTimeUp();
    },
    onUserClickClearPhotoForTeacherAsking: function() {
      this.showImgUrl = '';
      this.teacherAsking.photoUrl = '';
      this.teacherAsking.photoBase64Data = '';
    },

    // 创建问答对话
    createTeacherAskingDialogue: async function() {
      let ta = this.teacherAsking;
      if (ta.dialogueId) {
        // 如果已经有对话ID，直接返回
        return ta.dialogueId;
      }

      let createReq = {
        draftId: this.queries.lessonId,
        sceneIdx: this.currentSceneId,
        groupIdx: this.currentGroupId,
        actionIdx: ta.currentAction.actionId,
        type: "teacher_ask"
      };

      return new Promise((resolve, reject) => {
        createQaDialogue(this.queries, createReq, this.toLogin,
          (res) => {
            if (res.data.code === 0) {
              ta.dialogueId = res.data.data;
              console.log('创建问答对话成功，dialogueId:', ta.dialogueId);
              resolve(ta.dialogueId);
            } else {
              console.error('创建问答对话失败:', res.data.msg);
              reject(new Error(res.data.msg));
            }
          },
          (err) => {
            console.error('创建问答对话请求失败:', err);
            reject(err);
          }
        );
      });
    },
    
    // 添加内容到对话历史记录
    addToDialogueHistory: function(role, content, type = 'text') {
      const historyItem = {
        role: role, // 'user' 或 'teacher'
        content: content,
        type: type, // 'text', 'audio', 'blackboard', 'image', 'graphic', 'audioDisp'
        timestamp: new Date().toISOString()
      };
      
      this.teacherAsking.dialogueHistory.push(historyItem);
      console.log('添加对话历史:', historyItem);
    },
    
    sendAnswerForTeacherAskingInner: async function (text) {
      let ta = this.teacherAsking;
      if (ta.bHandling)
        return;
      ta.bCountingDown = false;
      ta.bHandling = true;
      ta.bHaveAnswer = true;

      let btn = document.getElementById('idTeacherAskingBtnSend');
      if (btn) {
        btn.setAttribute("class", "ans-btn ans-btn-send-wait-response");
      }

      if (text.length === 0) {
        ta.bShowAnswer = true; //显示点评内容
        ta.answerText = '作答时限已到，您未完成作答，老师将给出答案';
      }

      try {
        // 确保有对话ID
        await this.createTeacherAskingDialogue();

        if (!ta.bShowView) {
          console.log('🚪 创建对话后检测到窗口已关闭，中止提交');
          ta.bHandling = false;
          let btnClosed = document.getElementById('idTeacherAskingBtnSend');
          if (btnClosed) {
            btnClosed.setAttribute("class", "ans-btn ans-btn-send");
          }
          return;
        }

        // 将当前用户回答添加到对话历史
        if (ta.handwritingImage) {
          this.addToDialogueHistory('user', ta.handwritingImage, 'image');
        } else {
          if (!ta.lastUserAnswerIsAudio) {
            this.addToDialogueHistory('user', text, 'text');
          }
        }
        
        if (ta.photoBase64Data && !ta.handwritingImage) {
          this.addToDialogueHistory('user', ta.photoBase64Data, 'image');
        }

        let req = {
          dialogueId: ta.dialogueId,
          examText  : ta.currentAction.examText,  //问题文字
          quesUrl   : ta.currentAction.quesUrl,   //问题附图地址
          examTarget: ta.currentAction.examTarget,//考察目标
          examAns   : ta.currentAction.examAns,   //标准答案
          ansUrl    : ta.currentAction.ansUrl,    //标准答案附图地址
          userAns   : text, //用户提交的答案，或者是AI同学抢答的答案
          userAnsImgBase64WithMime: ta.handwritingImage || ta.photoBase64Data,
          voiceActor: ta.currentAction.voiceActor,
          isVague   : ta.currentAction.isVague, //是否模糊匹配
          errQues   : ta.currentAction.errQues, //错题信息
          workflowId: ta.currentAction.workflowId, //工作流ID
          endCorrectTimes: ta.currentAction.endCorrectTimes, //工作流结束正确次数
          isEndOnCorrect: ta.currentAction.isEndOnCorrect, //是否在正确次数后结束
        };
        
        // 发送答案后立即清理图片数据，避免影响下一轮问答
        ta.handwritingImage = '';
        ta.photoBase64Data = '';
        
        console.log('分析你的答案: ', text);

        if (!ta.bShowView) {
          console.log('🚪 推流开始前检测到窗口已关闭，中止请求');
          ta.bHandling = false;
          let btnGone = document.getElementById('idTeacherAskingBtnSend');
          if (btnGone) {
            btnGone.setAttribute("class", "ans-btn ans-btn-send");
          }
          return;
        }

      let idx = Math.round(Math.random());
      let mp3_url = idx==0 ? require('@/assets/robot_thinking_1.mp3') : require('@/assets/robot_thinking_2.mp3');
      let robot_voice_player_a = this.playSound(mp3_url, () => {
        robot_voice_player_a.play().catch(async function (err) {
          console.error('play robot-voice-a error:', err, err.name, err.message);
        });
      });
      robot_voice_player_a.volume = robot_voice_player_a.volume/2/3/2/2;
      // 不在请求开始时播放动嘴，只播放思考音频
      // robot_voice_player_a.addEventListener('play', () => {
      //   this.showTeacherSpeakingVideo();
      // });
      // robot_voice_player_a.addEventListener('pause', () => {
      //   this.showTeacherIdleVideo();
      // });
      // robot_voice_player_a.addEventListener('ended', () => {
      //   this.showTeacherIdleVideo();
      // });

        let thiz = this;
        ta.bShowThinking = true;
        ta.bShowAnswer = true; // 显示答案区域
        ta.answerText = ''; // 重置答案文本，准备接收新的推流内容
        // 设置推流状态标志，防止在推流过程中切换到待机状态
        console.log('🚀 开始推流，设置 isStreaming = true');
        thiz.isStreaming = true;
        
        // 初始化流控制机制
        thiz.streamAbortController = new AbortController();
        thiz.streamRunningFlag = true;
        
        console.log('commit with streaming');
        let queue = [];
        let bDone = false;
        let bExitDialogue = false; // 添加退出对话标志
        invokeLessonPlayerStreamWebApi(thiz.queries, 'teacher-ask-workflow', req, thiz.toLogin,
            (one)=>{
              // 检查是否需要退出对话
              if(one.exitDialogue === true) {
                console.log('🚪 推流回调中检测到 exitDialogue=true，设置退出标志，等待音频播放完成');
                bExitDialogue = true; // 设置退出标志，不立即关闭
                thiz.teacherAsking.bExitDialogue = true; // 设置全局退出标志，用于隐藏学生输入框
                bDone = true; // 标记推流数据接收完成
                return;
              }
              
              queue.push(one);
              // 处理新的流式响应格式
              if (one.blackboardText) {
                // 黑板文本内容会在后续处理
              } else if (one.imageText) {
                // 图片文本内容会在后续处理
              } else if (one.graphicCode) {
                // 图形代码会在后续处理
              } else if (one.audioDispText) {
                // 音频显示文本会在后续处理
              } else if (one.audioUrl || one.dispText || one.audioText) {
                // 音频URL和显示文本会在后续处理
              }
            },
            (err)=>{
              if(err) {
                ta.answerText = '';//'老师返回的点评内容'+err;
              }
              bDone = true;
            },
            {
              signal: thiz.streamAbortController.signal,
              isRunning: () => !!(thiz.streamRunningFlag && thiz.isStreaming)
            }
        );

        ta.bShowThinking = false;
        ta.bShowAnswer = true; //显示点评内容
        let enable_robot_voice_b = false;
        let queueIdx = 0;
        let robot_voice_player_b = null;
        while ((!bDone || queueIdx < queue.length) && thiz.streamRunningFlag && thiz.isStreaming) {
          // 检查是否需要中断流处理
          if (!thiz.streamRunningFlag || !thiz.isStreaming) {
            console.log('🛑 检测到流中断标志，退出流处理循环');
            bDone = true;
            break;
          }
          
          if(queueIdx >= queue.length) {
            await sleep(500);
            continue;
          }
          if(enable_robot_voice_b) {
            if(!robot_voice_player_b) {
              if(robot_voice_player_a) {
                console.log('need pause robot_voice_player_a');
                robot_voice_player_a.pause();
                thiz.freeStaticAudioPlayer(robot_voice_player_a);
                robot_voice_player_a = null;
                // 推流过程中不切换到待机状态
                // thiz.showTeacherIdleVideo();
              }
              console.log('need play robot_voice_player_b');
              robot_voice_player_b = thiz.playSound(require('@/assets/robot_voice_b.mp3'), ()=>{
                robot_voice_player_b.play().catch(async function (err) {
                  console.error('play robot-voice-b error:', err, err.name, err.message);
                });
              });
              robot_voice_player_b.volume = robot_voice_player_b.volume/3/3/2/2;
              // 推流过程中不切换动嘴状态
              // robot_voice_player_b.addEventListener('play', () => {
              //   thiz.showTeacherSpeakingVideo();
              // });
              // robot_voice_player_b.addEventListener('pause', () => {
              //   thiz.showTeacherIdleVideo();
              // });
              // robot_voice_player_b.addEventListener('ended', () => {
              //   thiz.showTeacherIdleVideo();
              // });
            }
          }
          else {
            if(robot_voice_player_a) {
              console.log('need pause robot_voice_player_a');
              robot_voice_player_a.pause();
              thiz.freeStaticAudioPlayer(robot_voice_player_a);
              robot_voice_player_a = null;
              // 推流过程中不切换到待机状态
              // thiz.showTeacherIdleVideo();
            }
          }

          let data = queue[queueIdx++];
          console.log('GG-item:', data);
          
          // 处理新的流式响应格式
          if(data.blackboardText) {
            ta.displayBoardText += '\n<div>'+data.blackboardText+'</div>';
            await thiz.scrollToBottomEnd('taDisplayBoardText');
            // 将黑板文本添加到对话历史
            thiz.addToDialogueHistory('teacher', data.blackboardText, 'blackboard');
          }
          else if(data.imageText) {
            console.log('imageText:', data.imageText);
            // 将图片文本添加到对话历史
            thiz.addToDialogueHistory('teacher', data.imageText, 'image');
          }
          else if(data.graphicCode) {
            await thiz.injectJSXGraphCode(data.graphicCode, (imgDataUrl) => {
              ta.displayBoardText += '\n![](' + imgDataUrl + ")";
              thiz.scrollToBottomEnd('taDisplayBoardText');
            });
            // 将图形代码添加到对话历史
            thiz.addToDialogueHistory('teacher', data.graphicCode, 'graphic');
          }
          else if(data.audioDispText) { //口播书面语字幕
            ta.bShowAudioText = true;
            if(!ta.displayAudioText) {
              ta.currentAction.userAnswerText = '';
            }
            ta.displayAudioText += '\n<div>'+data.audioDispText+'</div>';
            await thiz.scrollToBottomEnd('taDisplayAudioText');
            // audioDispText是完整句子集合，不添加到聊天记录中
            // thiz.addToDialogueHistory('teacher', data.audioDispText, 'audioDisp');
          }
          else if(data.audioUrl || data.dispText || data.audioText) {//音频相关内容
            // 先处理文字内容：将音频片段的文字内容逐条添加到对话历史（用于聊天界面显示）
            let displayText = data.dispText || data.audioText || '';
            if (displayText && displayText.trim()) {
              console.log('📝 先添加音频片段文字到对话历史:', displayText);
              thiz.addToDialogueHistory('teacher', displayText, 'text');
            }
            
            // 更新答案文本显示
            if (data.dispText) {
              ta.answerText += data.dispText;
            } else if (data.audioText) {
              ta.answerText += data.audioText;
            }
            
            // 然后播放音频
            if (data.audioUrl) {
              await new Promise((resolve) => {
                console.log('📢 文字显示完成后播放音频', data.audioUrl);
                let ap = thiz.playSound(data.audioUrl, () => {
                  // 音频播放结束时不立即切换到待机状态，等待整个推流结束
                  thiz.freeStaticAudioPlayer(ap);
                  resolve();
                });
                // 监听音频实际开始播放事件，第一次播放时开始动嘴
                // 使用一次性监听器避免重复添加
                ap.addEventListener('play', () => {
                  // 只在第一次播放时调用，避免推流过程中重复调用
                  if (!thiz.teacherAsking.bTeacherSpeaking) {
                    console.log('🎵 首次音频播放，开始动嘴');
                    thiz.showTeacherSpeakingVideo();
                  } else {
                    console.log('🎵 音频播放，已在说话状态，跳过');
                  }
                }, { once: true });
              });
            }
          }
        }
        setTimeout(() => {
          ta.bHandling = false;

          if (!ta.bShowView) {
            console.log('🚪 推流收尾：窗口已关闭，跳过多轮对话与倒计时重启');
            if (robot_voice_player_a) {
              robot_voice_player_a.pause();
              thiz.freeStaticAudioPlayer(robot_voice_player_a);
            }
            if (robot_voice_player_b) {
              robot_voice_player_b.pause();
              thiz.freeStaticAudioPlayer(robot_voice_player_b);
            }
            thiz.isStreaming = false;
            thiz.streamRunningFlag = false;
            thiz.streamAbortController = null;
            let btnSkip = document.getElementById('idTeacherAskingBtnSend');
            if (btnSkip) {
              btnSkip.setAttribute("class", "ans-btn ans-btn-send");
            }
            return;
          }
          
          // 检查是否需要退出对话
          if (bExitDialogue) {
            thiz.showTeacherIdleVideo();
            console.log('🚪 检测到exitDialogue标志，所有音频播放完成，立即关闭对话窗口');
            // 立即关闭对话窗口，不再等待2秒
            console.log('🚪 立即调用 handleTeacherAskingClose');
            thiz.handleTeacherAskingClose();
            return; // 直接返回，不执行后续的多轮对话逻辑
          }
          
          // 多轮对话模式：保持窗口打开，不关闭 bShowView
          // ta.bShowView = false; // 注释掉这行，保持窗口打开
          
          console.log('end pause robot_voice_player_a');
          if(robot_voice_player_a) {
            robot_voice_player_a.pause();
            thiz.freeStaticAudioPlayer(robot_voice_player_a);
          }
          console.log('end pause robot_voice_player_b');
          if(robot_voice_player_b) {
            robot_voice_player_b.pause();
            thiz.freeStaticAudioPlayer(robot_voice_player_b);
          }
          // 清除推流状态标志和流控制机制
          console.log('🏁 推流结束，设置 isStreaming = false');
          thiz.isStreaming = false;
          thiz.streamRunningFlag = false;
          thiz.streamAbortController = null;
          // 所有音频播放结束后显示数字人待机状态
          console.log('⏰ 延迟2秒后调用 showTeacherIdleVideo');
          thiz.showTeacherIdleVideo();
          thiz.onUserClickClearPhotoForTeacherAsking();
          
          // 标记最后一条教师消息为完成状态（推流内容已在处理过程中逐条添加）
          if (ta.dialogueHistory && ta.dialogueHistory.length > 0) {
            let lastItem = ta.dialogueHistory[ta.dialogueHistory.length - 1];
            if (lastItem.role === 'teacher') {
              lastItem.isComplete = true;
              console.log('📝 标记最后一条教师消息为完成状态');
            }
          }
          
        // 重置状态以准备下一轮对话
        ta.bShowAnswer = false;
        ta.bShowThinking = false;
        ta.answerText = '';
        ta.lastUserAnswerIsAudio = false;
        // 如果配置了手写画板，下一轮继续显示手写画板进行作答
        if (ta.handwritingBoardConfig && ta.handwritingBoardConfig.enabled) {
          ta.bShowHandwritingBoard = true;
        }
          
          // 在自动录音模式下，清空输入框
          if (ta.bAutoRecording && ta.currentAction) {
            ta.currentAction.userAnswerText = '';
          }
          
          console.log('💬 多轮对话：窗口保持打开，等待用户继续输入');
          
          // 重新启动倒计时逻辑
          // 清除之前的定时器
          if (ta.countDownTimer) {
            console.log('🔥 多轮对话清除之前的定时器');
            clearInterval(ta.countDownTimer);
            ta.countDownTimer = null;
          }
          ta.bCountingDown = true;
          ta.bHaveAnswer = false; // 重置回答状态，允许下一轮超时检查
          console.log('🔥 多轮对话倒计时重启 - qaDelay:', ta.currentAction.qaDelay, 'bCountingDown:', ta.bCountingDown);
          if(ta.bCountingDown && ta.currentAction) {
            let seconds = 0;
            ta.countDownText = thiz.secondsToText(ta.currentAction.qaDelay);
            console.log('🔥 多轮对话初始化countDownText:', ta.countDownText);
            ta.countDownTimer = setInterval(() => {
              seconds++;
              console.log('🔥 多轮对话定时器执行 - seconds:', seconds, 'bCountingDown:', ta.bCountingDown);
              if(ta.bCountingDown && ta.currentAction) {
                let remainingTime = ta.currentAction.qaDelay - seconds;
                console.log('🔥 多轮对话计算remainingTime:', remainingTime, '= qaDelay:', ta.currentAction.qaDelay, '- seconds:', seconds);
                if(remainingTime > 0) {
                  ta.countDownText = thiz.secondsToText(remainingTime);
                  console.log('🔥 多轮对话更新countDownText (>0):', ta.countDownText);
                } else {
                  ta.countDownText = thiz.secondsToText(0);
                  console.log('🔥 多轮对话更新countDownText (<=0):', ta.countDownText);
                }
              }
              //三秒内没有回答，则发起学生状态监控
              if(!ta.bHaveAnswer && seconds == 4 && !thiz.bAudioRecording) {
                thiz.checkStudentStatus((badStatusAudioUrl) => {
                  if(!ta.bHaveAnswer && !thiz.bAudioRecording && badStatusAudioUrl) {
                    thiz.playSound(badStatusAudioUrl);
                  }
                });
              }
              //超过问答限时/秒
              if(!ta.bHaveAnswer && seconds > ta.currentAction.qaDelay) {
                ta.bCountingDown = false;
                console.log('多轮对话倒计时到期');
                thiz.handleTeacherAskingTimeUp();
              }
              if(!ta.bShowView) {
                clearInterval(ta.countDownTimer);
                ta.countDownTimer = null;
                console.log('多轮对话窗口关闭，停止倒计时');
                // promiseResolve现在已经在handleTeacherAskingClose中被调用了，这里不需要重复调用
                console.log('🎯 多轮对话窗口已关闭，promiseResolve已在handleTeacherAskingClose中处理');
              }
            }, 1000);
          }
          
          thiz.startOrStopAudioRecording(null, null, null);
        }, 2000);
      } catch (error) {
        console.error('处理教师提问回答时发生错误:', error);
        ta.bHandling = false;
        ta.bShowAnswer = true;
        ta.answerText = '处理回答时发生错误，请重试';
        
        let btn = document.getElementById('idTeacherAskingBtnSend');
        if (btn) {
          btn.setAttribute("class", "ans-btn ans-btn-send");
        }
      }
    },



    clearOralScoring: function () {
      this.oralScoring = {};
      this.oralScoring.micStat = this.oralScoringConst.MIC_STAT_BEFORE;
      this.oralScoring.audioInputNotice = '点击麦克风开始录音';
      this.oralScoring.bPlaying = true;
    },
    enterOralScoring: function (action) {
      return new Promise(resolve => {
        console.log('enterOralScoring', action);
        let thiz = this;
        let os = thiz.oralScoring;
        os.currentAction = action;

        os.bShowView = true; //打开口语评分窗口
        os.bPlaying = true;

        os.aiAnswerText = '老师我知道答案，让我来回答吧，我的答案是：\r\n'+action.aiAnswer;
        os.aiMateImgUrl = action.aiMateStandImgUrl;

        os.bCountingDown = true;

        let handleOralScoring = function() {
          console.log('play os.currentAction.teacherHuashuAudio END');
          // 清除之前的定时器
          if (os.countDownTimer) {
            console.log('🔥 口语评分清除之前的定时器');
            clearInterval(os.countDownTimer);
            os.countDownTimer = null;
          }
          let seconds = 0;
          console.log('🔥 口语评分倒计时初始化 - qaDelay:', action.qaDelay, 'bCountingDown:', os.bCountingDown);
          os.countDownText = thiz.secondsToText(action.qaDelay);
          console.log('🔥 口语评分初始化countDownText:', os.countDownText);
          os.countDownTimer = setInterval(async () => {
            seconds++;
            console.log('🔥 口语评分定时器执行 - seconds:', seconds, 'bCountingDown:', os.bCountingDown);
            if (os.bCountingDown) {
              let remainingTime = action.qaDelay - seconds;
              console.log('🔥 口语评分计算remainingTime:', remainingTime, '= qaDelay:', action.qaDelay, '- seconds:', seconds);
              if(remainingTime > 0) {
                os.countDownText = thiz.secondsToText(remainingTime);
                console.log('🔥 口语评分更新countDownText (>0):', os.countDownText);
              } else {
                os.countDownText = thiz.secondsToText(0);
                console.log('🔥 口语评分更新countDownText (<=0):', os.countDownText);
              }
            }
            //超过问答限时/秒
            if (os.bPlaying && !os.bHaveAnswer && seconds > action.qaDelay) {
              os.micStat = thiz.oralScoringConst.MIC_STAT_AFTER;
              os.bCountingDown = false;
              console.log('作答时限到');
              //如果开启了AI抢答
              if (action.isPree) {
                console.log('AI同学抢答');
                os.bShowAiAnswer = true; //显示AI抢答
                if (action.aiMateAnswerAudioUrlB) {
                  console.log('AI同学抢答：显示UI');
                  os.bHaveAnswer = true;
                  os.aiMateImgUrl = action.aiMateSpeakImgUrl;
                  if(os.bPlaying) {
                    os.lastPlayer = action.aiMateAnswerAudioA;
                    await thiz.playerPlayAndWaitEnd(action.aiMateAnswerAudioA, 'oralScoringA');
                  }
                  if(os.bPlaying) {
                    os.lastPlayer = action.aiMateAnswerAudioB;
                    await thiz.playerPlayAndWaitEnd(action.aiMateAnswerAudioB, 'oralScoringB');
                  }
                  if(os.bPlaying) {
                    os.aiMateImgUrl = action.aiMateIdleImgUrl;
                    await thiz.sendAnswerForOralScoringInner('ai-answer');
                  }
                } else if(os.bPlaying) {
                  console.log('AI同学抢答：不显示UI');
                  await thiz.sendAnswerForOralScoringInner('ai-answer');
                }
              }
              //如果没开启AI抢答，则直接提示正确答案
              else {
                console.log('学生未录音');
                await thiz.sendAnswerForOralScoringInner('no-record-file');
              }
            }
            if (!os.bShowView) {
              clearInterval(os.countDownTimer);
              os.countDownTimer = null;
              thiz.log("End Teacher Asking");
              resolve();
            }
          }, 1000);
        };

        if(action.teacherHuashuAudio && action.teacherHuashuAudioUrl) {
          console.log('play os.currentAction.teacherHuashuAudio: play...');
          os.lastPlayer = action.teacherHuashuAudio;
          action.teacherHuashuAudio.play().catch(async function (err) {
            console.error('play oral-teacherHuashuAudio error:', err, err.name, err.message);
          });
          action.teacherHuashuAudio.onended = handleOralScoring();
        } else {
          console.log('play os.currentAction.teacherHuashuAudio: skip');
          handleOralScoring();
        }

      });
    },

    onUserClickAudioInputForOralScoring: function () {
      let thiz = this;
      let os = this.oralScoring;
      let osc = this.oralScoringConst;
      os.bCountingDown = false;
      os.bHaveAnswer = true;
      let begin = 0;
      let onRecordStarted = function(beginTimeMillis) {
        os.micStat = osc.MIC_STAT_RUNNING;
        os.audioInputNotice = "点击麦克风结束录音";
        thiz.audioRecorderSeconds = 60;
        begin = beginTimeMillis;
      };
      let onRecordWavFile = function(file) {
        os.micStat = osc.MIC_STAT_AFTER;
        thiz.sendAnswerForOralScoringInner('yes-record-file-v3', file);
      };
      let onRecordDuration = function(durationTimeMillis) {
        let seconds = (durationTimeMillis - begin) / 1000;
        thiz.audioRecorderSeconds = 60 - seconds;
        if(thiz.audioRecorderSeconds <= 0) {
          thiz.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
        }
      };
      this.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
    },

    sendAnswerForOralScoringInner: async function (method, wavFile) {
      let os = this.oralScoring;
      if (os.bHandling) {
        console.log('提交口语评分请求：正在处理上次的提交');
        return;
      }

      os.bCountingDown = false;
      os.bHandling = true;
      os.bHaveAnswer = true;
      console.log('提交口语评分请求：已提交', method, wavFile);

      //看来你对这句话的发音有困难
      if (os.bPlaying && method === 'no-record-file' && os.tooDifficultAudio) {
        os.lastPlayer = os.tooDifficultAudio;
        await this.playerPlayAndWaitEnd(os.tooDifficultAudio, "tooDifficultAudio");
        await this.endOralScoringInner();
        return;
      }

      //
      let voiceFile;
      if (method === 'ai-answer') {
        voiceFile = os.currentAction.aiMateAnswerAudioUrlB;
      } else if (method === 'yes-record-file-v3') {
        voiceFile = wavFile;
      }
      console.log('voiceFile', voiceFile);

      //
      let fm = new FormData();
      fm.append('method', method);
      fm.append('text', os.currentAction.identifyText);
      fm.append('voiceActor', JSON.stringify(os.currentAction.voiceActor));
      if (method === 'ai-answer') {
        fm.append('mp3Url', os.currentAction.aiMateAnswerAudioUrlB);
      } else if (method === 'yes-record-file-v3') {
        fm.append('wavFile', wavFile);
      }

      let thiz = this;
      let onOralScoreFail = async () => {
        if (os.bPlaying && os.currentAction.scoreFailAudio) {
          os.lastPlayer = os.currentAction.scoreFailAudio;
          await thiz.playerPlayAndWaitEnd(os.currentAction.scoreFailAudio, 'os.scoreFailAudio');
        }
      };
      invokeLessonPlayerWebFormApi(this.queries, 'oral-score', fm, this.toLogin,
          async (res) => {
            console.log(res);
            if (res.data.code == 0 && res.data.data) {
              thiz.showOralScoringResultInner(res.data.data);
            } else {
              await onOralScoreFail();
            }
            await thiz.endOralScoringInner();
          },
          async (err) => {
            console.error(err);
            await onOralScoreFail();
            await thiz.endOralScoringInner();
          }
      );
    },

    showOralScoringResultInner: function(data) {
      let totalScore = Number(data.overall.total_score);
      if(data.lan === 'en') {
        totalScore = totalScore/10*100
      }
      console.log('showOralScoringResultInner ', data.lan, totalScore);
      let os = this.oralScoring;
      os.resultData = data;
      os.bShowResult = true;
      if(totalScore <= 0) os.overallStars = 0;
      else if(totalScore <= 33.3333) os.overallStars = 1;
      else if(totalScore <= 66.6666) os.overallStars = 2;
      else os.overallStars = 3;
    },

    endOralScoringInner: async function () {
      let os = this.oralScoring;
      let act = os.currentAction;
      if (os.bPlaying && act.readMoreAudio) {
        os.lastPlayer = act.readMoreAudio;
        await this.playerPlayAndWaitEnd(act.readMoreAudio, 'os.readMoreAudio');
      }
      if (act.identifyTextAudio) {
        if(os.bPlaying)
          await sleep(1000);
        if(os.bPlaying) {
          os.lastPlayer = act.identifyTextAudio;
          await this.playerPlayAndWaitEnd(act.identifyTextAudio, 'os.identifyTextAudio');
        }

        if(os.bPlaying)
          await sleep(1000);
        if(os.bPlaying) {
          os.lastPlayer = act.identifyTextAudio;
          await this.playerPlayAndWaitEnd(act.identifyTextAudio, 'os.identifyTextAudio');
        }
      }
    },

    checkStudentStatus: async function(onStudentBadStatusAudioUrl) {
      // 检查是否启用摄像头监控功能
      if(!this.cameraMonitoring) {
        console.log('摄像头人像监控功能未启用');
        return;
      }
      
      if(this.bCheckboxCamera && this.cameraStream) {
        let view = this.$refs.userCameraView;
        let can = this.$refs.userCameraCanvas;

        const ctx = can.getContext('2d');
        ctx.drawImage(view, 0, 0, can.width, can.height);

        let thiz = this;
        can.toBlob((blob)=>{
          let pngFile = new window.File([blob], "cam_capture.png");
          let fm = new FormData();
          fm.append('pngFile', pngFile);
          invokeLessonPlayerWebFormApi(thiz.queries, 'check-student-status', fm, thiz.toLogin,
              (res)=>{
                console.log(res);
                //1:你去哪儿啦？快回来老师找你呢！
                //2:别睡啦，你的口水都流桌上啦！
                //3:专心上课别开小差！
                //4:上课不要交头接耳，咱们一起认真听讲！
                //5:上课时不能吃东西，饿了稍微坚持一下下课再吃！
                //6:遇到难题了吗？别怕，找到提问按钮老师会帮你解答的！
                if(["1", "2", "3", "4", "5", "6"].includes(res.data.data)) {
                  if(onStudentBadStatusAudioUrl) {
                    onStudentBadStatusAudioUrl(require('@/assets/student_status/'+res.data.data+'.mp3'));
                  } else {
                    thiz.pausePlayingMedias();
                    let ap = thiz.playSound(require('@/assets/student_status/'+res.data.data+'.mp3'), () => {
                      thiz.freeStaticAudioPlayer(ap);
                      thiz.resumePlayingMedias();
                    });
                  }
                }
              },
              (err)=>{
                console.error(err);
              }
          );
        }, "image/png");
      }
    },

    onUserClickExitOralScoring: function() {
      this.oralScoring.bPlaying = false;
      if(this.oralScoring.lastPlayer) {
        this.stopMediaPlayer(this.oralScoring.lastPlayer);
      }
      this.oralScoring.bShowView = false;
    },

    showImage: function (url) {
      this.showImgUrl = url;
    },

    cameraDragStart: function (e) {
      e.preventDefault();
      this.cameraDrag.isDragging = true;
      let ele = this.$refs.userCameraView;
      if (e.type == "touchstart") {
        let _e = e.changedTouches[0];
        this.cameraDrag.diffX = _e.clientX - ele.offsetLeft;
        this.cameraDrag.diffY = _e.clientY - ele.offsetTop;
      } else if (e.type == "mousedown") {
        this.cameraDrag.diffX = e.clientX - ele.offsetLeft;
        this.cameraDrag.diffY = e.clientY - ele.offsetTop;
      }
    },
    cameraDragMove: function (e) {
      let style = this.cameraDrag.style;
      if (!this.cameraDrag.isDragging) return;
      e.preventDefault();
      if (e.type == "touchmove") {
        let _e = e.changedTouches[0];
        style.left = _e.clientX - this.cameraDrag.diffX + "px";
        style.top  = _e.clientY - this.cameraDrag.diffY + "px";
      } else if (e.type == "mousemove") {
        style.left = e.clientX - this.cameraDrag.diffX + "px";
        style.top  = e.clientY - this.cameraDrag.diffY + "px";
      }
    },
    cameraDragEnd: function() {
      this.cameraDrag.isDragging = false;
    },

    teacherAskingDragStart: function (e) {
      if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON') {
        return;
      }
      e.preventDefault();
      let drag = this.teacherAsking.drag;
      drag.isDragging = true;

      let ev = null;
      if (e.type == "touchstart") {
        ev = e.changedTouches[0];
      } else if (e.type == "mousedown") {
        ev = e;
      }
      if(ev) {
        drag.prevX = ev.clientX;
        drag.prevY = ev.clientY;
      }
    },
    teacherAskingDragMove: function (e) {
      if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON') {
        return;
      }
      let drag = this.teacherAsking.drag;
      if (!drag.isDragging) return;
      e.preventDefault();

      let ev = null;
      if (e.type == "touchmove") {
        ev = e.changedTouches[0];
      } else if (e.type == "mousemove") {
        ev = e;
      }
      if(!ev) {
        return;
      }

      let diffX = ev.clientX - drag.prevX;
      let diffY = ev.clientY - drag.prevY;
      drag.prevX = ev.clientX;
      drag.prevY = ev.clientY;

      let aiMate = document.getElementById('idTeacherAskingAiMate');
      if(aiMate) {
        let aiStyle = drag.aiMateStyle;
        aiStyle.left = aiMate.offsetLeft + diffX + "px";
        aiStyle.top  = aiMate.offsetTop  + diffY + "px";
      }

      let userInput = document.getElementById('idTeacherAskingUserInput');
      if(userInput) {
        let inputStyle = drag.userInputStyle;
        inputStyle.left = userInput.offsetLeft + diffX + "px";
        inputStyle.top  = userInput.offsetTop  + diffY + "px";
      }

      let aiAnswer = document.getElementById('idTeacherAskingAiAnswer');
      if(aiAnswer) {
        let aiAnsStyle = drag.aiAnswerStyle;
        aiAnsStyle.left = aiAnswer.offsetLeft + diffX + "px";
        aiAnsStyle.top  = aiAnswer.offsetTop  + diffY + "px";
      }
    },
    teacherAskingDragEnd: function() {
      this.teacherAsking.drag.isDragging = false;
    },



    // 显示liveWindow边框
    showLiveWindowFrame: function() {
      let currentLiveWindow = this.getCurrentSceneLiveWindow();
      if (!currentLiveWindow) {
        return;
      }

      // 检查idSurface元素是否存在
      let surfaceElement = document.getElementById('idSurface');
      if (!surfaceElement) {
        console.warn('idSurface元素不存在，无法显示liveWindow边框');
        return;
      }

      // 创建或显示liveWindow边框元素
      let liveWindowFrame = document.getElementById('liveWindowFrame');
      if (!liveWindowFrame) {
        liveWindowFrame = document.createElement('div');
        liveWindowFrame.id = 'liveWindowFrame';
        liveWindowFrame.style.position = 'absolute';
        liveWindowFrame.style.border = '2px solid #00ff00';
        liveWindowFrame.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';
        liveWindowFrame.style.pointerEvents = 'none';
        // 从 liveWindow.style.zIndex 读取 zIndex，默认为 998
        let lwZIndex = (currentLiveWindow.style && currentLiveWindow.style.zIndex) || 998;
        liveWindowFrame.style.zIndex = lwZIndex.toString();
        surfaceElement.appendChild(liveWindowFrame);
      }

      // 设置liveWindow的位置和尺寸
      let lw = currentLiveWindow;
      let lwLeft = lw.left || lw.x || (lw.style && lw.style.left) || 0;
      let lwTop = lw.top || lw.y || (lw.style && lw.style.top) || 0;
      let lwWidth = lw.width || (lw.style && lw.style.width) || 100;
      let lwHeight = lw.height || (lw.style && lw.style.height) || 100;

      // 转换为百分比坐标
      let leftPercent = (lwLeft / this.lesson.resolution.width) * 100;
      let topPercent = (lwTop / this.lesson.resolution.height) * 100;
      let widthPercent = (lwWidth / this.lesson.resolution.width) * 100;
      let heightPercent = (lwHeight / this.lesson.resolution.height) * 100;

      liveWindowFrame.style.left = leftPercent + '%';
      liveWindowFrame.style.top = topPercent + '%';
      liveWindowFrame.style.width = widthPercent + '%';
      liveWindowFrame.style.height = heightPercent + '%';
      liveWindowFrame.style.display = 'block';
    },

    // 清理liveWindow边框
    clearLiveWindowFrame: function() {
      let liveWindowFrame = document.getElementById('liveWindowFrame');
      if (liveWindowFrame) {
        liveWindowFrame.style.display = 'none';
      }
    },

    // 计算数字人与liveWindow的裁剪区域
    calculateDigitalHumanClipping: function(action) {
      let currentLiveWindow = this.getCurrentSceneLiveWindow();
      if (!currentLiveWindow || !action.style) {
        return null;
      }

      // 获取liveWindow配置
      let lw = currentLiveWindow;
      let lwLeft = lw.left || lw.x || (lw.style && lw.style.left) || 0;
      let lwTop = lw.top || lw.y || (lw.style && lw.style.top) || 0;
      let lwWidth = lw.width || (lw.style && lw.style.width) || 100;
      let lwHeight = lw.height || (lw.style && lw.style.height) || 100;

      // 获取数字人位置和尺寸（基于lesson.resolution的绝对坐标）
      let dhLeft = action.style.left || 0;
      let dhTop = action.style.top || 0;
      let dhWidth = action.style.width || 100;
      let dhHeight = action.style.height || 100;

      // 计算重合区域
      let overlapLeft = Math.max(lwLeft, dhLeft);
      let overlapTop = Math.max(lwTop, dhTop);
      let overlapRight = Math.min(lwLeft + lwWidth, dhLeft + dhWidth);
      let overlapBottom = Math.min(lwTop + lwHeight, dhTop + dhHeight);

      // 检查是否有重合
      if (overlapLeft >= overlapRight || overlapTop >= overlapBottom) {
        return { hasOverlap: false };
      }

      // 计算重合区域的尺寸
      let overlapWidth = overlapRight - overlapLeft;
      let overlapHeight = overlapBottom - overlapTop;

      // 计算在数字人坐标系中的相对位置（用于canvas裁剪）
      let clipX = overlapLeft - dhLeft;
      let clipY = overlapTop - dhTop;

      // 转换为百分比坐标（用于CSS样式）
      let clipLeftPercent = (clipX / dhWidth) * 100;
      let clipTopPercent = (clipY / dhHeight) * 100;
      let clipWidthPercent = (overlapWidth / dhWidth) * 100;
      let clipHeightPercent = (overlapHeight / dhHeight) * 100;

      // 计算在页面上的显示位置（基于重合区域）
      let displayLeftPercent = (overlapLeft / this.lesson.resolution.width) * 100;
      let displayTopPercent = (overlapTop / this.lesson.resolution.height) * 100;
      let displayWidthPercent = (overlapWidth / this.lesson.resolution.width) * 100;
      let displayHeightPercent = (overlapHeight / this.lesson.resolution.height) * 100;

      return {
        hasOverlap: true,
        // 原始数字人区域
        original: {
          left: dhLeft,
          top: dhTop,
          width: dhWidth,
          height: dhHeight
        },
        // 重合区域在数字人中的相对位置（像素）
        clip: {
          x: clipX,
          y: clipY,
          width: overlapWidth,
          height: overlapHeight
        },
        // 重合区域在数字人中的相对位置（百分比）
        clipPercent: {
          left: clipLeftPercent,
          top: clipTopPercent,
          width: clipWidthPercent,
          height: clipHeightPercent
        },
        // 重合区域在页面上的显示位置（百分比）
        display: {
          left: displayLeftPercent,
          top: displayTopPercent,
          width: displayWidthPercent,
          height: displayHeightPercent
        }
      };
    },

    // 特殊href方法调用
    camera: function() {
      console.log('camera方法被调用 - 切换摄像头状态');
      this.bCheckboxCamera = !this.bCheckboxCamera;

      if (this.bCheckboxCamera && !this.bRecord) {
        // 打开摄像头
        const constraints = {
          video: {
            width: { ideal: 320 },
            height: { ideal: 240 }
          }
        };
        navigator.mediaDevices.getUserMedia(constraints)
          .then(stream => {
            this.cameraStream = stream;
            // 检查DOM元素是否存在
            if (this.$refs.userCameraView) {
              this.$refs.userCameraView.srcObject = stream;
              console.log('摄像头已打开');
            } else {
              console.warn('摄像头视频元素不存在，等待DOM更新后重试');
              this.$nextTick(() => {
                if (this.$refs.userCameraView) {
                  this.$refs.userCameraView.srcObject = stream;
                  console.log('摄像头已打开（延迟设置）');
                } else {
                  console.error('摄像头视频元素仍然不存在');
                }
              });
            }
          })
          .catch(error => {
            console.error('摄像头打开错误：', error);
          });
      } else {
        // 关闭摄像头
        if (this.cameraStream) {
          this.cameraStream.getTracks().forEach(track => track.stop());
          this.cameraStream = null;
          // 清理摄像头视频元素
          if (this.$refs.userCameraView) {
            this.$refs.userCameraView.srcObject = null;
          }
          console.log('摄像头已关闭');
        }
      }
    },

    list: function() {
      console.log('list方法被调用 - 显示场景切换目录列表弹窗');
      // 初始化场景列表数据
      this.initSceneList();
      this.bShowListDialog = true;
    },

    option: function() {
      console.log('option方法被调用 - 显示设置弹窗');
      this.bShowOptionDialog = true;
    },

    // 弹窗相关方法
    toggleMicrophone: function() {
      this.bCheckboxMicrophone = !this.bCheckboxMicrophone;
      console.log('录音开关切换为:', this.bCheckboxMicrophone);
    },

    toggleCamera: function() {
      this.bCheckboxCamera = !this.bCheckboxCamera;
      console.log('摄像头开关切换为:', this.bCheckboxCamera);

      // 直接调用camera()方法的逻辑
      if (this.bCheckboxCamera) {
        // 打开摄像头
        const constraints = {
          video: {
            width: { ideal: 320 },
            height: { ideal: 240 }
          }
        };
        navigator.mediaDevices.getUserMedia(constraints)
          .then(stream => {
            this.cameraStream = stream;
            // 检查DOM元素是否存在
            if (this.$refs.userCameraView) {
              this.$refs.userCameraView.srcObject = stream;
              console.log('摄像头已打开');
            } else {
              console.warn('摄像头视频元素不存在，等待DOM更新后重试');
              this.$nextTick(() => {
                if (this.$refs.userCameraView) {
                  this.$refs.userCameraView.srcObject = stream;
                  console.log('摄像头已打开（延迟设置）');
                } else {
                  console.error('摄像头视频元素仍然不存在');
                }
              });
            }
          })
          .catch(error => {
            console.error('摄像头打开错误：', error);
          });
      } else {
        // 关闭摄像头
        if (this.cameraStream) {
          this.cameraStream.getTracks().forEach(track => track.stop());
          this.cameraStream = null;
          // 清理摄像头视频元素
          if (this.$refs.userCameraView) {
            this.$refs.userCameraView.srcObject = null;
          }
          console.log('摄像头已关闭');
        }
      }
    },

    cancelOptionDialog: function() {
      console.log('取消设置弹窗');
      this.bShowOptionDialog = false;
    },

    saveOptionDialog: function() {
      console.log('保存设置弹窗');
      // 这里可以添加保存逻辑，比如保存到localStorage
      localStorage.setItem('lesson.player.bCheckboxMicrophone', this.bCheckboxMicrophone);
      localStorage.setItem('lesson.player.bCheckboxCamera', this.bCheckboxCamera);
      this.bShowOptionDialog = false;
    },

    question: function() {
      console.log('question方法被调用 - 触发qaTriggerImage点击');
      let img = document.getElementById('qaTriggerImage');
      if (img) {
        img.click();
        console.log('已触发qaTriggerImage点击事件');
      } else {
        console.log('未找到qaTriggerImage元素');
      }
    },

    // 初始化场景列表数据
    initSceneList: function() {
      console.log('初始化场景列表');
      this.sceneList = [];
      if (this.lesson && this.lesson.scenes) {
        for (let i = 0; i < this.lesson.scenes.length; i++) {
          let scene = this.lesson.scenes[i];
          this.sceneList.push({
            title: scene.title || scene.name || `场景${i + 1}`,
            index: i
          });
        }
      }
      console.log('场景列表初始化完成:', this.sceneList);
    },

    // 切换到指定场景
    // 彻底清理所有音视频资源
    cleanupAllMediaResources: async function() {
      console.log('开始清理所有音视频资源...');

      // 1. 停止并清理所有正在播放的媒体
      for (let id in this.playingMedias) {
        let media = this.playingMedias[id];
        if (media) {
          media.pause();
          media.currentTime = 0;
          // 如果是视频，清理src
          if (media.tagName === 'VIDEO' || media.tagName === 'AUDIO') {
            media.src = '';
            media.load();
          }
        }
      }
      this.playingMedias = {};

      // 2. 停止并清理背景音频
      if (this.backgroundAudio) {
        this.backgroundAudio.pause();
        this.backgroundAudio.currentTime = 0;
        this.backgroundAudio.src = '';
        this.backgroundAudio.load();
        this.backgroundAudio = null;
      }

      // 3. 停止并清理摄像头流
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(track => {
          track.stop();
          console.log('停止摄像头轨道:', track.kind);
        });
        this.cameraStream = null;

        // 清理摄像头视频元素
        if (this.$refs.userCameraView) {
          this.$refs.userCameraView.srcObject = null;
        }
      }

      // 4. 停止并清理录音器
      if (this.audioRecorder) {
        try {
          this.audioRecorder.stop();
          this.audioRecorder.stopStream(); // 释放麦克风硬件，避免 iOS 保持听筒路由
          this.audioRecorder.end();
          console.log('停止录音器');
        } catch (error) {
          console.error('停止录音器时出错:', error);
        }
        this.audioRecorder = null;
      }

      // 5. 清理录音器定时器
      if (this.audioRecorderTimer) {
        clearInterval(this.audioRecorderTimer);
        this.audioRecorderTimer = null;
      }

      // 6. 重置录音相关状态
      this.audioRecorderSeconds = '';

      // 7. 清理所有静音的媒体元素
      this.mutedMediaElements = {};

      // 8. 停止所有可能的音频上下文
      try {
        if (window.AudioContext || window.webkitAudioContext) {
          // 查找并关闭可能的音频上下文
          if (window.audioContext && window.audioContext.state !== 'closed') {
            await window.audioContext.close();
            console.log('关闭音频上下文');
          }
        }
      } catch (error) {
        console.error('关闭音频上下文时出错:', error);
      }

      // 9. 清理页面中所有的audio和video元素
      const allAudios = document.querySelectorAll('audio');
      const allVideos = document.querySelectorAll('video');

      allAudios.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
        audio.src = '';
        audio.load();
      });

      allVideos.forEach(video => {
        video.pause();
        video.currentTime = 0;
        video.src = '';
        video.load();
      });

      // 10. 清理mediaCache缓存
      this.mediaCache = {};
      console.log('清理mediaCache缓存');

      console.log('所有音视频资源清理完成');

      // 等待一小段时间确保清理完成（减少延迟以提升切换速度）
      await new Promise(resolve => setTimeout(resolve, 20));
    },

    switchToScene: async function(sceneIndex) {
      const startTime = performance.now();
      console.log('切换到场景:', sceneIndex, '开始时间:', startTime);

      if (!this.lesson || !this.lesson.scenes || sceneIndex >= this.lesson.scenes.length) {
        console.error('无效的场景索引:', sceneIndex);
        return;
      }

      // 关闭场景列表弹窗
      this.bShowListDialog = false;

      // 如果当前正在播放，先停止播放
      if (this.bPlayingScript) {
        this.bScriptEnded = true; // 标记脚本结束，停止当前播放循环
        await this.$nextTick(); // 等待当前播放循环结束
      }

      // 彻底清理所有音视频资源
      const cleanupStartTime = performance.now();
      await this.cleanupAllMediaResources();
      const cleanupEndTime = performance.now();
      console.log('资源清理耗时:', (cleanupEndTime - cleanupStartTime).toFixed(2), 'ms');

      // 异步重新预加载媒体资源并重建mediaCache（不阻塞场景切换）
      console.log('开始异步预加载媒体资源...');
      this.preloadMediasOfLocalBlob().then(() => {
        console.log('媒体资源预加载完成');
      }).catch(error => {
        console.error('媒体资源预加载失败:', error);
      });

      // 清理当前场景内容
      this.clearCurrentScene();

      // 清理场景容器中的所有元素，但保留摄像头视频
      let sceneContainer = document.getElementById("sceneContainer");
      if (sceneContainer) {
        // 获取摄像头视频元素和canvas元素的引用
        const cameraVideo = this.$refs.userCameraView;
        const cameraCanvas = this.$refs.userCameraCanvas;
        
        // 获取所有子元素
        const children = Array.from(sceneContainer.children);
        // 删除除摄像头视频和canvas外的所有元素
        children.forEach(child => {
          // 保留摄像头视频元素和相关canvas
          if (child !== cameraVideo && child !== cameraCanvas) {
            sceneContainer.removeChild(child);
          }
        });
      }

      // 重置播放状态
      this.bScriptEnded = false;
      this.bPlayingScript = true;

      // 从指定场景开始播放
      await this.playLessonScriptFromScene(sceneIndex);
      
      const endTime = performance.now();
      console.log('场景切换总耗时:', (endTime - startTime).toFixed(2), 'ms');
    },

    // 从指定场景开始播放课程剧本
    playLessonScriptFromScene: async function(startSceneIndex) {
      let tBeginTimestampMillis = Date.now();
      let sceneIdx = -1;

      // 重新初始化必要的音视频资源
      console.log('重新初始化音视频资源...');

      // 重新打开摄像头（如果需要）
      if(this.bCheckboxCamera && !this.bRecord) {
        const constraints = {
          video: {
            width: { ideal: 320 }, // 理想宽度
            height: { ideal: 240 }  // 理想高度
          }
        };
        try {
          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          this.cameraStream = stream;
          if (this.$refs.userCameraView) {
            this.$refs.userCameraView.srcObject = stream;
            console.log('摄像头重新初始化成功');
          } else {
            console.warn('摄像头视频元素不存在，等待DOM更新后重试');
            await this.$nextTick();
            if (this.$refs.userCameraView) {
              this.$refs.userCameraView.srcObject = stream;
              console.log('摄像头重新初始化成功（延迟设置）');
            } else {
              console.error('摄像头视频元素仍然不存在');
            }
          }
        } catch (error) {
          console.error('摄像头重新打开错误：', error);
        }
      }

      // 重新请求音视频权限
      console.log("重新请求音视频权限");
      this.requestPlayerPermissions();

      // 从指定场景开始遍历
      for (let i = startSceneIndex; i < this.lesson.scenes.length; i++) {
        sceneIdx = i;
        this.currentSceneId = sceneIdx;

        // 检查是否需要停止播放
        if (this.bScriptEnded) {
          console.log('播放被中断，停止在场景:', sceneIdx);
          break;
        }

        this.clearCurrentScene();

        this.currentScene = this.lesson.scenes[sceneIdx];
        this.log('scene-'+sceneIdx, this.currentScene);
        await this.$nextTick();

        if(sceneIdx > 0 && !this.bRecord) {
          this.checkStudentStatus().then(r => {
          });
        }

        if(this.bStepByStep) {
          await this.waitUserClickNextSceneButton();
          if(!this.bEnterNextStep) {
            continue;
          }
        }

        this.userAsking.userQuestionFlag = false;
        if(this.bAutoPlay && !this.bRecord) {
          this.userAsking.userQuestionFlag = true;
        }

        //play action-groups of current scene
        for (let groupIdx in this.currentScene.groups) {
          // 检查是否需要停止播放
          if (this.bScriptEnded) {
            console.log('播放被中断，停止在场景:', sceneIdx, '组:', groupIdx);
            return;
          }

          this.currentGroupId = groupIdx;
          await this.playActionGroup(this.currentScene.groups[groupIdx]);
        }

        //wait scene end
        let bRemove = sceneIdx < this.lesson.scenes.length-1;
        await this.waitSceneEnd(bRemove);

        //用户主动提问
        if(this.userAsking.userQuestionFlag && !this.bRecord) {
          await this.enterUserAskingQuestions();
        }

        //系统主动测试，用户做选择题
        if(this.currentUserAnsweringAction && !this.bRecord) {
          await this.enterUserAnsweringQuestions();
        }

        this.log('scene-'+sceneIdx+' end');
      }

      let elapsedInMillis = Date.now() - tBeginTimestampMillis;
      this.bScriptEnded = true;
      this.log('script end from scene '+startSceneIndex+', notify back-end server');

      //通知后端学习完毕
      let notifyData = {
        progressNumerator  : parseInt(sceneIdx)+1,     //学习进度: 分子
        progressDenominator: this.lesson.scenes.length,//学习进度: 分母
        elapsedInMillis: elapsedInMillis               //学习所花的时长（毫秒）
      };
      this.invokeLessonPlayerWebApi('play-end', notifyData, function(res) {
        console.log('play-end-reply', res);
      });
    }

  }
  
}
</script>
